import { css as I, LitElement as U, html as p, unsafeCSS as _e, svg as Te } from "lit";
import { property as l, customElement as P, query as E, state as V, queryAll as si, queryAssignedNodes as Ui } from "lit/decorators.js";
import { unsafeSVG as Yi } from "lit/directives/unsafe-svg.js";
import { ifDefined as qi } from "lit/directives/if-defined.js";
const Fi = I`
:host {
    display: inline-block;
    height: 1.3em;
    width: 1.3em;
}

svg, img {
    position: relative;
    fill: var(--icon-color, var(--text-color));
    width: 100%;
    height: 100%;
}
`;
var Wi = Object.defineProperty, Bi = Object.getOwnPropertyDescriptor, Qt = (e, t, r, i) => {
  for (var n = i > 1 ? void 0 : i ? Bi(t, r) : t, o = e.length - 1, a; o >= 0; o--)
    (a = e[o]) && (n = (i ? a(t, r, n) : a(n)) || n);
  return i && n && Wi(t, r, n), n;
};
let Z = class extends U {
  constructor() {
    super(...arguments), this.svg = "";
  }
  /**
   * File name of an SVG that will be fetched from the Sever.
   * Overrides the svg property
   */
  set icon(e) {
    var t;
    if (e !== this._iconName)
      if (this._iconName = e, ((t = this._iconName) == null ? void 0 : t.toLocaleUpperCase().endsWith(".PNG")) ?? !1) {
        const r = Z.imageBaseUrl + this._iconName;
        this.imgSrc = r;
      } else {
        let r = Z.iconBaseUrl + this._iconName;
        r.toLocaleUpperCase().endsWith(".SVG") || (r += ".svg"), fetch(r).then((i) => i.text()).then((i) => {
          const n = this.svg;
          this.svg = i, this.requestUpdate("svg", n);
        }).catch((i) => console.error(i));
      }
  }
  get icon() {
    return this._iconName;
  }
  static createIfDefined(e, t = p``) {
    return e ? typeof e == "string" ? p`<druide-icon icon="${e}"></druide-icon>` : p`<druide-icon .svg="${e}"></druide-icon>` : t;
  }
  render() {
    return this.imgSrc ? p`<img src="${this.imgSrc}"/>` : typeof this.svg == "string" ? p`${Yi(this.svg)}` : this.svg;
  }
};
Z.styles = Fi;
Z.iconBaseUrl = "";
Z.imageBaseUrl = "";
Qt([
  l()
], Z.prototype, "icon", 1);
Qt([
  l()
], Z.prototype, "svg", 2);
Qt([
  l()
], Z.prototype, "imgSrc", 2);
Z = Qt([
  P("druide-icon")
], Z);
const Ai = I`:host {
    --text-color: var(--primary-text-color);
    padding-top: 0.5rem;
    padding-bottom: 0.5rem;
}
:host([fullwidth]) {
    display: inline-flex;
}
:host([disabled]) {
    pointer-events: none;
}

.btn {
    flex: auto;
    margin-left: 0.25rem;
    margin-right: 0.25rem;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    color: var(--primary-color);
    background-color: var(--text-color);
    border: none;
    border-radius: 4px;
    padding: 0.5rem 1rem;
    text-transform: uppercase;
    text-decoration: none;
    cursor: pointer;
    transition: box-shadow 150ms cubic-bezier(0.4, 0, 0.2, 1);
    font-size: 0.875rem;
    font-weight: 500;
}

.btn[raised=true] {
    color: var(--text-color);
    background-color: var(--primary-color);
    box-shadow: 0px 3px 1px -2px rgb(0 0 0 / 20%), 0px 2px 2px 0px rgb(0 0 0 / 14%), 0px 1px 5px 0px rgb(0 0 0 / 12%);
}
.btn[disabled=true] {
    color: var(--button-disabled-text-color);
    background-color: var(--button-disabled-background-color);
    cursor: default;
}

.label{
    white-space:pre;
}


.btn:hover,
.btn:focus {
    background-color: var(--primary-color-hover);
    box-shadow: 0px 2px 4px -1px rgba(0, 0, 0, 0.2), 0px 4px 5px 0px rgba(0, 0, 0, 0.14), 0px 1px 10px 0px rgba(0, 0, 0, 0.12);
}

.btn:active {
    background-color: var(--primary-color-hover);
    box-shadow: 0px 2px 4px -1px rgba(0, 0, 0, 0.2), 0px 4px 5px 0px rgba(0, 0, 0, 0.14), 0px 1px 10px 0px rgba(0, 0, 0, 0.12);
}

.btn > druide-icon {
    align-self:center;
    margin-left: 0.25rem;
    margin-right: 0.25rem;
}

`;
var Hi = Object.defineProperty, ji = Object.getOwnPropertyDescriptor, Ge = (e, t, r, i) => {
  for (var n = i > 1 ? void 0 : i ? ji(t, r) : t, o = e.length - 1, a; o >= 0; o--)
    (a = e[o]) && (n = (i ? a(t, r, n) : a(n)) || n);
  return i && n && Hi(t, r, n), n;
};
let xe = class extends U {
  constructor() {
    super(...arguments), this.title = "", this.submit = !1, this.cancel = !1, this.raised = !0, this.disabled = !1;
  }
  render() {
    return p`
            <a class="btn" raised=${this.raised} disabled=${this.disabled} tabindex="1" @click=${this.submitOnClick} @keyup=${this.submitOnEnter}>
            ${Z.createIfDefined(this.icon)}
            <span class="label"><slot>${this.title}</slot></span>
        </a> `;
  }
  submitOnClick() {
    this.submit ? this.dispatchEvent(new CustomEvent("submit", { bubbles: !0, composed: !0 })) : this.cancel && this.dispatchEvent(new CustomEvent("cancel", { bubbles: !0, composed: !0 }));
  }
  submitOnEnter(e) {
    (e.key == "Enter" || e.key == " ") && (this.submit || this.cancel ? this.submitOnClick() : this.dispatchEvent(new CustomEvent("click", { bubbles: !0 })));
  }
};
xe.styles = _e(Ai);
Ge([
  l()
], xe.prototype, "title", 2);
Ge([
  l()
], xe.prototype, "icon", 2);
Ge([
  l({ type: Boolean })
], xe.prototype, "submit", 2);
Ge([
  l({ type: Boolean })
], xe.prototype, "cancel", 2);
Ge([
  l({ type: Boolean })
], xe.prototype, "raised", 2);
Ge([
  l({ type: Boolean })
], xe.prototype, "disabled", 2);
xe = Ge([
  P("druide-button")
], xe);
const Ri = I`
:host {

}

.btn {

    margin-left: 0.25rem;
    margin-right: 0.25rem;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    border: none;
    border-radius: 4px;
    padding: 0.25rem;
    text-transform: uppercase;
    text-decoration: none;
    cursor: pointer;
    transition: 150ms cubic-bezier(0.4, 0, 0.2, 1);
    
    font-size: 0.875rem;
    font-weight: 500;

    background-color: var(--icon-btn-background-color, white);
}
.label{
    white-space:pre;
}


.btn:hover,
.btn:focus {
    --icon-color:var(--primary-text-color);
    background-color: var(--primary-color-hover);
    box-shadow: 0px 2px 4px -1px rgba(0, 0, 0, 0.2), 0px 4px 5px 0px rgba(0, 0, 0, 0.14), 0px 1px 10px 0px rgba(0, 0, 0, 0.12);
}

.btn:active {
    --icon-color:var(--primary-text-color);
    background-color: var(--primary-color-hover);
    box-shadow: 0px 2px 4px -1px rgba(0, 0, 0, 0.2), 0px 4px 5px 0px rgba(0, 0, 0, 0.14), 0px 1px 10px 0px rgba(0, 0, 0, 0.12);
}

.btn > * {
    align-self:center;
    font-size:1.5em;
}
::slotted(svg) {
    display: inline-block;
    height: 1.3em;
    width: 1.3em;
    align-self:center;
    position: relative;
    fill: var(--icon-color, var(--text-color));

}
`;
var zi = Object.defineProperty, Vi = Object.getOwnPropertyDescriptor, St = (e, t, r, i) => {
  for (var n = i > 1 ? void 0 : i ? Vi(t, r) : t, o = e.length - 1, a; o >= 0; o--)
    (a = e[o]) && (n = (i ? a(t, r, n) : a(n)) || n);
  return i && n && zi(t, r, n), n;
};
let je = class extends U {
  constructor() {
    super(...arguments), this.submit = !1, this.cancel = !1;
  }
  render() {
    return p`
            <a class="btn" tabindex="1" href=${qi(this.href)} @click=${this.submitOnClick} @keyup=${this.submitOnEnter}><slot>${Z.createIfDefined(this.icon)}</slot></a> `;
  }
  submitOnClick() {
    this.submit ? this.dispatchEvent(new CustomEvent("submit", { bubbles: !0, composed: !0 })) : this.cancel && this.dispatchEvent(new CustomEvent("cancel", { bubbles: !0, composed: !0 }));
  }
  submitOnEnter(e) {
    (e.key == "Enter" || e.key == " ") && (this.submit || this.cancel ? this.submitOnClick() : this.dispatchEvent(new CustomEvent("click", { bubbles: !0 })));
  }
};
je.styles = _e(Ri);
St([
  l()
], je.prototype, "icon", 2);
St([
  l({ type: Boolean })
], je.prototype, "submit", 2);
St([
  l({ type: Boolean })
], je.prototype, "cancel", 2);
St([
  l({ type: String })
], je.prototype, "href", 2);
je = St([
  P("druide-icon-button")
], je);
const Qi = I`
:host {
    display: block;
    margin: 1rem;
    --image-placement: column;
    --background-color: #fff;
}

.card {
    position: relative;
    height:100%;
    background-color: var(--background-color);
    transition: box-shadow 0.25s;
    border-radius: var(--card-radius, 1.5rem);
    overflow: hidden;
    box-shadow: 0 2px 2px 0 rgba(0, 0, 0, 0.14), 0 3px 1px -2px rgba(0, 0, 0, 0.12), 0 1px 5px 0 rgba(0, 0, 0, 0.2);
    padding: 12px 16px 8px;
}

.content-container {
    display: flex;
    flex-direction: var(--image-placement);
    align-content: center;
    align-items: center;
}

.info-container {
    width: 100%;
}

.header {
    font-size: 1.25em;
    font-weight: 500;

    display: flex;
    justify-content: center;
    align-items: center;
}

.header > * {
    flex-shrink: 1;
}

.header > .title {
    flex-grow: 1;
    line-height: 2em;
}

.content {
    margin: var(--card-content-margin, 0);
}

.footer {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: space-between;
}
.footer .right {
    flex-grow: 1;
    flex-basis: 0;
    display: flex;
    justify-content: flex-end;
}
.footer .left {
    flex-grow: 1;
    flex-basis: 0;
    display: flex;
    justify-content: flex-start;
}
.footer .center {
    align-items: center;
}
`;
var Xi = Object.defineProperty, Gi = Object.getOwnPropertyDescriptor, Xt = (e, t, r, i) => {
  for (var n = i > 1 ? void 0 : i ? Gi(t, r) : t, o = e.length - 1, a; o >= 0; o--)
    (a = e[o]) && (n = (i ? a(t, r, n) : a(n)) || n);
  return i && n && Xi(t, r, n), n;
};
let it = class extends U {
  constructor() {
    super(...arguments), this.title = "", this.label = "", this.icon = "";
  }
  render() {
    return p`
            <div class="card">
                <div class="content-container">
                    <div class="info-container">
                        <slot name="header">
                            <div class="header">
                                ${Z.createIfDefined(this.icon)}
                                <div class="title">${this.title}${this.label}</div>
                                <slot name="header-action"></slot>
                            </div>
                        </slot>
                        <div class="content">
                            <slot></slot>
                        </div>
                    </div>
                    <slot name="image"></slot>
                </div>
                <slot name="footer">
                    <div class="footer">
                        <div class="left">
                            <slot name="footer-left"></slot>
                        </div>
                        <div class="center">
                            <slot name="footer-center"></slot>
                        </div>
                        <div class="right">
                            <slot name="footer-right"></slot>
                        </div>
                    </div>
                </slot>
            </div>
        `;
  }
};
it.styles = Qi;
Xt([
  l()
], it.prototype, "title", 2);
Xt([
  l()
], it.prototype, "label", 2);
Xt([
  l()
], it.prototype, "icon", 2);
it = Xt([
  P("druide-card")
], it);
const Ki = `:host{--mobile-card-width: 760px;--closed-card-height-wide: 200px;--closed-card-height-mobile: 450px}.expandable-card{display:flex;flex-direction:row;max-height:var(--closed-card-height-wide);transition:max-height .25s ease-in-out;overflow:hidden;align-items:flex-start}@media (max-width: 760px){.expandable-card{max-height:var(--closed-card-height-mobile)}}.image-container{width:30%;padding-right:10px}.image-slot{height:var(--closed-card-height-wide);display:flex;justify-content:center;align-items:center}@media (max-width: 760px){.image-container{width:100%;padding-bottom:10px;padding-right:0}.image-slot{width:100%;height:fit-content}}.content-container{width:70%}@media (max-width: 760px){.content-container{width:100%}}.header-container,div[slot=header]{display:flex;justify-content:space-between;align-items:center}druide-icon-button{flex-grow:0;padding:20px;transform:rotate(0);transition-property:transform;transition-duration:.3s}druide-icon-button.active{transform:rotate(180deg);transition-property:transform;transition-duration:.3s}::slotted(*){max-height:inherit;opacity:inherit}@media (max-width: 760px){druide-icon-button{display:none}.expandable-card{flex-direction:column}}
`;
var Zi = Object.defineProperty, Ji = Object.getOwnPropertyDescriptor, Et = (e, t, r, i) => {
  for (var n = i > 1 ? void 0 : i ? Ji(t, r) : t, o = e.length - 1, a; o >= 0; o--)
    (a = e[o]) && (n = (i ? a(t, r, n) : a(n)) || n);
  return i && n && Zi(t, r, n), n;
};
const en = Te`<svg xmlns="http://www.w3.org/2000/svg" height="48" viewBox="0 -960 960 960" width="48"><path d="M480-345 240-585l43-43 197 198 197-197 43 43-240 239Z"/></svg>`;
let Re = class extends U {
  constructor() {
    super(...arguments), this.mobil = screen.width < 760;
  }
  render() {
    return p`
            <druide-card @click=${() => this.toggleIfMobile()}>
                <div class="expandable-card" expandable>
                    <div class="image-container">
                        <div class="image-slot">
                            <slot name="image"></slot>
                        </div>
                        ${this.mobil ? "" : p`<slot name="image-accordian"></slot>`}
                    </div>
                    <div class="content-container">
                        <div class="header-container">
                            <slot name="header"></slot>
                            <druide-icon-button .icon=${en} @click=${() => this.toggleCard()}></druide-icon-button>
                        </div>
                        <slot></slot>
                        ${this.mobil ? p`<slot name="image-accordian"></slot>` : ""}
                        <slot name="accordian"></slot>
                    </div>
                </div>
            </druide-card>
        `;
  }
  toggleIfMobile() {
    this.mobil && this.toggleCard();
  }
  toggleCard() {
    this.trigger.classList.toggle("active"), this.shadowRoot.querySelectorAll("[expandable]").forEach((e) => {
      const t = e.style.getPropertyValue("--closed-card-height");
      e.style.maxHeight != t ? e.style.maxHeight = t : e.style.maxHeight = e.scrollHeight + "px";
    });
  }
};
Re.styles = [_e(Ki)];
Et([
  l()
], Re.prototype, "mobil", 2);
Et([
  E("druide-icon-button")
], Re.prototype, "trigger", 2);
Et([
  E("slot[name=image-accordian]")
], Re.prototype, "imageAccordian", 2);
Et([
  E("#image-accordian-mobil")
], Re.prototype, "imageAccordianMobil", 2);
Re = Et([
  P("druide-card-expandable")
], Re);
function vt() {
  return (e, t) => {
    Object.defineProperty(e, "focus", {
      value: function() {
        this[t] && this[t].focus();
      }
    }), Object.defineProperty(e, "blur", {
      value: function() {
        this[t] && this[t].blur();
      }
    });
  };
}
const tn = I`
:host {
    display: inline-block;
}

.input-container {
    position: relative;
}

.checkbox-label {
    display: flex;
    align-items: center;
    cursor: pointer;
}

.checkbox-label:hover {
    color: var(--primary-color-hover);
}

.checkbox-label:hover .checkmark {
    border-color:var(--primary-color-hover);
}

.input-container[disabled] {
    color: var(--disabled);
    pointer-events: none;
}

.checkbox-container {
    width: 18px;
    height: 18px;
    padding: 7px;
    margin: 4px;
    position: relative;
    flex: 0 0 auto;
}

.checkbox-container .checkmark {
    display: inline-grid;
    position: absolute;
    width: 14px;
    height: 14px;
    top: 7px;
    left: 7px;
    border-radius: 2px;
    border: 2px solid var(--checkbox-border-color, rgba(0,0,0,0.5));
    color: var(--text-color);
}
.checkbox-container .checkmark svg {
    color: var(--primary-color);
    transition: transform 0.1s ease-in 25ms;
    transform: scale(0);
    transform-origin: bottom left;
}

.checkbox-container input {
    position: absolute;
    font-size: inherit;
    top: -4px;
    left: -4px;
    height: 40px;
    width: 40px;
    margin: 0px;
    opacity: 0;
    outline: none;
    cursor: pointer;
}
.checkbox-container input:focus + .checkmark {
    border-color: var(--primary-color);
}

.checkbox-container input:checked + .checkmark svg {
    transform: scale(1);
}

.checkbox-container input:disabled + .checkmark {
    background-color: var(--input-disabled-color);
}

.error > .checkbox-label input + .checkmark > svg {
    color: var(--error-border-color);
}
.error > .checkbox-label input + .checkmark {
    border-color: var(--error-border-color);
    -webkit-appearance: none; /* This ensures that ios safari will show the box-shadow */
}

.required > .checkbox-label > .label::after {
    content: "*";
}

.label-container{
    font-size: 0.875rem;
    display:block;
}

.error-label {
    color:var(--error-border-color);
    font-size: 0.75rem;
    font-style: italic;
}
`;
var rn = Object.defineProperty, nn = Object.getOwnPropertyDescriptor, Ke = (e, t, r, i) => {
  for (var n = i > 1 ? void 0 : i ? nn(t, r) : t, o = e.length - 1, a; o >= 0; o--)
    (a = e[o]) && (n = (i ? a(t, r, n) : a(n)) || n);
  return i && n && rn(t, r, n), n;
};
let Oe = class extends U {
  constructor() {
    super(...arguments), this.label = "", this.required = !1, this.value = !1, this.disabled = !1;
  }
  render() {
    return p`
            <div class="input-container ${this.error ? "error" : ""} ${this.required ? "required" : ""}" ?disabled=${this.disabled}>
                <label class="checkbox-label" for="checkbox">
                    <span class="checkbox-container">
                        <input type="checkbox" id="checkbox" .checked=${this.value} ?disabled=${this.disabled} @change=${this.onChange}>
                        <span class="checkmark">
                            <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' aria-hidden="true" focusable="false">
                                <path fill='none' stroke='currentColor' stroke-width='3' d='M1.73 12.91l6.37 6.37L22.79 4.59' />
                            </svg>
                        </span>
                    </span>
                    <div class="label-container">
                        <div class="label">${this.label}</div>
                        <div class="error-label">${this.error}</div>
                    </div>
                </label>
            </div>
        `;
  }
  onChange() {
    this.value = this.input.checked, this.dispatchEvent(new CustomEvent("change", { detail: { value: this.input.checked } }));
  }
};
Oe.styles = [tn, I``];
Ke([
  l({ type: String })
], Oe.prototype, "label", 2);
Ke([
  l({ type: Boolean })
], Oe.prototype, "required", 2);
Ke([
  l({ type: String })
], Oe.prototype, "error", 2);
Ke([
  l({ type: Boolean })
], Oe.prototype, "value", 2);
Ke([
  l({ type: Boolean })
], Oe.prototype, "disabled", 2);
Ke([
  vt(),
  E("#checkbox")
], Oe.prototype, "input", 2);
Oe = Ke([
  P("druide-checkbox")
], Oe);
function T(e) {
  if (e === null || e === !0 || e === !1)
    return NaN;
  var t = Number(e);
  return isNaN(t) ? t : t < 0 ? Math.ceil(t) : Math.floor(t);
}
function f(e, t) {
  if (t.length < e)
    throw new TypeError(e + " argument" + (e > 1 ? "s" : "") + " required, but only " + t.length + " present");
}
function b(e) {
  f(1, arguments);
  var t = Object.prototype.toString.call(e);
  return e instanceof Date || typeof e == "object" && t === "[object Date]" ? new Date(e.getTime()) : typeof e == "number" || t === "[object Number]" ? new Date(e) : ((typeof e == "string" || t === "[object String]") && typeof console < "u" && (console.warn("Starting with v2.0.0-beta.1 date-fns doesn't accept strings as date arguments. Please use `parseISO` to parse strings. See: https://git.io/fjule"), console.warn(new Error().stack)), /* @__PURE__ */ new Date(NaN));
}
function on(e, t) {
  f(2, arguments);
  var r = b(e), i = T(t);
  return isNaN(i) ? /* @__PURE__ */ new Date(NaN) : (i && r.setDate(r.getDate() + i), r);
}
function xr(e, t) {
  f(2, arguments);
  var r = b(e), i = T(t);
  if (isNaN(i))
    return /* @__PURE__ */ new Date(NaN);
  if (!i)
    return r;
  var n = r.getDate(), o = new Date(r.getTime());
  o.setMonth(r.getMonth() + i + 1, 0);
  var a = o.getDate();
  return n >= a ? o : (r.setFullYear(o.getFullYear(), o.getMonth(), n), r);
}
function an(e, t) {
  f(2, arguments);
  var r = b(e).getTime(), i = T(t);
  return new Date(r + i);
}
function rt(e, t) {
  f(1, arguments);
  var r = t || {}, i = r.locale, n = i && i.options && i.options.weekStartsOn, o = n == null ? 0 : T(n), a = r.weekStartsOn == null ? o : T(r.weekStartsOn);
  if (!(a >= 0 && a <= 6))
    throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
  var s = b(e), c = s.getDay(), u = (c < a ? 7 : 0) + c - a;
  return s.setDate(s.getDate() - u), s.setHours(0, 0, 0, 0), s;
}
function jt(e) {
  return f(1, arguments), rt(e, {
    weekStartsOn: 1
  });
}
function sn(e) {
  f(1, arguments);
  var t = b(e), r = t.getFullYear(), i = /* @__PURE__ */ new Date(0);
  i.setFullYear(r + 1, 0, 4), i.setHours(0, 0, 0, 0);
  var n = jt(i), o = /* @__PURE__ */ new Date(0);
  o.setFullYear(r, 0, 4), o.setHours(0, 0, 0, 0);
  var a = jt(o);
  return t.getTime() >= n.getTime() ? r + 1 : t.getTime() >= a.getTime() ? r : r - 1;
}
function ln(e) {
  f(1, arguments);
  var t = sn(e), r = /* @__PURE__ */ new Date(0);
  r.setFullYear(t, 0, 4), r.setHours(0, 0, 0, 0);
  var i = jt(r);
  return i;
}
function li(e) {
  var t = new Date(Date.UTC(e.getFullYear(), e.getMonth(), e.getDate(), e.getHours(), e.getMinutes(), e.getSeconds(), e.getMilliseconds()));
  return t.setUTCFullYear(e.getFullYear()), e.getTime() - t.getTime();
}
function Br(e) {
  f(1, arguments);
  var t = b(e);
  return t.setHours(0, 0, 0, 0), t;
}
function cn(e, t) {
  f(2, arguments);
  var r = T(t), i = r * 7;
  return on(e, i);
}
function $e(e, t) {
  f(2, arguments);
  var r = T(t);
  return xr(e, r * 12);
}
function un(e) {
  return f(1, arguments), e instanceof Date || typeof e == "object" && Object.prototype.toString.call(e) === "[object Date]";
}
function dn(e) {
  if (f(1, arguments), !un(e) && typeof e != "number")
    return !1;
  var t = b(e);
  return !isNaN(Number(t));
}
function Ar(e, t) {
  f(2, arguments);
  var r = Br(e), i = Br(t);
  return r.getTime() === i.getTime();
}
function Hr(e) {
  f(1, arguments);
  var t = b(e), r = t.getMonth();
  return t.setFullYear(t.getFullYear(), r + 1, 0), t.setHours(23, 59, 59, 999), t;
}
function pn(e, t) {
  f(1, arguments);
  var r = e || {}, i = b(r.start), n = b(r.end), o = n.getTime();
  if (!(i.getTime() <= o))
    throw new RangeError("Invalid interval");
  var a = [], s = i;
  s.setHours(0, 0, 0, 0);
  var c = t && "step" in t ? Number(t.step) : 1;
  if (c < 1 || isNaN(c))
    throw new RangeError("`options.step` must be a number greater than 1");
  for (; s.getTime() <= o; )
    a.push(b(s)), s.setDate(s.getDate() + c), s.setHours(0, 0, 0, 0);
  return a;
}
function hn(e, t) {
  f(1, arguments);
  var r = e || {}, i = b(r.start), n = b(r.end), o = n.getTime();
  if (!(i.getTime() <= o))
    throw new RangeError("Invalid interval");
  var a = rt(i, t), s = rt(n, t);
  a.setHours(15), s.setHours(15), o = s.getTime();
  for (var c = [], u = a; u.getTime() <= o; )
    u.setHours(0), c.push(b(u)), u = cn(u, 1), u.setHours(15);
  return c;
}
function jr(e) {
  f(1, arguments);
  var t = b(e);
  return t.setDate(1), t.setHours(0, 0, 0, 0), t;
}
function fn(e) {
  f(1, arguments);
  var t = b(e), r = /* @__PURE__ */ new Date(0);
  return r.setFullYear(t.getFullYear(), 0, 1), r.setHours(0, 0, 0, 0), r;
}
function vn(e) {
  f(1, arguments);
  var t = b(e), r = t.getFullYear();
  return t.setFullYear(r + 1, 0, 0), t.setHours(23, 59, 59, 999), t;
}
function gn(e) {
  f(1, arguments);
  var t = e || {}, r = b(t.start), i = b(t.end), n = i.getTime();
  if (!(r.getTime() <= n))
    throw new RangeError("Invalid interval");
  var o = [], a = r;
  for (a.setHours(0, 0, 0, 0), a.setMonth(0, 1); a.getTime() <= n; )
    o.push(b(a)), a.setFullYear(a.getFullYear() + 1);
  return o;
}
function ur(e, t) {
  f(1, arguments);
  var r = t || {}, i = r.locale, n = i && i.options && i.options.weekStartsOn, o = n == null ? 0 : T(n), a = r.weekStartsOn == null ? o : T(r.weekStartsOn);
  if (!(a >= 0 && a <= 6))
    throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
  var s = b(e), c = s.getDay(), u = (c < a ? -7 : 0) + 6 - (c - a);
  return s.setDate(s.getDate() + u), s.setHours(23, 59, 59, 999), s;
}
var mn = {
  lessThanXSeconds: {
    one: "less than a second",
    other: "less than {{count}} seconds"
  },
  xSeconds: {
    one: "1 second",
    other: "{{count}} seconds"
  },
  halfAMinute: "half a minute",
  lessThanXMinutes: {
    one: "less than a minute",
    other: "less than {{count}} minutes"
  },
  xMinutes: {
    one: "1 minute",
    other: "{{count}} minutes"
  },
  aboutXHours: {
    one: "about 1 hour",
    other: "about {{count}} hours"
  },
  xHours: {
    one: "1 hour",
    other: "{{count}} hours"
  },
  xDays: {
    one: "1 day",
    other: "{{count}} days"
  },
  aboutXWeeks: {
    one: "about 1 week",
    other: "about {{count}} weeks"
  },
  xWeeks: {
    one: "1 week",
    other: "{{count}} weeks"
  },
  aboutXMonths: {
    one: "about 1 month",
    other: "about {{count}} months"
  },
  xMonths: {
    one: "1 month",
    other: "{{count}} months"
  },
  aboutXYears: {
    one: "about 1 year",
    other: "about {{count}} years"
  },
  xYears: {
    one: "1 year",
    other: "{{count}} years"
  },
  overXYears: {
    one: "over 1 year",
    other: "over {{count}} years"
  },
  almostXYears: {
    one: "almost 1 year",
    other: "almost {{count}} years"
  }
}, bn = function(e, t, r) {
  var i, n = mn[e];
  return typeof n == "string" ? i = n : t === 1 ? i = n.one : i = n.other.replace("{{count}}", t.toString()), r != null && r.addSuffix ? r.comparison && r.comparison > 0 ? "in " + i : i + " ago" : i;
};
const wn = bn;
function dr(e) {
  return function() {
    var t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, r = t.width ? String(t.width) : e.defaultWidth, i = e.formats[r] || e.formats[e.defaultWidth];
    return i;
  };
}
var yn = {
  full: "EEEE, MMMM do, y",
  long: "MMMM do, y",
  medium: "MMM d, y",
  short: "MM/dd/yyyy"
}, xn = {
  full: "h:mm:ss a zzzz",
  long: "h:mm:ss a z",
  medium: "h:mm:ss a",
  short: "h:mm a"
}, On = {
  full: "{{date}} 'at' {{time}}",
  long: "{{date}} 'at' {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}"
}, Dn = {
  date: dr({
    formats: yn,
    defaultWidth: "full"
  }),
  time: dr({
    formats: xn,
    defaultWidth: "full"
  }),
  dateTime: dr({
    formats: On,
    defaultWidth: "full"
  })
};
const Cn = Dn;
var _n = {
  lastWeek: "'last' eeee 'at' p",
  yesterday: "'yesterday at' p",
  today: "'today at' p",
  tomorrow: "'tomorrow at' p",
  nextWeek: "eeee 'at' p",
  other: "P"
}, Tn = function(e, t, r, i) {
  return _n[e];
};
const Pn = Tn;
function yt(e) {
  return function(t, r) {
    var i = r || {}, n = i.context ? String(i.context) : "standalone", o;
    if (n === "formatting" && e.formattingValues) {
      var a = e.defaultFormattingWidth || e.defaultWidth, s = i.width ? String(i.width) : a;
      o = e.formattingValues[s] || e.formattingValues[a];
    } else {
      var c = e.defaultWidth, u = i.width ? String(i.width) : e.defaultWidth;
      o = e.values[u] || e.values[c];
    }
    var d = e.argumentCallback ? e.argumentCallback(t) : t;
    return o[d];
  };
}
var kn = {
  narrow: ["B", "A"],
  abbreviated: ["BC", "AD"],
  wide: ["Before Christ", "Anno Domini"]
}, Sn = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["Q1", "Q2", "Q3", "Q4"],
  wide: ["1st quarter", "2nd quarter", "3rd quarter", "4th quarter"]
}, En = {
  narrow: ["J", "F", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"],
  abbreviated: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"],
  wide: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"]
}, $n = {
  narrow: ["S", "M", "T", "W", "T", "F", "S"],
  short: ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"],
  abbreviated: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
  wide: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"]
}, Mn = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mi",
    noon: "n",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  }
}, In = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mi",
    noon: "n",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "midnight",
    noon: "noon",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnight",
    noon: "noon",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  }
}, Ln = function(e, t) {
  var r = Number(e), i = r % 100;
  if (i > 20 || i < 10)
    switch (i % 10) {
      case 1:
        return r + "st";
      case 2:
        return r + "nd";
      case 3:
        return r + "rd";
    }
  return r + "th";
}, Nn = {
  ordinalNumber: Ln,
  era: yt({
    values: kn,
    defaultWidth: "wide"
  }),
  quarter: yt({
    values: Sn,
    defaultWidth: "wide",
    argumentCallback: function(e) {
      return e - 1;
    }
  }),
  month: yt({
    values: En,
    defaultWidth: "wide"
  }),
  day: yt({
    values: $n,
    defaultWidth: "wide"
  }),
  dayPeriod: yt({
    values: Mn,
    defaultWidth: "wide",
    formattingValues: In,
    defaultFormattingWidth: "wide"
  })
};
const Un = Nn;
function xt(e) {
  return function(t) {
    var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, i = r.width, n = i && e.matchPatterns[i] || e.matchPatterns[e.defaultMatchWidth], o = t.match(n);
    if (!o)
      return null;
    var a = o[0], s = i && e.parsePatterns[i] || e.parsePatterns[e.defaultParseWidth], c = Array.isArray(s) ? qn(s, function(v) {
      return v.test(a);
    }) : Yn(s, function(v) {
      return v.test(a);
    }), u;
    u = e.valueCallback ? e.valueCallback(c) : c, u = r.valueCallback ? r.valueCallback(u) : u;
    var d = t.slice(a.length);
    return {
      value: u,
      rest: d
    };
  };
}
function Yn(e, t) {
  for (var r in e)
    if (e.hasOwnProperty(r) && t(e[r]))
      return r;
}
function qn(e, t) {
  for (var r = 0; r < e.length; r++)
    if (t(e[r]))
      return r;
}
function Fn(e) {
  return function(t) {
    var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, i = t.match(e.matchPattern);
    if (!i)
      return null;
    var n = i[0], o = t.match(e.parsePattern);
    if (!o)
      return null;
    var a = e.valueCallback ? e.valueCallback(o[0]) : o[0];
    a = r.valueCallback ? r.valueCallback(a) : a;
    var s = t.slice(n.length);
    return {
      value: a,
      rest: s
    };
  };
}
var Wn = /^(\d+)(th|st|nd|rd)?/i, Bn = /\d+/i, An = {
  narrow: /^(b|a)/i,
  abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
  wide: /^(before christ|before common era|anno domini|common era)/i
}, Hn = {
  any: [/^b/i, /^(a|c)/i]
}, jn = {
  narrow: /^[1234]/i,
  abbreviated: /^q[1234]/i,
  wide: /^[1234](th|st|nd|rd)? quarter/i
}, Rn = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, zn = {
  narrow: /^[jfmasond]/i,
  abbreviated: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
  wide: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i
}, Vn = {
  narrow: [/^j/i, /^f/i, /^m/i, /^a/i, /^m/i, /^j/i, /^j/i, /^a/i, /^s/i, /^o/i, /^n/i, /^d/i],
  any: [/^ja/i, /^f/i, /^mar/i, /^ap/i, /^may/i, /^jun/i, /^jul/i, /^au/i, /^s/i, /^o/i, /^n/i, /^d/i]
}, Qn = {
  narrow: /^[smtwf]/i,
  short: /^(su|mo|tu|we|th|fr|sa)/i,
  abbreviated: /^(sun|mon|tue|wed|thu|fri|sat)/i,
  wide: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i
}, Xn = {
  narrow: [/^s/i, /^m/i, /^t/i, /^w/i, /^t/i, /^f/i, /^s/i],
  any: [/^su/i, /^m/i, /^tu/i, /^w/i, /^th/i, /^f/i, /^sa/i]
}, Gn = {
  narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
  any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
}, Kn = {
  any: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /^mi/i,
    noon: /^no/i,
    morning: /morning/i,
    afternoon: /afternoon/i,
    evening: /evening/i,
    night: /night/i
  }
}, Zn = {
  ordinalNumber: Fn({
    matchPattern: Wn,
    parsePattern: Bn,
    valueCallback: function(e) {
      return parseInt(e, 10);
    }
  }),
  era: xt({
    matchPatterns: An,
    defaultMatchWidth: "wide",
    parsePatterns: Hn,
    defaultParseWidth: "any"
  }),
  quarter: xt({
    matchPatterns: jn,
    defaultMatchWidth: "wide",
    parsePatterns: Rn,
    defaultParseWidth: "any",
    valueCallback: function(e) {
      return e + 1;
    }
  }),
  month: xt({
    matchPatterns: zn,
    defaultMatchWidth: "wide",
    parsePatterns: Vn,
    defaultParseWidth: "any"
  }),
  day: xt({
    matchPatterns: Qn,
    defaultMatchWidth: "wide",
    parsePatterns: Xn,
    defaultParseWidth: "any"
  }),
  dayPeriod: xt({
    matchPatterns: Gn,
    defaultMatchWidth: "any",
    parsePatterns: Kn,
    defaultParseWidth: "any"
  })
};
const Jn = Zn;
var eo = {
  code: "en-US",
  formatDistance: wn,
  formatLong: Cn,
  formatRelative: Pn,
  localize: Un,
  match: Jn,
  options: {
    weekStartsOn: 0,
    firstWeekContainsDate: 1
  }
};
const ci = eo;
function ui(e, t) {
  f(2, arguments);
  var r = T(t);
  return an(e, -r);
}
function M(e, t) {
  for (var r = e < 0 ? "-" : "", i = Math.abs(e).toString(); i.length < t; )
    i = "0" + i;
  return r + i;
}
var to = {
  // Year
  y: function(e, t) {
    var r = e.getUTCFullYear(), i = r > 0 ? r : 1 - r;
    return M(t === "yy" ? i % 100 : i, t.length);
  },
  // Month
  M: function(e, t) {
    var r = e.getUTCMonth();
    return t === "M" ? String(r + 1) : M(r + 1, 2);
  },
  // Day of the month
  d: function(e, t) {
    return M(e.getUTCDate(), t.length);
  },
  // AM or PM
  a: function(e, t) {
    var r = e.getUTCHours() / 12 >= 1 ? "pm" : "am";
    switch (t) {
      case "a":
      case "aa":
        return r.toUpperCase();
      case "aaa":
        return r;
      case "aaaaa":
        return r[0];
      case "aaaa":
      default:
        return r === "am" ? "a.m." : "p.m.";
    }
  },
  // Hour [1-12]
  h: function(e, t) {
    return M(e.getUTCHours() % 12 || 12, t.length);
  },
  // Hour [0-23]
  H: function(e, t) {
    return M(e.getUTCHours(), t.length);
  },
  // Minute
  m: function(e, t) {
    return M(e.getUTCMinutes(), t.length);
  },
  // Second
  s: function(e, t) {
    return M(e.getUTCSeconds(), t.length);
  },
  // Fraction of second
  S: function(e, t) {
    var r = t.length, i = e.getUTCMilliseconds(), n = Math.floor(i * Math.pow(10, r - 3));
    return M(n, t.length);
  }
};
const Se = to;
var ro = 864e5;
function io(e) {
  f(1, arguments);
  var t = b(e), r = t.getTime();
  t.setUTCMonth(0, 1), t.setUTCHours(0, 0, 0, 0);
  var i = t.getTime(), n = r - i;
  return Math.floor(n / ro) + 1;
}
function nt(e) {
  f(1, arguments);
  var t = 1, r = b(e), i = r.getUTCDay(), n = (i < t ? 7 : 0) + i - t;
  return r.setUTCDate(r.getUTCDate() - n), r.setUTCHours(0, 0, 0, 0), r;
}
function di(e) {
  f(1, arguments);
  var t = b(e), r = t.getUTCFullYear(), i = /* @__PURE__ */ new Date(0);
  i.setUTCFullYear(r + 1, 0, 4), i.setUTCHours(0, 0, 0, 0);
  var n = nt(i), o = /* @__PURE__ */ new Date(0);
  o.setUTCFullYear(r, 0, 4), o.setUTCHours(0, 0, 0, 0);
  var a = nt(o);
  return t.getTime() >= n.getTime() ? r + 1 : t.getTime() >= a.getTime() ? r : r - 1;
}
function no(e) {
  f(1, arguments);
  var t = di(e), r = /* @__PURE__ */ new Date(0);
  r.setUTCFullYear(t, 0, 4), r.setUTCHours(0, 0, 0, 0);
  var i = nt(r);
  return i;
}
var oo = 6048e5;
function pi(e) {
  f(1, arguments);
  var t = b(e), r = nt(t).getTime() - no(t).getTime();
  return Math.round(r / oo) + 1;
}
function Ae(e, t) {
  f(1, arguments);
  var r = t || {}, i = r.locale, n = i && i.options && i.options.weekStartsOn, o = n == null ? 0 : T(n), a = r.weekStartsOn == null ? o : T(r.weekStartsOn);
  if (!(a >= 0 && a <= 6))
    throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
  var s = b(e), c = s.getUTCDay(), u = (c < a ? 7 : 0) + c - a;
  return s.setUTCDate(s.getUTCDate() - u), s.setUTCHours(0, 0, 0, 0), s;
}
function Or(e, t) {
  f(1, arguments);
  var r = b(e, t), i = r.getUTCFullYear(), n = t || {}, o = n.locale, a = o && o.options && o.options.firstWeekContainsDate, s = a == null ? 1 : T(a), c = n.firstWeekContainsDate == null ? s : T(n.firstWeekContainsDate);
  if (!(c >= 1 && c <= 7))
    throw new RangeError("firstWeekContainsDate must be between 1 and 7 inclusively");
  var u = /* @__PURE__ */ new Date(0);
  u.setUTCFullYear(i + 1, 0, c), u.setUTCHours(0, 0, 0, 0);
  var d = Ae(u, t), v = /* @__PURE__ */ new Date(0);
  v.setUTCFullYear(i, 0, c), v.setUTCHours(0, 0, 0, 0);
  var D = Ae(v, t);
  return r.getTime() >= d.getTime() ? i + 1 : r.getTime() >= D.getTime() ? i : i - 1;
}
function ao(e, t) {
  f(1, arguments);
  var r = t || {}, i = r.locale, n = i && i.options && i.options.firstWeekContainsDate, o = n == null ? 1 : T(n), a = r.firstWeekContainsDate == null ? o : T(r.firstWeekContainsDate), s = Or(e, t), c = /* @__PURE__ */ new Date(0);
  c.setUTCFullYear(s, 0, a), c.setUTCHours(0, 0, 0, 0);
  var u = Ae(c, t);
  return u;
}
var so = 6048e5;
function hi(e, t) {
  f(1, arguments);
  var r = b(e), i = Ae(r, t).getTime() - ao(r, t).getTime();
  return Math.round(i / so) + 1;
}
var tt = {
  am: "am",
  pm: "pm",
  midnight: "midnight",
  noon: "noon",
  morning: "morning",
  afternoon: "afternoon",
  evening: "evening",
  night: "night"
}, lo = {
  // Era
  G: function(e, t, r) {
    var i = e.getUTCFullYear() > 0 ? 1 : 0;
    switch (t) {
      case "G":
      case "GG":
      case "GGG":
        return r.era(i, {
          width: "abbreviated"
        });
      case "GGGGG":
        return r.era(i, {
          width: "narrow"
        });
      case "GGGG":
      default:
        return r.era(i, {
          width: "wide"
        });
    }
  },
  // Year
  y: function(e, t, r) {
    if (t === "yo") {
      var i = e.getUTCFullYear(), n = i > 0 ? i : 1 - i;
      return r.ordinalNumber(n, {
        unit: "year"
      });
    }
    return Se.y(e, t);
  },
  // Local week-numbering year
  Y: function(e, t, r, i) {
    var n = Or(e, i), o = n > 0 ? n : 1 - n;
    if (t === "YY") {
      var a = o % 100;
      return M(a, 2);
    }
    return t === "Yo" ? r.ordinalNumber(o, {
      unit: "year"
    }) : M(o, t.length);
  },
  // ISO week-numbering year
  R: function(e, t) {
    var r = di(e);
    return M(r, t.length);
  },
  // Extended year. This is a single number designating the year of this calendar system.
  // The main difference between `y` and `u` localizers are B.C. years:
  // | Year | `y` | `u` |
  // |------|-----|-----|
  // | AC 1 |   1 |   1 |
  // | BC 1 |   1 |   0 |
  // | BC 2 |   2 |  -1 |
  // Also `yy` always returns the last two digits of a year,
  // while `uu` pads single digit years to 2 characters and returns other years unchanged.
  u: function(e, t) {
    var r = e.getUTCFullYear();
    return M(r, t.length);
  },
  // Quarter
  Q: function(e, t, r) {
    var i = Math.ceil((e.getUTCMonth() + 1) / 3);
    switch (t) {
      case "Q":
        return String(i);
      case "QQ":
        return M(i, 2);
      case "Qo":
        return r.ordinalNumber(i, {
          unit: "quarter"
        });
      case "QQQ":
        return r.quarter(i, {
          width: "abbreviated",
          context: "formatting"
        });
      case "QQQQQ":
        return r.quarter(i, {
          width: "narrow",
          context: "formatting"
        });
      case "QQQQ":
      default:
        return r.quarter(i, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Stand-alone quarter
  q: function(e, t, r) {
    var i = Math.ceil((e.getUTCMonth() + 1) / 3);
    switch (t) {
      case "q":
        return String(i);
      case "qq":
        return M(i, 2);
      case "qo":
        return r.ordinalNumber(i, {
          unit: "quarter"
        });
      case "qqq":
        return r.quarter(i, {
          width: "abbreviated",
          context: "standalone"
        });
      case "qqqqq":
        return r.quarter(i, {
          width: "narrow",
          context: "standalone"
        });
      case "qqqq":
      default:
        return r.quarter(i, {
          width: "wide",
          context: "standalone"
        });
    }
  },
  // Month
  M: function(e, t, r) {
    var i = e.getUTCMonth();
    switch (t) {
      case "M":
      case "MM":
        return Se.M(e, t);
      case "Mo":
        return r.ordinalNumber(i + 1, {
          unit: "month"
        });
      case "MMM":
        return r.month(i, {
          width: "abbreviated",
          context: "formatting"
        });
      case "MMMMM":
        return r.month(i, {
          width: "narrow",
          context: "formatting"
        });
      case "MMMM":
      default:
        return r.month(i, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Stand-alone month
  L: function(e, t, r) {
    var i = e.getUTCMonth();
    switch (t) {
      case "L":
        return String(i + 1);
      case "LL":
        return M(i + 1, 2);
      case "Lo":
        return r.ordinalNumber(i + 1, {
          unit: "month"
        });
      case "LLL":
        return r.month(i, {
          width: "abbreviated",
          context: "standalone"
        });
      case "LLLLL":
        return r.month(i, {
          width: "narrow",
          context: "standalone"
        });
      case "LLLL":
      default:
        return r.month(i, {
          width: "wide",
          context: "standalone"
        });
    }
  },
  // Local week of year
  w: function(e, t, r, i) {
    var n = hi(e, i);
    return t === "wo" ? r.ordinalNumber(n, {
      unit: "week"
    }) : M(n, t.length);
  },
  // ISO week of year
  I: function(e, t, r) {
    var i = pi(e);
    return t === "Io" ? r.ordinalNumber(i, {
      unit: "week"
    }) : M(i, t.length);
  },
  // Day of the month
  d: function(e, t, r) {
    return t === "do" ? r.ordinalNumber(e.getUTCDate(), {
      unit: "date"
    }) : Se.d(e, t);
  },
  // Day of year
  D: function(e, t, r) {
    var i = io(e);
    return t === "Do" ? r.ordinalNumber(i, {
      unit: "dayOfYear"
    }) : M(i, t.length);
  },
  // Day of week
  E: function(e, t, r) {
    var i = e.getUTCDay();
    switch (t) {
      case "E":
      case "EE":
      case "EEE":
        return r.day(i, {
          width: "abbreviated",
          context: "formatting"
        });
      case "EEEEE":
        return r.day(i, {
          width: "narrow",
          context: "formatting"
        });
      case "EEEEEE":
        return r.day(i, {
          width: "short",
          context: "formatting"
        });
      case "EEEE":
      default:
        return r.day(i, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Local day of week
  e: function(e, t, r, i) {
    var n = e.getUTCDay(), o = (n - i.weekStartsOn + 8) % 7 || 7;
    switch (t) {
      case "e":
        return String(o);
      case "ee":
        return M(o, 2);
      case "eo":
        return r.ordinalNumber(o, {
          unit: "day"
        });
      case "eee":
        return r.day(n, {
          width: "abbreviated",
          context: "formatting"
        });
      case "eeeee":
        return r.day(n, {
          width: "narrow",
          context: "formatting"
        });
      case "eeeeee":
        return r.day(n, {
          width: "short",
          context: "formatting"
        });
      case "eeee":
      default:
        return r.day(n, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Stand-alone local day of week
  c: function(e, t, r, i) {
    var n = e.getUTCDay(), o = (n - i.weekStartsOn + 8) % 7 || 7;
    switch (t) {
      case "c":
        return String(o);
      case "cc":
        return M(o, t.length);
      case "co":
        return r.ordinalNumber(o, {
          unit: "day"
        });
      case "ccc":
        return r.day(n, {
          width: "abbreviated",
          context: "standalone"
        });
      case "ccccc":
        return r.day(n, {
          width: "narrow",
          context: "standalone"
        });
      case "cccccc":
        return r.day(n, {
          width: "short",
          context: "standalone"
        });
      case "cccc":
      default:
        return r.day(n, {
          width: "wide",
          context: "standalone"
        });
    }
  },
  // ISO day of week
  i: function(e, t, r) {
    var i = e.getUTCDay(), n = i === 0 ? 7 : i;
    switch (t) {
      case "i":
        return String(n);
      case "ii":
        return M(n, t.length);
      case "io":
        return r.ordinalNumber(n, {
          unit: "day"
        });
      case "iii":
        return r.day(i, {
          width: "abbreviated",
          context: "formatting"
        });
      case "iiiii":
        return r.day(i, {
          width: "narrow",
          context: "formatting"
        });
      case "iiiiii":
        return r.day(i, {
          width: "short",
          context: "formatting"
        });
      case "iiii":
      default:
        return r.day(i, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // AM or PM
  a: function(e, t, r) {
    var i = e.getUTCHours(), n = i / 12 >= 1 ? "pm" : "am";
    switch (t) {
      case "a":
      case "aa":
        return r.dayPeriod(n, {
          width: "abbreviated",
          context: "formatting"
        });
      case "aaa":
        return r.dayPeriod(n, {
          width: "abbreviated",
          context: "formatting"
        }).toLowerCase();
      case "aaaaa":
        return r.dayPeriod(n, {
          width: "narrow",
          context: "formatting"
        });
      case "aaaa":
      default:
        return r.dayPeriod(n, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // AM, PM, midnight, noon
  b: function(e, t, r) {
    var i = e.getUTCHours(), n;
    switch (i === 12 ? n = tt.noon : i === 0 ? n = tt.midnight : n = i / 12 >= 1 ? "pm" : "am", t) {
      case "b":
      case "bb":
        return r.dayPeriod(n, {
          width: "abbreviated",
          context: "formatting"
        });
      case "bbb":
        return r.dayPeriod(n, {
          width: "abbreviated",
          context: "formatting"
        }).toLowerCase();
      case "bbbbb":
        return r.dayPeriod(n, {
          width: "narrow",
          context: "formatting"
        });
      case "bbbb":
      default:
        return r.dayPeriod(n, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // in the morning, in the afternoon, in the evening, at night
  B: function(e, t, r) {
    var i = e.getUTCHours(), n;
    switch (i >= 17 ? n = tt.evening : i >= 12 ? n = tt.afternoon : i >= 4 ? n = tt.morning : n = tt.night, t) {
      case "B":
      case "BB":
      case "BBB":
        return r.dayPeriod(n, {
          width: "abbreviated",
          context: "formatting"
        });
      case "BBBBB":
        return r.dayPeriod(n, {
          width: "narrow",
          context: "formatting"
        });
      case "BBBB":
      default:
        return r.dayPeriod(n, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Hour [1-12]
  h: function(e, t, r) {
    if (t === "ho") {
      var i = e.getUTCHours() % 12;
      return i === 0 && (i = 12), r.ordinalNumber(i, {
        unit: "hour"
      });
    }
    return Se.h(e, t);
  },
  // Hour [0-23]
  H: function(e, t, r) {
    return t === "Ho" ? r.ordinalNumber(e.getUTCHours(), {
      unit: "hour"
    }) : Se.H(e, t);
  },
  // Hour [0-11]
  K: function(e, t, r) {
    var i = e.getUTCHours() % 12;
    return t === "Ko" ? r.ordinalNumber(i, {
      unit: "hour"
    }) : M(i, t.length);
  },
  // Hour [1-24]
  k: function(e, t, r) {
    var i = e.getUTCHours();
    return i === 0 && (i = 24), t === "ko" ? r.ordinalNumber(i, {
      unit: "hour"
    }) : M(i, t.length);
  },
  // Minute
  m: function(e, t, r) {
    return t === "mo" ? r.ordinalNumber(e.getUTCMinutes(), {
      unit: "minute"
    }) : Se.m(e, t);
  },
  // Second
  s: function(e, t, r) {
    return t === "so" ? r.ordinalNumber(e.getUTCSeconds(), {
      unit: "second"
    }) : Se.s(e, t);
  },
  // Fraction of second
  S: function(e, t) {
    return Se.S(e, t);
  },
  // Timezone (ISO-8601. If offset is 0, output is always `'Z'`)
  X: function(e, t, r, i) {
    var n = i._originalDate || e, o = n.getTimezoneOffset();
    if (o === 0)
      return "Z";
    switch (t) {
      case "X":
        return zr(o);
      case "XXXX":
      case "XX":
        return Be(o);
      case "XXXXX":
      case "XXX":
      default:
        return Be(o, ":");
    }
  },
  // Timezone (ISO-8601. If offset is 0, output is `'+00:00'` or equivalent)
  x: function(e, t, r, i) {
    var n = i._originalDate || e, o = n.getTimezoneOffset();
    switch (t) {
      case "x":
        return zr(o);
      case "xxxx":
      case "xx":
        return Be(o);
      case "xxxxx":
      case "xxx":
      default:
        return Be(o, ":");
    }
  },
  // Timezone (GMT)
  O: function(e, t, r, i) {
    var n = i._originalDate || e, o = n.getTimezoneOffset();
    switch (t) {
      case "O":
      case "OO":
      case "OOO":
        return "GMT" + Rr(o, ":");
      case "OOOO":
      default:
        return "GMT" + Be(o, ":");
    }
  },
  // Timezone (specific non-location)
  z: function(e, t, r, i) {
    var n = i._originalDate || e, o = n.getTimezoneOffset();
    switch (t) {
      case "z":
      case "zz":
      case "zzz":
        return "GMT" + Rr(o, ":");
      case "zzzz":
      default:
        return "GMT" + Be(o, ":");
    }
  },
  // Seconds timestamp
  t: function(e, t, r, i) {
    var n = i._originalDate || e, o = Math.floor(n.getTime() / 1e3);
    return M(o, t.length);
  },
  // Milliseconds timestamp
  T: function(e, t, r, i) {
    var n = i._originalDate || e, o = n.getTime();
    return M(o, t.length);
  }
};
function Rr(e, t) {
  var r = e > 0 ? "-" : "+", i = Math.abs(e), n = Math.floor(i / 60), o = i % 60;
  if (o === 0)
    return r + String(n);
  var a = t || "";
  return r + String(n) + a + M(o, 2);
}
function zr(e, t) {
  if (e % 60 === 0) {
    var r = e > 0 ? "-" : "+";
    return r + M(Math.abs(e) / 60, 2);
  }
  return Be(e, t);
}
function Be(e, t) {
  var r = t || "", i = e > 0 ? "-" : "+", n = Math.abs(e), o = M(Math.floor(n / 60), 2), a = M(n % 60, 2);
  return i + o + r + a;
}
const co = lo;
function Vr(e, t) {
  switch (e) {
    case "P":
      return t.date({
        width: "short"
      });
    case "PP":
      return t.date({
        width: "medium"
      });
    case "PPP":
      return t.date({
        width: "long"
      });
    case "PPPP":
    default:
      return t.date({
        width: "full"
      });
  }
}
function fi(e, t) {
  switch (e) {
    case "p":
      return t.time({
        width: "short"
      });
    case "pp":
      return t.time({
        width: "medium"
      });
    case "ppp":
      return t.time({
        width: "long"
      });
    case "pppp":
    default:
      return t.time({
        width: "full"
      });
  }
}
function uo(e, t) {
  var r = e.match(/(P+)(p+)?/), i = r[1], n = r[2];
  if (!n)
    return Vr(e, t);
  var o;
  switch (i) {
    case "P":
      o = t.dateTime({
        width: "short"
      });
      break;
    case "PP":
      o = t.dateTime({
        width: "medium"
      });
      break;
    case "PPP":
      o = t.dateTime({
        width: "long"
      });
      break;
    case "PPPP":
    default:
      o = t.dateTime({
        width: "full"
      });
      break;
  }
  return o.replace("{{date}}", Vr(i, t)).replace("{{time}}", fi(n, t));
}
var po = {
  p: fi,
  P: uo
};
const vi = po;
var ho = ["D", "DD"], fo = ["YY", "YYYY"];
function gi(e) {
  return ho.indexOf(e) !== -1;
}
function mi(e) {
  return fo.indexOf(e) !== -1;
}
function Rt(e, t, r) {
  if (e === "YYYY")
    throw new RangeError("Use `yyyy` instead of `YYYY` (in `".concat(t, "`) for formatting years to the input `").concat(r, "`; see: https://git.io/fxCyr"));
  if (e === "YY")
    throw new RangeError("Use `yy` instead of `YY` (in `".concat(t, "`) for formatting years to the input `").concat(r, "`; see: https://git.io/fxCyr"));
  if (e === "D")
    throw new RangeError("Use `d` instead of `D` (in `".concat(t, "`) for formatting days of the month to the input `").concat(r, "`; see: https://git.io/fxCyr"));
  if (e === "DD")
    throw new RangeError("Use `dd` instead of `DD` (in `".concat(t, "`) for formatting days of the month to the input `").concat(r, "`; see: https://git.io/fxCyr"));
}
var vo = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g, go = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g, mo = /^'([^]*?)'?$/, bo = /''/g, wo = /[a-zA-Z]/;
function he(e, t, r) {
  f(2, arguments);
  var i = String(t), n = r || {}, o = n.locale || ci, a = o.options && o.options.firstWeekContainsDate, s = a == null ? 1 : T(a), c = n.firstWeekContainsDate == null ? s : T(n.firstWeekContainsDate);
  if (!(c >= 1 && c <= 7))
    throw new RangeError("firstWeekContainsDate must be between 1 and 7 inclusively");
  var u = o.options && o.options.weekStartsOn, d = u == null ? 0 : T(u), v = n.weekStartsOn == null ? d : T(n.weekStartsOn);
  if (!(v >= 0 && v <= 6))
    throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
  if (!o.localize)
    throw new RangeError("locale must contain localize property");
  if (!o.formatLong)
    throw new RangeError("locale must contain formatLong property");
  var D = b(e);
  if (!dn(D))
    throw new RangeError("Invalid time value");
  var h = li(D), $ = ui(D, h), O = {
    firstWeekContainsDate: c,
    weekStartsOn: v,
    locale: o,
    _originalDate: D
  }, g = i.match(go).map(function(y) {
    var _ = y[0];
    if (_ === "p" || _ === "P") {
      var m = vi[_];
      return m(y, o.formatLong, O);
    }
    return y;
  }).join("").match(vo).map(function(y) {
    if (y === "''")
      return "'";
    var _ = y[0];
    if (_ === "'")
      return yo(y);
    var m = co[_];
    if (m)
      return !n.useAdditionalWeekYearTokens && mi(y) && Rt(y, t, e), !n.useAdditionalDayOfYearTokens && gi(y) && Rt(y, t, e), m($, y, o.localize, O);
    if (_.match(wo))
      throw new RangeError("Format string contains an unescaped latin alphabet character `" + _ + "`");
    return y;
  }).join("");
  return g;
}
function yo(e) {
  return e.match(mo)[1].replace(bo, "'");
}
function xo(e, t) {
  if (e == null)
    throw new TypeError("assign requires that input parameter not be null or undefined");
  t = t || {};
  for (var r in t)
    Object.prototype.hasOwnProperty.call(t, r) && (e[r] = t[r]);
  return e;
}
var Oo = 6048e5;
function Do(e) {
  f(1, arguments);
  var t = b(e), r = jt(t).getTime() - ln(t).getTime();
  return Math.round(r / Oo) + 1;
}
function Co(e, t) {
  f(2, arguments);
  var r = T(t);
  return xr(e, -r);
}
function pr(e, t, r) {
  f(2, arguments);
  var i = r || {}, n = i.locale, o = n && n.options && n.options.weekStartsOn, a = o == null ? 0 : T(o), s = i.weekStartsOn == null ? a : T(i.weekStartsOn);
  if (!(s >= 0 && s <= 6))
    throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
  var c = b(e), u = T(t), d = c.getUTCDay(), v = u % 7, D = (v + 7) % 7, h = (D < s ? 7 : 0) + u - d;
  return c.setUTCDate(c.getUTCDate() + h), c;
}
function _o(e, t) {
  f(2, arguments);
  var r = T(t);
  r % 7 === 0 && (r = r - 7);
  var i = 1, n = b(e), o = n.getUTCDay(), a = r % 7, s = (a + 7) % 7, c = (s < i ? 7 : 0) + r - o;
  return n.setUTCDate(n.getUTCDate() + c), n;
}
function To(e, t) {
  f(2, arguments);
  var r = b(e), i = T(t), n = pi(r) - i;
  return r.setUTCDate(r.getUTCDate() - n * 7), r;
}
function Po(e, t, r) {
  f(2, arguments);
  var i = b(e), n = T(t), o = hi(i, r) - n;
  return i.setUTCDate(i.getUTCDate() - o * 7), i;
}
var ko = 36e5, So = 6e4, Eo = 1e3, H = {
  month: /^(1[0-2]|0?\d)/,
  // 0 to 12
  date: /^(3[0-1]|[0-2]?\d)/,
  // 0 to 31
  dayOfYear: /^(36[0-6]|3[0-5]\d|[0-2]?\d?\d)/,
  // 0 to 366
  week: /^(5[0-3]|[0-4]?\d)/,
  // 0 to 53
  hour23h: /^(2[0-3]|[0-1]?\d)/,
  // 0 to 23
  hour24h: /^(2[0-4]|[0-1]?\d)/,
  // 0 to 24
  hour11h: /^(1[0-1]|0?\d)/,
  // 0 to 11
  hour12h: /^(1[0-2]|0?\d)/,
  // 0 to 12
  minute: /^[0-5]?\d/,
  // 0 to 59
  second: /^[0-5]?\d/,
  // 0 to 59
  singleDigit: /^\d/,
  // 0 to 9
  twoDigits: /^\d{1,2}/,
  // 0 to 99
  threeDigits: /^\d{1,3}/,
  // 0 to 999
  fourDigits: /^\d{1,4}/,
  // 0 to 9999
  anyDigitsSigned: /^-?\d+/,
  singleDigitSigned: /^-?\d/,
  // 0 to 9, -0 to -9
  twoDigitsSigned: /^-?\d{1,2}/,
  // 0 to 99, -0 to -99
  threeDigitsSigned: /^-?\d{1,3}/,
  // 0 to 999, -0 to -999
  fourDigitsSigned: /^-?\d{1,4}/
  // 0 to 9999, -0 to -9999
}, de = {
  basicOptionalMinutes: /^([+-])(\d{2})(\d{2})?|Z/,
  basic: /^([+-])(\d{2})(\d{2})|Z/,
  basicOptionalSeconds: /^([+-])(\d{2})(\d{2})((\d{2}))?|Z/,
  extended: /^([+-])(\d{2}):(\d{2})|Z/,
  extendedOptionalSeconds: /^([+-])(\d{2}):(\d{2})(:(\d{2}))?|Z/
};
function W(e, t, r) {
  var i = t.match(e);
  if (!i)
    return null;
  var n = parseInt(i[0], 10);
  return {
    value: r ? r(n) : n,
    rest: t.slice(i[0].length)
  };
}
function pe(e, t) {
  var r = t.match(e);
  if (!r)
    return null;
  if (r[0] === "Z")
    return {
      value: 0,
      rest: t.slice(1)
    };
  var i = r[1] === "+" ? 1 : -1, n = r[2] ? parseInt(r[2], 10) : 0, o = r[3] ? parseInt(r[3], 10) : 0, a = r[5] ? parseInt(r[5], 10) : 0;
  return {
    value: i * (n * ko + o * So + a * Eo),
    rest: t.slice(r[0].length)
  };
}
function Qr(e, t) {
  return W(H.anyDigitsSigned, e, t);
}
function B(e, t, r) {
  switch (e) {
    case 1:
      return W(H.singleDigit, t, r);
    case 2:
      return W(H.twoDigits, t, r);
    case 3:
      return W(H.threeDigits, t, r);
    case 4:
      return W(H.fourDigits, t, r);
    default:
      return W(new RegExp("^\\d{1," + e + "}"), t, r);
  }
}
function qt(e, t, r) {
  switch (e) {
    case 1:
      return W(H.singleDigitSigned, t, r);
    case 2:
      return W(H.twoDigitsSigned, t, r);
    case 3:
      return W(H.threeDigitsSigned, t, r);
    case 4:
      return W(H.fourDigitsSigned, t, r);
    default:
      return W(new RegExp("^-?\\d{1," + e + "}"), t, r);
  }
}
function hr(e) {
  switch (e) {
    case "morning":
      return 4;
    case "evening":
      return 17;
    case "pm":
    case "noon":
    case "afternoon":
      return 12;
    case "am":
    case "midnight":
    case "night":
    default:
      return 0;
  }
}
function Xr(e, t) {
  var r = t > 0, i = r ? t : 1 - t, n;
  if (i <= 50)
    n = e || 100;
  else {
    var o = i + 50, a = Math.floor(o / 100) * 100, s = e >= o % 100;
    n = e + a - (s ? 100 : 0);
  }
  return r ? n : 1 - n;
}
var $o = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31], Mo = [31, 29, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
function Gr(e) {
  return e % 400 === 0 || e % 4 === 0 && e % 100 !== 0;
}
var Io = {
  // Era
  G: {
    priority: 140,
    parse: function(e, t, r, i) {
      switch (t) {
        case "G":
        case "GG":
        case "GGG":
          return r.era(e, {
            width: "abbreviated"
          }) || r.era(e, {
            width: "narrow"
          });
        case "GGGGG":
          return r.era(e, {
            width: "narrow"
          });
        case "GGGG":
        default:
          return r.era(e, {
            width: "wide"
          }) || r.era(e, {
            width: "abbreviated"
          }) || r.era(e, {
            width: "narrow"
          });
      }
    },
    set: function(e, t, r, i) {
      return t.era = r, e.setUTCFullYear(r, 0, 1), e.setUTCHours(0, 0, 0, 0), e;
    },
    incompatibleTokens: ["R", "u", "t", "T"]
  },
  // Year
  y: {
    // From http://www.unicode.org/reports/tr35/tr35-31/tr35-dates.html#Date_Format_Patterns
    // | Year     |     y | yy |   yyy |  yyyy | yyyyy |
    // |----------|-------|----|-------|-------|-------|
    // | AD 1     |     1 | 01 |   001 |  0001 | 00001 |
    // | AD 12    |    12 | 12 |   012 |  0012 | 00012 |
    // | AD 123   |   123 | 23 |   123 |  0123 | 00123 |
    // | AD 1234  |  1234 | 34 |  1234 |  1234 | 01234 |
    // | AD 12345 | 12345 | 45 | 12345 | 12345 | 12345 |
    priority: 130,
    parse: function(e, t, r, i) {
      var n = function(o) {
        return {
          year: o,
          isTwoDigitYear: t === "yy"
        };
      };
      switch (t) {
        case "y":
          return B(4, e, n);
        case "yo":
          return r.ordinalNumber(e, {
            unit: "year",
            valueCallback: n
          });
        default:
          return B(t.length, e, n);
      }
    },
    validate: function(e, t, r) {
      return t.isTwoDigitYear || t.year > 0;
    },
    set: function(e, t, r, i) {
      var n = e.getUTCFullYear();
      if (r.isTwoDigitYear) {
        var o = Xr(r.year, n);
        return e.setUTCFullYear(o, 0, 1), e.setUTCHours(0, 0, 0, 0), e;
      }
      var a = !("era" in t) || t.era === 1 ? r.year : 1 - r.year;
      return e.setUTCFullYear(a, 0, 1), e.setUTCHours(0, 0, 0, 0), e;
    },
    incompatibleTokens: ["Y", "R", "u", "w", "I", "i", "e", "c", "t", "T"]
  },
  // Local week-numbering year
  Y: {
    priority: 130,
    parse: function(e, t, r, i) {
      var n = function(o) {
        return {
          year: o,
          isTwoDigitYear: t === "YY"
        };
      };
      switch (t) {
        case "Y":
          return B(4, e, n);
        case "Yo":
          return r.ordinalNumber(e, {
            unit: "year",
            valueCallback: n
          });
        default:
          return B(t.length, e, n);
      }
    },
    validate: function(e, t, r) {
      return t.isTwoDigitYear || t.year > 0;
    },
    set: function(e, t, r, i) {
      var n = Or(e, i);
      if (r.isTwoDigitYear) {
        var o = Xr(r.year, n);
        return e.setUTCFullYear(o, 0, i.firstWeekContainsDate), e.setUTCHours(0, 0, 0, 0), Ae(e, i);
      }
      var a = !("era" in t) || t.era === 1 ? r.year : 1 - r.year;
      return e.setUTCFullYear(a, 0, i.firstWeekContainsDate), e.setUTCHours(0, 0, 0, 0), Ae(e, i);
    },
    incompatibleTokens: ["y", "R", "u", "Q", "q", "M", "L", "I", "d", "D", "i", "t", "T"]
  },
  // ISO week-numbering year
  R: {
    priority: 130,
    parse: function(e, t, r, i) {
      return qt(t === "R" ? 4 : t.length, e);
    },
    set: function(e, t, r, i) {
      var n = /* @__PURE__ */ new Date(0);
      return n.setUTCFullYear(r, 0, 4), n.setUTCHours(0, 0, 0, 0), nt(n);
    },
    incompatibleTokens: ["G", "y", "Y", "u", "Q", "q", "M", "L", "w", "d", "D", "e", "c", "t", "T"]
  },
  // Extended year
  u: {
    priority: 130,
    parse: function(e, t, r, i) {
      return qt(t === "u" ? 4 : t.length, e);
    },
    set: function(e, t, r, i) {
      return e.setUTCFullYear(r, 0, 1), e.setUTCHours(0, 0, 0, 0), e;
    },
    incompatibleTokens: ["G", "y", "Y", "R", "w", "I", "i", "e", "c", "t", "T"]
  },
  // Quarter
  Q: {
    priority: 120,
    parse: function(e, t, r, i) {
      switch (t) {
        case "Q":
        case "QQ":
          return B(t.length, e);
        case "Qo":
          return r.ordinalNumber(e, {
            unit: "quarter"
          });
        case "QQQ":
          return r.quarter(e, {
            width: "abbreviated",
            context: "formatting"
          }) || r.quarter(e, {
            width: "narrow",
            context: "formatting"
          });
        case "QQQQQ":
          return r.quarter(e, {
            width: "narrow",
            context: "formatting"
          });
        case "QQQQ":
        default:
          return r.quarter(e, {
            width: "wide",
            context: "formatting"
          }) || r.quarter(e, {
            width: "abbreviated",
            context: "formatting"
          }) || r.quarter(e, {
            width: "narrow",
            context: "formatting"
          });
      }
    },
    validate: function(e, t, r) {
      return t >= 1 && t <= 4;
    },
    set: function(e, t, r, i) {
      return e.setUTCMonth((r - 1) * 3, 1), e.setUTCHours(0, 0, 0, 0), e;
    },
    incompatibleTokens: ["Y", "R", "q", "M", "L", "w", "I", "d", "D", "i", "e", "c", "t", "T"]
  },
  // Stand-alone quarter
  q: {
    priority: 120,
    parse: function(e, t, r, i) {
      switch (t) {
        case "q":
        case "qq":
          return B(t.length, e);
        case "qo":
          return r.ordinalNumber(e, {
            unit: "quarter"
          });
        case "qqq":
          return r.quarter(e, {
            width: "abbreviated",
            context: "standalone"
          }) || r.quarter(e, {
            width: "narrow",
            context: "standalone"
          });
        case "qqqqq":
          return r.quarter(e, {
            width: "narrow",
            context: "standalone"
          });
        case "qqqq":
        default:
          return r.quarter(e, {
            width: "wide",
            context: "standalone"
          }) || r.quarter(e, {
            width: "abbreviated",
            context: "standalone"
          }) || r.quarter(e, {
            width: "narrow",
            context: "standalone"
          });
      }
    },
    validate: function(e, t, r) {
      return t >= 1 && t <= 4;
    },
    set: function(e, t, r, i) {
      return e.setUTCMonth((r - 1) * 3, 1), e.setUTCHours(0, 0, 0, 0), e;
    },
    incompatibleTokens: ["Y", "R", "Q", "M", "L", "w", "I", "d", "D", "i", "e", "c", "t", "T"]
  },
  // Month
  M: {
    priority: 110,
    parse: function(e, t, r, i) {
      var n = function(o) {
        return o - 1;
      };
      switch (t) {
        case "M":
          return W(H.month, e, n);
        case "MM":
          return B(2, e, n);
        case "Mo":
          return r.ordinalNumber(e, {
            unit: "month",
            valueCallback: n
          });
        case "MMM":
          return r.month(e, {
            width: "abbreviated",
            context: "formatting"
          }) || r.month(e, {
            width: "narrow",
            context: "formatting"
          });
        case "MMMMM":
          return r.month(e, {
            width: "narrow",
            context: "formatting"
          });
        case "MMMM":
        default:
          return r.month(e, {
            width: "wide",
            context: "formatting"
          }) || r.month(e, {
            width: "abbreviated",
            context: "formatting"
          }) || r.month(e, {
            width: "narrow",
            context: "formatting"
          });
      }
    },
    validate: function(e, t, r) {
      return t >= 0 && t <= 11;
    },
    set: function(e, t, r, i) {
      return e.setUTCMonth(r, 1), e.setUTCHours(0, 0, 0, 0), e;
    },
    incompatibleTokens: ["Y", "R", "q", "Q", "L", "w", "I", "D", "i", "e", "c", "t", "T"]
  },
  // Stand-alone month
  L: {
    priority: 110,
    parse: function(e, t, r, i) {
      var n = function(o) {
        return o - 1;
      };
      switch (t) {
        case "L":
          return W(H.month, e, n);
        case "LL":
          return B(2, e, n);
        case "Lo":
          return r.ordinalNumber(e, {
            unit: "month",
            valueCallback: n
          });
        case "LLL":
          return r.month(e, {
            width: "abbreviated",
            context: "standalone"
          }) || r.month(e, {
            width: "narrow",
            context: "standalone"
          });
        case "LLLLL":
          return r.month(e, {
            width: "narrow",
            context: "standalone"
          });
        case "LLLL":
        default:
          return r.month(e, {
            width: "wide",
            context: "standalone"
          }) || r.month(e, {
            width: "abbreviated",
            context: "standalone"
          }) || r.month(e, {
            width: "narrow",
            context: "standalone"
          });
      }
    },
    validate: function(e, t, r) {
      return t >= 0 && t <= 11;
    },
    set: function(e, t, r, i) {
      return e.setUTCMonth(r, 1), e.setUTCHours(0, 0, 0, 0), e;
    },
    incompatibleTokens: ["Y", "R", "q", "Q", "M", "w", "I", "D", "i", "e", "c", "t", "T"]
  },
  // Local week of year
  w: {
    priority: 100,
    parse: function(e, t, r, i) {
      switch (t) {
        case "w":
          return W(H.week, e);
        case "wo":
          return r.ordinalNumber(e, {
            unit: "week"
          });
        default:
          return B(t.length, e);
      }
    },
    validate: function(e, t, r) {
      return t >= 1 && t <= 53;
    },
    set: function(e, t, r, i) {
      return Ae(Po(e, r, i), i);
    },
    incompatibleTokens: ["y", "R", "u", "q", "Q", "M", "L", "I", "d", "D", "i", "t", "T"]
  },
  // ISO week of year
  I: {
    priority: 100,
    parse: function(e, t, r, i) {
      switch (t) {
        case "I":
          return W(H.week, e);
        case "Io":
          return r.ordinalNumber(e, {
            unit: "week"
          });
        default:
          return B(t.length, e);
      }
    },
    validate: function(e, t, r) {
      return t >= 1 && t <= 53;
    },
    set: function(e, t, r, i) {
      return nt(To(e, r, i), i);
    },
    incompatibleTokens: ["y", "Y", "u", "q", "Q", "M", "L", "w", "d", "D", "e", "c", "t", "T"]
  },
  // Day of the month
  d: {
    priority: 90,
    subPriority: 1,
    parse: function(e, t, r, i) {
      switch (t) {
        case "d":
          return W(H.date, e);
        case "do":
          return r.ordinalNumber(e, {
            unit: "date"
          });
        default:
          return B(t.length, e);
      }
    },
    validate: function(e, t, r) {
      var i = e.getUTCFullYear(), n = Gr(i), o = e.getUTCMonth();
      return n ? t >= 1 && t <= Mo[o] : t >= 1 && t <= $o[o];
    },
    set: function(e, t, r, i) {
      return e.setUTCDate(r), e.setUTCHours(0, 0, 0, 0), e;
    },
    incompatibleTokens: ["Y", "R", "q", "Q", "w", "I", "D", "i", "e", "c", "t", "T"]
  },
  // Day of year
  D: {
    priority: 90,
    subPriority: 1,
    parse: function(e, t, r, i) {
      switch (t) {
        case "D":
        case "DD":
          return W(H.dayOfYear, e);
        case "Do":
          return r.ordinalNumber(e, {
            unit: "date"
          });
        default:
          return B(t.length, e);
      }
    },
    validate: function(e, t, r) {
      var i = e.getUTCFullYear(), n = Gr(i);
      return n ? t >= 1 && t <= 366 : t >= 1 && t <= 365;
    },
    set: function(e, t, r, i) {
      return e.setUTCMonth(0, r), e.setUTCHours(0, 0, 0, 0), e;
    },
    incompatibleTokens: ["Y", "R", "q", "Q", "M", "L", "w", "I", "d", "E", "i", "e", "c", "t", "T"]
  },
  // Day of week
  E: {
    priority: 90,
    parse: function(e, t, r, i) {
      switch (t) {
        case "E":
        case "EE":
        case "EEE":
          return r.day(e, {
            width: "abbreviated",
            context: "formatting"
          }) || r.day(e, {
            width: "short",
            context: "formatting"
          }) || r.day(e, {
            width: "narrow",
            context: "formatting"
          });
        case "EEEEE":
          return r.day(e, {
            width: "narrow",
            context: "formatting"
          });
        case "EEEEEE":
          return r.day(e, {
            width: "short",
            context: "formatting"
          }) || r.day(e, {
            width: "narrow",
            context: "formatting"
          });
        case "EEEE":
        default:
          return r.day(e, {
            width: "wide",
            context: "formatting"
          }) || r.day(e, {
            width: "abbreviated",
            context: "formatting"
          }) || r.day(e, {
            width: "short",
            context: "formatting"
          }) || r.day(e, {
            width: "narrow",
            context: "formatting"
          });
      }
    },
    validate: function(e, t, r) {
      return t >= 0 && t <= 6;
    },
    set: function(e, t, r, i) {
      return e = pr(e, r, i), e.setUTCHours(0, 0, 0, 0), e;
    },
    incompatibleTokens: ["D", "i", "e", "c", "t", "T"]
  },
  // Local day of week
  e: {
    priority: 90,
    parse: function(e, t, r, i) {
      var n = function(o) {
        var a = Math.floor((o - 1) / 7) * 7;
        return (o + i.weekStartsOn + 6) % 7 + a;
      };
      switch (t) {
        case "e":
        case "ee":
          return B(t.length, e, n);
        case "eo":
          return r.ordinalNumber(e, {
            unit: "day",
            valueCallback: n
          });
        case "eee":
          return r.day(e, {
            width: "abbreviated",
            context: "formatting"
          }) || r.day(e, {
            width: "short",
            context: "formatting"
          }) || r.day(e, {
            width: "narrow",
            context: "formatting"
          });
        case "eeeee":
          return r.day(e, {
            width: "narrow",
            context: "formatting"
          });
        case "eeeeee":
          return r.day(e, {
            width: "short",
            context: "formatting"
          }) || r.day(e, {
            width: "narrow",
            context: "formatting"
          });
        case "eeee":
        default:
          return r.day(e, {
            width: "wide",
            context: "formatting"
          }) || r.day(e, {
            width: "abbreviated",
            context: "formatting"
          }) || r.day(e, {
            width: "short",
            context: "formatting"
          }) || r.day(e, {
            width: "narrow",
            context: "formatting"
          });
      }
    },
    validate: function(e, t, r) {
      return t >= 0 && t <= 6;
    },
    set: function(e, t, r, i) {
      return e = pr(e, r, i), e.setUTCHours(0, 0, 0, 0), e;
    },
    incompatibleTokens: ["y", "R", "u", "q", "Q", "M", "L", "I", "d", "D", "E", "i", "c", "t", "T"]
  },
  // Stand-alone local day of week
  c: {
    priority: 90,
    parse: function(e, t, r, i) {
      var n = function(o) {
        var a = Math.floor((o - 1) / 7) * 7;
        return (o + i.weekStartsOn + 6) % 7 + a;
      };
      switch (t) {
        case "c":
        case "cc":
          return B(t.length, e, n);
        case "co":
          return r.ordinalNumber(e, {
            unit: "day",
            valueCallback: n
          });
        case "ccc":
          return r.day(e, {
            width: "abbreviated",
            context: "standalone"
          }) || r.day(e, {
            width: "short",
            context: "standalone"
          }) || r.day(e, {
            width: "narrow",
            context: "standalone"
          });
        case "ccccc":
          return r.day(e, {
            width: "narrow",
            context: "standalone"
          });
        case "cccccc":
          return r.day(e, {
            width: "short",
            context: "standalone"
          }) || r.day(e, {
            width: "narrow",
            context: "standalone"
          });
        case "cccc":
        default:
          return r.day(e, {
            width: "wide",
            context: "standalone"
          }) || r.day(e, {
            width: "abbreviated",
            context: "standalone"
          }) || r.day(e, {
            width: "short",
            context: "standalone"
          }) || r.day(e, {
            width: "narrow",
            context: "standalone"
          });
      }
    },
    validate: function(e, t, r) {
      return t >= 0 && t <= 6;
    },
    set: function(e, t, r, i) {
      return e = pr(e, r, i), e.setUTCHours(0, 0, 0, 0), e;
    },
    incompatibleTokens: ["y", "R", "u", "q", "Q", "M", "L", "I", "d", "D", "E", "i", "e", "t", "T"]
  },
  // ISO day of week
  i: {
    priority: 90,
    parse: function(e, t, r, i) {
      var n = function(o) {
        return o === 0 ? 7 : o;
      };
      switch (t) {
        case "i":
        case "ii":
          return B(t.length, e);
        case "io":
          return r.ordinalNumber(e, {
            unit: "day"
          });
        case "iii":
          return r.day(e, {
            width: "abbreviated",
            context: "formatting",
            valueCallback: n
          }) || r.day(e, {
            width: "short",
            context: "formatting",
            valueCallback: n
          }) || r.day(e, {
            width: "narrow",
            context: "formatting",
            valueCallback: n
          });
        case "iiiii":
          return r.day(e, {
            width: "narrow",
            context: "formatting",
            valueCallback: n
          });
        case "iiiiii":
          return r.day(e, {
            width: "short",
            context: "formatting",
            valueCallback: n
          }) || r.day(e, {
            width: "narrow",
            context: "formatting",
            valueCallback: n
          });
        case "iiii":
        default:
          return r.day(e, {
            width: "wide",
            context: "formatting",
            valueCallback: n
          }) || r.day(e, {
            width: "abbreviated",
            context: "formatting",
            valueCallback: n
          }) || r.day(e, {
            width: "short",
            context: "formatting",
            valueCallback: n
          }) || r.day(e, {
            width: "narrow",
            context: "formatting",
            valueCallback: n
          });
      }
    },
    validate: function(e, t, r) {
      return t >= 1 && t <= 7;
    },
    set: function(e, t, r, i) {
      return e = _o(e, r, i), e.setUTCHours(0, 0, 0, 0), e;
    },
    incompatibleTokens: ["y", "Y", "u", "q", "Q", "M", "L", "w", "d", "D", "E", "e", "c", "t", "T"]
  },
  // AM or PM
  a: {
    priority: 80,
    parse: function(e, t, r, i) {
      switch (t) {
        case "a":
        case "aa":
        case "aaa":
          return r.dayPeriod(e, {
            width: "abbreviated",
            context: "formatting"
          }) || r.dayPeriod(e, {
            width: "narrow",
            context: "formatting"
          });
        case "aaaaa":
          return r.dayPeriod(e, {
            width: "narrow",
            context: "formatting"
          });
        case "aaaa":
        default:
          return r.dayPeriod(e, {
            width: "wide",
            context: "formatting"
          }) || r.dayPeriod(e, {
            width: "abbreviated",
            context: "formatting"
          }) || r.dayPeriod(e, {
            width: "narrow",
            context: "formatting"
          });
      }
    },
    set: function(e, t, r, i) {
      return e.setUTCHours(hr(r), 0, 0, 0), e;
    },
    incompatibleTokens: ["b", "B", "H", "K", "k", "t", "T"]
  },
  // AM, PM, midnight
  b: {
    priority: 80,
    parse: function(e, t, r, i) {
      switch (t) {
        case "b":
        case "bb":
        case "bbb":
          return r.dayPeriod(e, {
            width: "abbreviated",
            context: "formatting"
          }) || r.dayPeriod(e, {
            width: "narrow",
            context: "formatting"
          });
        case "bbbbb":
          return r.dayPeriod(e, {
            width: "narrow",
            context: "formatting"
          });
        case "bbbb":
        default:
          return r.dayPeriod(e, {
            width: "wide",
            context: "formatting"
          }) || r.dayPeriod(e, {
            width: "abbreviated",
            context: "formatting"
          }) || r.dayPeriod(e, {
            width: "narrow",
            context: "formatting"
          });
      }
    },
    set: function(e, t, r, i) {
      return e.setUTCHours(hr(r), 0, 0, 0), e;
    },
    incompatibleTokens: ["a", "B", "H", "K", "k", "t", "T"]
  },
  // in the morning, in the afternoon, in the evening, at night
  B: {
    priority: 80,
    parse: function(e, t, r, i) {
      switch (t) {
        case "B":
        case "BB":
        case "BBB":
          return r.dayPeriod(e, {
            width: "abbreviated",
            context: "formatting"
          }) || r.dayPeriod(e, {
            width: "narrow",
            context: "formatting"
          });
        case "BBBBB":
          return r.dayPeriod(e, {
            width: "narrow",
            context: "formatting"
          });
        case "BBBB":
        default:
          return r.dayPeriod(e, {
            width: "wide",
            context: "formatting"
          }) || r.dayPeriod(e, {
            width: "abbreviated",
            context: "formatting"
          }) || r.dayPeriod(e, {
            width: "narrow",
            context: "formatting"
          });
      }
    },
    set: function(e, t, r, i) {
      return e.setUTCHours(hr(r), 0, 0, 0), e;
    },
    incompatibleTokens: ["a", "b", "t", "T"]
  },
  // Hour [1-12]
  h: {
    priority: 70,
    parse: function(e, t, r, i) {
      switch (t) {
        case "h":
          return W(H.hour12h, e);
        case "ho":
          return r.ordinalNumber(e, {
            unit: "hour"
          });
        default:
          return B(t.length, e);
      }
    },
    validate: function(e, t, r) {
      return t >= 1 && t <= 12;
    },
    set: function(e, t, r, i) {
      var n = e.getUTCHours() >= 12;
      return n && r < 12 ? e.setUTCHours(r + 12, 0, 0, 0) : !n && r === 12 ? e.setUTCHours(0, 0, 0, 0) : e.setUTCHours(r, 0, 0, 0), e;
    },
    incompatibleTokens: ["H", "K", "k", "t", "T"]
  },
  // Hour [0-23]
  H: {
    priority: 70,
    parse: function(e, t, r, i) {
      switch (t) {
        case "H":
          return W(H.hour23h, e);
        case "Ho":
          return r.ordinalNumber(e, {
            unit: "hour"
          });
        default:
          return B(t.length, e);
      }
    },
    validate: function(e, t, r) {
      return t >= 0 && t <= 23;
    },
    set: function(e, t, r, i) {
      return e.setUTCHours(r, 0, 0, 0), e;
    },
    incompatibleTokens: ["a", "b", "h", "K", "k", "t", "T"]
  },
  // Hour [0-11]
  K: {
    priority: 70,
    parse: function(e, t, r, i) {
      switch (t) {
        case "K":
          return W(H.hour11h, e);
        case "Ko":
          return r.ordinalNumber(e, {
            unit: "hour"
          });
        default:
          return B(t.length, e);
      }
    },
    validate: function(e, t, r) {
      return t >= 0 && t <= 11;
    },
    set: function(e, t, r, i) {
      var n = e.getUTCHours() >= 12;
      return n && r < 12 ? e.setUTCHours(r + 12, 0, 0, 0) : e.setUTCHours(r, 0, 0, 0), e;
    },
    incompatibleTokens: ["a", "b", "h", "H", "k", "t", "T"]
  },
  // Hour [1-24]
  k: {
    priority: 70,
    parse: function(e, t, r, i) {
      switch (t) {
        case "k":
          return W(H.hour24h, e);
        case "ko":
          return r.ordinalNumber(e, {
            unit: "hour"
          });
        default:
          return B(t.length, e);
      }
    },
    validate: function(e, t, r) {
      return t >= 1 && t <= 24;
    },
    set: function(e, t, r, i) {
      var n = r <= 24 ? r % 24 : r;
      return e.setUTCHours(n, 0, 0, 0), e;
    },
    incompatibleTokens: ["a", "b", "h", "H", "K", "t", "T"]
  },
  // Minute
  m: {
    priority: 60,
    parse: function(e, t, r, i) {
      switch (t) {
        case "m":
          return W(H.minute, e);
        case "mo":
          return r.ordinalNumber(e, {
            unit: "minute"
          });
        default:
          return B(t.length, e);
      }
    },
    validate: function(e, t, r) {
      return t >= 0 && t <= 59;
    },
    set: function(e, t, r, i) {
      return e.setUTCMinutes(r, 0, 0), e;
    },
    incompatibleTokens: ["t", "T"]
  },
  // Second
  s: {
    priority: 50,
    parse: function(e, t, r, i) {
      switch (t) {
        case "s":
          return W(H.second, e);
        case "so":
          return r.ordinalNumber(e, {
            unit: "second"
          });
        default:
          return B(t.length, e);
      }
    },
    validate: function(e, t, r) {
      return t >= 0 && t <= 59;
    },
    set: function(e, t, r, i) {
      return e.setUTCSeconds(r, 0), e;
    },
    incompatibleTokens: ["t", "T"]
  },
  // Fraction of second
  S: {
    priority: 30,
    parse: function(e, t, r, i) {
      var n = function(o) {
        return Math.floor(o * Math.pow(10, -t.length + 3));
      };
      return B(t.length, e, n);
    },
    set: function(e, t, r, i) {
      return e.setUTCMilliseconds(r), e;
    },
    incompatibleTokens: ["t", "T"]
  },
  // Timezone (ISO-8601. +00:00 is `'Z'`)
  X: {
    priority: 10,
    parse: function(e, t, r, i) {
      switch (t) {
        case "X":
          return pe(de.basicOptionalMinutes, e);
        case "XX":
          return pe(de.basic, e);
        case "XXXX":
          return pe(de.basicOptionalSeconds, e);
        case "XXXXX":
          return pe(de.extendedOptionalSeconds, e);
        case "XXX":
        default:
          return pe(de.extended, e);
      }
    },
    set: function(e, t, r, i) {
      return t.timestampIsSet ? e : new Date(e.getTime() - r);
    },
    incompatibleTokens: ["t", "T", "x"]
  },
  // Timezone (ISO-8601)
  x: {
    priority: 10,
    parse: function(e, t, r, i) {
      switch (t) {
        case "x":
          return pe(de.basicOptionalMinutes, e);
        case "xx":
          return pe(de.basic, e);
        case "xxxx":
          return pe(de.basicOptionalSeconds, e);
        case "xxxxx":
          return pe(de.extendedOptionalSeconds, e);
        case "xxx":
        default:
          return pe(de.extended, e);
      }
    },
    set: function(e, t, r, i) {
      return t.timestampIsSet ? e : new Date(e.getTime() - r);
    },
    incompatibleTokens: ["t", "T", "X"]
  },
  // Seconds timestamp
  t: {
    priority: 40,
    parse: function(e, t, r, i) {
      return Qr(e);
    },
    set: function(e, t, r, i) {
      return [new Date(r * 1e3), {
        timestampIsSet: !0
      }];
    },
    incompatibleTokens: "*"
  },
  // Milliseconds timestamp
  T: {
    priority: 20,
    parse: function(e, t, r, i) {
      return Qr(e);
    },
    set: function(e, t, r, i) {
      return [new Date(r), {
        timestampIsSet: !0
      }];
    },
    incompatibleTokens: "*"
  }
};
const Lo = Io;
var No = 10, Uo = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g, Yo = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g, qo = /^'([^]*?)'?$/, Fo = /''/g, Wo = /\S/, Bo = /[a-zA-Z]/;
function Ao(e, t, r, i) {
  f(3, arguments);
  var n = String(e), o = String(t), a = i || {}, s = a.locale || ci;
  if (!s.match)
    throw new RangeError("locale must contain match property");
  var c = s.options && s.options.firstWeekContainsDate, u = c == null ? 1 : T(c), d = a.firstWeekContainsDate == null ? u : T(a.firstWeekContainsDate);
  if (!(d >= 1 && d <= 7))
    throw new RangeError("firstWeekContainsDate must be between 1 and 7 inclusively");
  var v = s.options && s.options.weekStartsOn, D = v == null ? 0 : T(v), h = a.weekStartsOn == null ? D : T(a.weekStartsOn);
  if (!(h >= 0 && h <= 6))
    throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
  if (o === "")
    return n === "" ? b(r) : /* @__PURE__ */ new Date(NaN);
  var $ = {
    firstWeekContainsDate: d,
    weekStartsOn: h,
    locale: s
  }, O = [{
    priority: No,
    subPriority: -1,
    set: Ho,
    index: 0
  }], g, y = o.match(Yo).map(function(N) {
    var K = N[0];
    if (K === "p" || K === "P") {
      var ie = vi[K];
      return ie(N, s.formatLong, $);
    }
    return N;
  }).join("").match(Uo), _ = [];
  for (g = 0; g < y.length; g++) {
    var m = y[g];
    !a.useAdditionalWeekYearTokens && mi(m) && Rt(m, o, e), !a.useAdditionalDayOfYearTokens && gi(m) && Rt(m, o, e);
    var w = m[0], x = Lo[w];
    if (x) {
      var C = x.incompatibleTokens;
      if (Array.isArray(C)) {
        for (var L = void 0, q = 0; q < _.length; q++) {
          var F = _[q].token;
          if (C.indexOf(F) !== -1 || F === w) {
            L = _[q];
            break;
          }
        }
        if (L)
          throw new RangeError("The format string mustn't contain `".concat(L.fullToken, "` and `").concat(m, "` at the same time"));
      } else if (x.incompatibleTokens === "*" && _.length)
        throw new RangeError("The format string mustn't contain `".concat(m, "` and any other token at the same time"));
      _.push({
        token: w,
        fullToken: m
      });
      var Y = x.parse(n, m, s.match, $);
      if (!Y)
        return /* @__PURE__ */ new Date(NaN);
      O.push({
        priority: x.priority,
        subPriority: x.subPriority || 0,
        set: x.set,
        validate: x.validate,
        value: Y.value,
        index: O.length
      }), n = Y.rest;
    } else {
      if (w.match(Bo))
        throw new RangeError("Format string contains an unescaped latin alphabet character `" + w + "`");
      if (m === "''" ? m = "'" : w === "'" && (m = jo(m)), n.indexOf(m) === 0)
        n = n.slice(m.length);
      else
        return /* @__PURE__ */ new Date(NaN);
    }
  }
  if (n.length > 0 && Wo.test(n))
    return /* @__PURE__ */ new Date(NaN);
  var S = O.map(function(N) {
    return N.priority;
  }).sort(function(N, K) {
    return K - N;
  }).filter(function(N, K, ie) {
    return ie.indexOf(N) === K;
  }).map(function(N) {
    return O.filter(function(K) {
      return K.priority === N;
    }).sort(function(K, ie) {
      return ie.subPriority - K.subPriority;
    });
  }).map(function(N) {
    return N[0];
  }), R = b(r);
  if (isNaN(R))
    return /* @__PURE__ */ new Date(NaN);
  var A = ui(R, li(R)), ue = {};
  for (g = 0; g < S.length; g++) {
    var re = S[g];
    if (re.validate && !re.validate(A, re.value, $))
      return /* @__PURE__ */ new Date(NaN);
    var z = re.set(A, ue, re.value, $);
    z[0] ? (A = z[0], xo(ue, z[1])) : A = z;
  }
  return A;
}
function Ho(e, t) {
  if (t.timestampIsSet)
    return e;
  var r = /* @__PURE__ */ new Date(0);
  return r.setFullYear(e.getUTCFullYear(), e.getUTCMonth(), e.getUTCDate()), r.setHours(e.getUTCHours(), e.getUTCMinutes(), e.getUTCSeconds(), e.getUTCMilliseconds()), r;
}
function jo(e) {
  return e.match(qo)[1].replace(Fo, "'");
}
function Ro(e, t) {
  f(2, arguments);
  var r = b(e), i = b(t);
  return r.getFullYear() === i.getFullYear() && r.getMonth() === i.getMonth();
}
function Ft(e, t) {
  f(2, arguments);
  var r = b(e), i = b(t);
  return r.getFullYear() === i.getFullYear();
}
function Wt(e, t) {
  f(2, arguments);
  var r = T(t);
  return $e(e, -r);
}
const zo = `.container{display:flex;max-width:400px;flex-direction:column;border-radius:.5rem;overflow:hidden;border:1px solid var(--input-border-color)}.calendar-header{user-select:none;background-color:var(--primary-color);color:var(--primary-text-color);display:flex;justify-content:space-between;align-items:center;padding:10px}.calendar-header div{flex-grow:1;text-align:center;cursor:pointer}.calendar-header svg{fill:var(--primary-text-color);cursor:pointer}.calendar-body{flex-grow:1;background-color:var(--background-color);display:grid;align-items:center;gap:5px;padding:5px}.calendar-body.month{grid-template-columns:40px repeat(7,1fr);grid-template-rows:auto}.calendar-body.year,.calendar-body.decade{grid-template-columns:repeat(4,1fr);grid-template-rows:repeat(4,1fr)}.cell-container{display:flex;align-items:center;justify-content:center;aspect-ratio:1}.cell{position:relative;border:solid 1px transparent;box-sizing:border-box;border-radius:100%;height:100%;flex:1;display:flex;justify-content:center;align-items:center;cursor:pointer;user-select:none;padding:10px}.cell:hover{background-color:var(--background-color-hover)}.cell.week-number,.cell.day-name{border-radius:0;cursor:default;pointer-events:none}.cell.week-number{font-size:.8em;color:#00000080}.cell.day-name{font-weight:700}.cell.other-month,.cell.other-year{color:var(--input-disabled-color)}.cell.selected-date{background-color:var(--primary-color);color:var(--primary-text-color)}.cell.current-date{border-color:var(--background-color-hover);box-shadow:0 0 0 2pt var(--background-color-hover)}.cell.current-date.selected-date{box-shadow:0 0 0 2pt var(--background-color-hover)}.cell>.indicator-container{position:absolute;height:6px;display:flex;bottom:6px;gap:3px}.cell>.indicator-container>.indicator{width:6px;border-radius:100%}.year-grid{display:grid;height:100%;grid-template-columns:1fr 1fr 1fr 1fr}.year-grid>.cell{height:2.5em}.calendar-caption{display:flex;flex-wrap:wrap;justify-content:space-evenly;padding:10px;gap:10px;background-color:#fff}.caption{display:flex;align-items:center;gap:5px}.caption>.indicator{height:6px;width:6px;border-radius:100%}.caption>.text{font-size:.8em}
`;
var Vo = Object.defineProperty, Qo = Object.getOwnPropertyDescriptor, Pe = (e, t, r, i) => {
  for (var n = i > 1 ? void 0 : i ? Qo(t, r) : t, o = e.length - 1, a; o >= 0; o--)
    (a = e[o]) && (n = (i ? a(t, r, n) : a(n)) || n);
  return i && n && Vo(t, r, n), n;
};
let le = class extends U {
  constructor() {
    super(...arguments), this.monthNames = ["Januar", "Februar", "März", "April", "Mai", "Juni", "Juli", "August", "September", "Oktober", "November", "Dezember"], this.monthNamesShort = [
      ["Jan", "Feb", "Mrz", "Apr"],
      ["Mai", "Jun", "Jul", "Aug"],
      ["Sep", "Okt", "Nov", "Dez"]
    ], this.weekNames = ["Mo", "Di", "Mi", "Do", "Fr", "Sa", "So"], this.viewType = "month", this.viewDate = /* @__PURE__ */ new Date(), this._dayColoringMap = /* @__PURE__ */ new Map(), this._monthColoringMap = /* @__PURE__ */ new Map(), this._yearColoringMap = /* @__PURE__ */ new Map(), this._colorMapCaption = /* @__PURE__ */ new Map(), this.currentDate = /* @__PURE__ */ new Date(), this.selectedDateCss = "selected-date", this.currentDateCss = "current-date";
  }
  get value() {
    return this._value === void 0 ? "" : he(this._value, "yyyy-MM-dd");
  }
  set value(e) {
    e !== "" && (this._value = Ao(e, "yyyy-MM-dd", /* @__PURE__ */ new Date()), this.viewDate = new Date(this._value));
  }
  get dayColoringMap() {
    return this._dayColoringMap;
  }
  set dayColoringMap(e) {
    this._dayColoringMap = this.buildMap(e);
  }
  get monthColoringMap() {
    return this._monthColoringMap;
  }
  set monthColoringMap(e) {
    this._monthColoringMap = this.buildMap(e);
  }
  get yearColoringMap() {
    return this._yearColoringMap;
  }
  set yearColoringMap(e) {
    this._yearColoringMap = this.buildMap(e);
  }
  buildMap(e) {
    const t = /* @__PURE__ */ new Map();
    return Object.keys(e).forEach((i) => {
      t.set(i, e[i]);
    }), t;
  }
  get colorMapCaption() {
    return this._colorMapCaption;
  }
  set colorMapCaption(e) {
    this._colorMapCaption = this.buildMap(e);
  }
  render() {
    return p`
            <div class="container">
                <div class="calendar-header ${this.viewType}">
                    ${this.renderPickerHeader()}
                </div>
                <div class="calendar-body ${this.viewType}">
                    ${this.renderPickerBody()}
                </div>
                <div class="calendar-caption">
                    ${this.renderCaption()}
                </div>
            </div>
        `;
  }
  updated() {
    this.scrollSelectedYearIntoView();
  }
  firstUpdated() {
    this.firePeriodEvent();
  }
  scrollSelectedYearIntoView() {
    if (this.viewType == "decade" && this.shadowRoot) {
      const e = this.shadowRoot.querySelector(".calendar-body");
      if (e && e.scrollTop == 0) {
        let t = e.querySelector("." + this.selectedDateCss);
        t || (t = e.querySelector("." + this.currentDateCss)), t == null || t.scrollIntoView({ block: "nearest", inline: "start" });
      }
    }
  }
  renderPickerHeader() {
    return p`
                <svg xmlns="http://www.w3.org/2000/svg" @click=${this.arrowLeftClicked} viewBox="0 0 24 24" fill="black" width="1.5em" height="1.5em" >
                    <path d="M0 0h24v24H0V0z" fill="none"/>
                    <path d="M15.41 16.59L10.83 12l4.58-4.59L14 6l-6 6 6 6 1.41-1.41z"/>
                </svg>
                ${this.renderHeaderMonthYear()}
                <svg xmlns="http://www.w3.org/2000/svg" @click=${this.arrowRightClicked} viewBox="0 0 24 24" fill="black" width="1.5em" height="1.5em" >
                    <path d="M0 0h24v24H0V0z" fill="none"/>
                    <path d="M8.59 16.59L13.17 12 8.59 7.41 10 6l6 6-6 6-1.41-1.41z"/>
                </svg>
            </div>
        `;
  }
  renderHeaderMonthYear() {
    return this.viewType === "month" ? p` 
                <div @click=${() => this.onMonthSelectionClicked()}>${this.monthNames[this.viewDate.getMonth()]}</div>
                <div @click=${() => this.onYearSelectionClicked()}>${this.viewDate.getFullYear()}</div>` : this.viewType === "year" ? p`<div @click=${() => this.onYearSelectionClicked()}>${this.viewDate.getFullYear()}</div>` : p``;
  }
  renderPickerBody() {
    switch (this.viewType) {
      case "month":
        return this.renderMonthView();
      case "year":
        return this.renderYearView();
      case "decade":
        return this.renderDecadeView();
    }
  }
  renderMonthView() {
    const e = rt(jr(this.viewDate), { weekStartsOn: 1 }), t = ur(Hr(this.viewDate), { weekStartsOn: 1 }), r = hn({ start: e, end: t }, { weekStartsOn: 1 }), i = [];
    return i.push(p`
            <div class="cell week-number">KW</div>
            ${this.weekNames.map((n) => this.renderDayName(n))}`), r.forEach((n) => i.push(this.renderWeek(n))), i;
  }
  renderDayName(e) {
    return p`<div class="cell day-name">${e}</div>`;
  }
  isSameDay(e, t) {
    return e === void 0 || t === void 0 ? !1 : Ar(e, t);
  }
  isSameYear(e, t) {
    return e === void 0 || t === void 0 ? !1 : Ft(e, t);
  }
  renderWeek(e) {
    const t = pn({ start: rt(e, { weekStartsOn: 1 }), end: ur(e, { weekStartsOn: 1 }) }).map((r) => {
      const i = this.dayColoringMap.has(he(r, "yyyy-MM-dd")) ? this.dayColoringMap.get(he(r, "yyyy-MM-dd")) : [];
      return p`
                <div class="cell-container">
                    <div class="cell
                        ${Ro(r, this.viewDate) ? "same-month" : "other-month"}
                        ${Ar(r, this.currentDate) ? this.currentDateCss : ""}
                        ${this.isSameDay(r, this._value) ? this.selectedDateCss : ""}" 
                        @click=${() => this.onDayClicked(r)}
                        >
                        <div>${r.getDate()}</div>
                        <div class="indicator-container">
                            ${i.map(this.createIncatorElement)}
                        </div>
                    </div>
                </div>`;
    });
    return p`
            <div class="cell-container">
                <div class="cell week-number" @click=${() => this.onCalendarWeekClicked(e)}>${Do(e)}</div>
            </div>
            ${t}
            `;
  }
  createIncatorElement(e) {
    return p`
            <div class="indicator" style="background-color: ${e}"></div>
        `;
  }
  renderYearView() {
    const e = [];
    return this.monthNamesShort.forEach((t, r) => {
      e.push(p`
                    ${t.map((i, n) => this.renderMonthCell(i, r * 4 + n, !0))}
                `);
    }), e.push(p`${this.monthNamesShort[0].map((t, r) => this.renderMonthCell(t, r, !1))}`), e;
  }
  renderMonthCell(e, t, r) {
    var a;
    const i = r ? this.viewDate : $e(this.viewDate, 1), n = new Date(this.viewDate.getFullYear() + (r ? 0 : 1), t, 1), o = this.monthColoringMap.has(he(n, "yyyy-MM")) ? this.monthColoringMap.get(he(n, "yyyy-MM")) : [];
    return p`
        <div class="cell-container">
            <div class="cell ${r ? "same-year" : "other-year"}
                ${t === this.currentDate.getMonth() && Ft(this.currentDate, i) ? this.currentDateCss : ""}
                ${t === ((a = this._value) == null ? void 0 : a.getMonth()) && Ft(this._value, i) ? this.selectedDateCss : ""}" 
                @click=${() => this.onMonthClicked(t, !r)}>
                <div>${e}</div>
                <div class="indicator-container">
                    ${o.map(this.createIncatorElement)}
                </div>
            </div>
        </div>`;
  }
  renderDecadeView() {
    const e = gn({ start: Wt(this.viewDate, 9), end: $e(this.viewDate, 6) });
    return [
      p`${e.map((t) => this.renderYearCell(t))}`
    ];
  }
  renderYearCell(e) {
    let t = Ft(this.currentDate, e) ? this.currentDateCss : "";
    t += " ", t += this.isSameYear(this._value, e) ? this.selectedDateCss : "";
    const r = this.yearColoringMap.has(he(e, "yyyy")) ? this.yearColoringMap.get(he(e, "yyyy")) : [];
    return p`
        <div class="cell-container">
            <div class="cell ${t}" 
                @click=${() => this.onYearClicked(e)}>
                <div>${e.getFullYear()}</div>
                <div class="indicator-container">
                    ${r.map(this.createIncatorElement)}
                </div>
            </div>
        </div>
    `;
  }
  arrowLeftClicked() {
    switch (this.viewType) {
      case "month":
        this.viewDate = Co(this.viewDate, 1);
        break;
      case "year":
        this.viewDate = Wt(this.viewDate, 1);
        break;
      case "decade":
        this.viewDate = Wt(this.viewDate, 4);
        break;
    }
    this.firePeriodEvent();
  }
  arrowRightClicked() {
    switch (this.viewType) {
      case "month":
        this.viewDate = xr(this.viewDate, 1);
        break;
      case "year":
        this.viewDate = $e(this.viewDate, 1);
        break;
      case "decade":
        this.viewDate = $e(this.viewDate, 4);
        break;
    }
    this.firePeriodEvent();
  }
  renderCaption() {
    const e = [];
    for (const [t, r] of this.colorMapCaption.entries())
      e.push(this.renderCaptionElement(t, r));
    return e;
  }
  renderCaptionElement(e, t) {
    return p`
            <div class="caption">
                <div class="indicator" style="background-color: ${e}"></div>
                <div class="text">${t}</div>
            </div>
        
        `;
  }
  onMonthSelectionClicked() {
    this.viewType = "year", this.firePeriodEvent();
  }
  onYearSelectionClicked() {
    this.viewType = "decade", this.firePeriodEvent();
  }
  onDayClicked(e) {
    this.viewDate = e, this._value = e, this.fireSelectionEvent();
  }
  onCalendarWeekClicked(e) {
    this._value = e;
  }
  onMonthClicked(e, t = !1) {
    this.viewType = "month", this.viewDate.setMonth(e), t && (this.viewDate = $e(this.viewDate, 1)), this._value && (this._value.setMonth(e), t && (this._value = $e(this._value, 1))), this.firePeriodEvent();
  }
  onYearClicked(e) {
    this.viewDate.setFullYear(e.getFullYear()), this._value ? (this._value.setFullYear(e.getFullYear()), this.viewType = "month", this.fireSelectionEvent()) : this.viewType = "year", this.firePeriodEvent();
  }
  fireSelectionEvent() {
    this.dispatchEvent(new CustomEvent("change"));
  }
  firePeriodEvent() {
    let e, t;
    if (this.viewType == "month")
      e = rt(jr(this.viewDate), { weekStartsOn: 1 }), t = ur(Hr(this.viewDate), { weekStartsOn: 1 });
    else if (this.viewType == "year")
      e = fn(this.viewDate), t = vn(this.viewDate);
    else if (this.viewType == "decade")
      e = Wt(this.viewDate, 70), t = $e(this.viewDate, 10);
    else
      return;
    this.dispatchEvent(new CustomEvent("period", {
      detail: {
        startDate: he(e, "yyyy-MM-dd"),
        endDate: he(t, "yyyy-MM-dd"),
        period: this.viewType
      },
      bubbles: !0,
      composed: !0
    }));
  }
};
le.styles = [_e(zo)];
Pe([
  V()
], le.prototype, "viewType", 2);
Pe([
  l({ attribute: !1 })
], le.prototype, "viewDate", 2);
Pe([
  V()
], le.prototype, "_value", 2);
Pe([
  l()
], le.prototype, "value", 1);
Pe([
  V()
], le.prototype, "_dayColoringMap", 2);
Pe([
  V()
], le.prototype, "_monthColoringMap", 2);
Pe([
  V()
], le.prototype, "_yearColoringMap", 2);
Pe([
  V()
], le.prototype, "_colorMapCaption", 2);
le = Pe([
  P("druide-date-picker")
], le);
var ne = "top", ve = "bottom", De = "right", se = "left", Gt = "auto", Kt = [ne, ve, De, se], ot = "start", Ct = "end", Xo = "clippingParents", bi = "viewport", Ot = "popper", Go = "reference", Kr = /* @__PURE__ */ Kt.reduce(function(e, t) {
  return e.concat([t + "-" + ot, t + "-" + Ct]);
}, []), wi = /* @__PURE__ */ [].concat(Kt, [Gt]).reduce(function(e, t) {
  return e.concat([t, t + "-" + ot, t + "-" + Ct]);
}, []), Ko = "beforeRead", Zo = "read", Jo = "afterRead", ea = "beforeMain", ta = "main", ra = "afterMain", ia = "beforeWrite", na = "write", oa = "afterWrite", fr = [Ko, Zo, Jo, ea, ta, ra, ia, na, oa];
function ge(e) {
  return e ? (e.nodeName || "").toLowerCase() : null;
}
function ae(e) {
  if (e == null)
    return window;
  if (e.toString() !== "[object Window]") {
    var t = e.ownerDocument;
    return t && t.defaultView || window;
  }
  return e;
}
function ze(e) {
  var t = ae(e).Element;
  return e instanceof t || e instanceof Element;
}
function oe(e) {
  var t = ae(e).HTMLElement;
  return e instanceof t || e instanceof HTMLElement;
}
function Dr(e) {
  if (typeof ShadowRoot > "u")
    return !1;
  var t = ae(e).ShadowRoot;
  return e instanceof t || e instanceof ShadowRoot;
}
function aa(e) {
  var t = e.state;
  Object.keys(t.elements).forEach(function(r) {
    var i = t.styles[r] || {}, n = t.attributes[r] || {}, o = t.elements[r];
    !oe(o) || !ge(o) || (Object.assign(o.style, i), Object.keys(n).forEach(function(a) {
      var s = n[a];
      s === !1 ? o.removeAttribute(a) : o.setAttribute(a, s === !0 ? "" : s);
    }));
  });
}
function sa(e) {
  var t = e.state, r = {
    popper: {
      position: t.options.strategy,
      left: "0",
      top: "0",
      margin: "0"
    },
    arrow: {
      position: "absolute"
    },
    reference: {}
  };
  return Object.assign(t.elements.popper.style, r.popper), t.styles = r, t.elements.arrow && Object.assign(t.elements.arrow.style, r.arrow), function() {
    Object.keys(t.elements).forEach(function(i) {
      var n = t.elements[i], o = t.attributes[i] || {}, a = Object.keys(t.styles.hasOwnProperty(i) ? t.styles[i] : r[i]), s = a.reduce(function(c, u) {
        return c[u] = "", c;
      }, {});
      !oe(n) || !ge(n) || (Object.assign(n.style, s), Object.keys(o).forEach(function(c) {
        n.removeAttribute(c);
      }));
    });
  };
}
const la = {
  name: "applyStyles",
  enabled: !0,
  phase: "write",
  fn: aa,
  effect: sa,
  requires: ["computeStyles"]
};
function fe(e) {
  return e.split("-")[0];
}
var He = Math.max, zt = Math.min, at = Math.round;
function vr() {
  var e = navigator.userAgentData;
  return e != null && e.brands ? e.brands.map(function(t) {
    return t.brand + "/" + t.version;
  }).join(" ") : navigator.userAgent;
}
function yi() {
  return !/^((?!chrome|android).)*safari/i.test(vr());
}
function st(e, t, r) {
  t === void 0 && (t = !1), r === void 0 && (r = !1);
  var i = e.getBoundingClientRect(), n = 1, o = 1;
  t && oe(e) && (n = e.offsetWidth > 0 && at(i.width) / e.offsetWidth || 1, o = e.offsetHeight > 0 && at(i.height) / e.offsetHeight || 1);
  var a = ze(e) ? ae(e) : window, s = a.visualViewport, c = !yi() && r, u = (i.left + (c && s ? s.offsetLeft : 0)) / n, d = (i.top + (c && s ? s.offsetTop : 0)) / o, v = i.width / n, D = i.height / o;
  return {
    width: v,
    height: D,
    top: d,
    right: u + v,
    bottom: d + D,
    left: u,
    x: u,
    y: d
  };
}
function xi(e) {
  var t = st(e), r = e.offsetWidth, i = e.offsetHeight;
  return Math.abs(t.width - r) <= 1 && (r = t.width), Math.abs(t.height - i) <= 1 && (i = t.height), {
    x: e.offsetLeft,
    y: e.offsetTop,
    width: r,
    height: i
  };
}
function ca(e, t) {
  var r = t.getRootNode && t.getRootNode();
  if (e.contains(t))
    return !0;
  if (r && Dr(r)) {
    var i = t;
    do {
      if (i && e.isSameNode(i))
        return !0;
      i = i.parentNode || i.host;
    } while (i);
  }
  return !1;
}
function ce(e) {
  return ae(e).getComputedStyle(e);
}
function ua(e) {
  return ["table", "td", "th"].indexOf(ge(e)) >= 0;
}
function Ue(e) {
  return ((ze(e) ? e.ownerDocument : (
    // $FlowFixMe[prop-missing]
    e.document
  )) || window.document).documentElement;
}
function Zt(e) {
  return ge(e) === "html" ? e : (
    // this is a quicker (but less type safe) way to save quite some bytes from the bundle
    // $FlowFixMe[incompatible-return]
    // $FlowFixMe[prop-missing]
    e.assignedSlot || // step into the shadow DOM of the parent of a slotted node
    e.parentNode || // DOM Element detected
    (Dr(e) ? e.host : null) || // ShadowRoot detected
    // $FlowFixMe[incompatible-call]: HTMLElement is a Node
    Ue(e)
  );
}
function Zr(e) {
  return !oe(e) || // https://github.com/popperjs/popper-core/issues/837
  ce(e).position === "fixed" ? null : e.offsetParent;
}
function da(e) {
  var t = /firefox/i.test(vr()), r = /Trident/i.test(vr());
  if (r && oe(e)) {
    var i = ce(e);
    if (i.position === "fixed")
      return null;
  }
  var n = Zt(e);
  for (Dr(n) && (n = n.host); oe(n) && ["html", "body"].indexOf(ge(n)) < 0; ) {
    var o = ce(n);
    if (o.transform !== "none" || o.perspective !== "none" || o.contain === "paint" || ["transform", "perspective"].indexOf(o.willChange) !== -1 || t && o.willChange === "filter" || t && o.filter && o.filter !== "none")
      return n;
    n = n.parentNode;
  }
  return null;
}
function Jt(e) {
  for (var t = ae(e), r = Zr(e); r && ua(r) && ce(r).position === "static"; )
    r = Zr(r);
  return r && (ge(r) === "html" || ge(r) === "body" && ce(r).position === "static") ? t : r || da(e) || t;
}
function Oi(e) {
  return ["top", "bottom"].indexOf(e) >= 0 ? "x" : "y";
}
function At(e, t, r) {
  return He(e, zt(t, r));
}
function pa(e, t, r) {
  var i = At(e, t, r);
  return i > r ? r : i;
}
function Di() {
  return {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0
  };
}
function ha(e) {
  return Object.assign({}, Di(), e);
}
function fa(e, t) {
  return t.reduce(function(r, i) {
    return r[i] = e, r;
  }, {});
}
function lt(e) {
  return e.split("-")[1];
}
var va = {
  top: "auto",
  right: "auto",
  bottom: "auto",
  left: "auto"
};
function ga(e) {
  var t = e.x, r = e.y, i = window, n = i.devicePixelRatio || 1;
  return {
    x: at(t * n) / n || 0,
    y: at(r * n) / n || 0
  };
}
function Jr(e) {
  var t, r = e.popper, i = e.popperRect, n = e.placement, o = e.variation, a = e.offsets, s = e.position, c = e.gpuAcceleration, u = e.adaptive, d = e.roundOffsets, v = e.isFixed, D = a.x, h = D === void 0 ? 0 : D, $ = a.y, O = $ === void 0 ? 0 : $, g = typeof d == "function" ? d({
    x: h,
    y: O
  }) : {
    x: h,
    y: O
  };
  h = g.x, O = g.y;
  var y = a.hasOwnProperty("x"), _ = a.hasOwnProperty("y"), m = se, w = ne, x = window;
  if (u) {
    var C = Jt(r), L = "clientHeight", q = "clientWidth";
    if (C === ae(r) && (C = Ue(r), ce(C).position !== "static" && s === "absolute" && (L = "scrollHeight", q = "scrollWidth")), C = C, n === ne || (n === se || n === De) && o === Ct) {
      w = ve;
      var F = v && C === x && x.visualViewport ? x.visualViewport.height : (
        // $FlowFixMe[prop-missing]
        C[L]
      );
      O -= F - i.height, O *= c ? 1 : -1;
    }
    if (n === se || (n === ne || n === ve) && o === Ct) {
      m = De;
      var Y = v && C === x && x.visualViewport ? x.visualViewport.width : (
        // $FlowFixMe[prop-missing]
        C[q]
      );
      h -= Y - i.width, h *= c ? 1 : -1;
    }
  }
  var S = Object.assign({
    position: s
  }, u && va), R = d === !0 ? ga({
    x: h,
    y: O
  }) : {
    x: h,
    y: O
  };
  if (h = R.x, O = R.y, c) {
    var A;
    return Object.assign({}, S, (A = {}, A[w] = _ ? "0" : "", A[m] = y ? "0" : "", A.transform = (x.devicePixelRatio || 1) <= 1 ? "translate(" + h + "px, " + O + "px)" : "translate3d(" + h + "px, " + O + "px, 0)", A));
  }
  return Object.assign({}, S, (t = {}, t[w] = _ ? O + "px" : "", t[m] = y ? h + "px" : "", t.transform = "", t));
}
function ma(e) {
  var t = e.state, r = e.options, i = r.gpuAcceleration, n = i === void 0 ? !0 : i, o = r.adaptive, a = o === void 0 ? !0 : o, s = r.roundOffsets, c = s === void 0 ? !0 : s;
  if (process.env.NODE_ENV !== "production") {
    var u = ce(t.elements.popper).transitionProperty || "";
    a && ["transform", "top", "right", "bottom", "left"].some(function(v) {
      return u.indexOf(v) >= 0;
    }) && console.warn(["Popper: Detected CSS transitions on at least one of the following", 'CSS properties: "transform", "top", "right", "bottom", "left".', `

`, 'Disable the "computeStyles" modifier\'s `adaptive` option to allow', "for smooth transitions, or remove these properties from the CSS", "transition declaration on the popper element if only transitioning", "opacity or background-color for example.", `

`, "We recommend using the popper element as a wrapper around an inner", "element that can have any CSS property transitioned for animations."].join(" "));
  }
  var d = {
    placement: fe(t.placement),
    variation: lt(t.placement),
    popper: t.elements.popper,
    popperRect: t.rects.popper,
    gpuAcceleration: n,
    isFixed: t.options.strategy === "fixed"
  };
  t.modifiersData.popperOffsets != null && (t.styles.popper = Object.assign({}, t.styles.popper, Jr(Object.assign({}, d, {
    offsets: t.modifiersData.popperOffsets,
    position: t.options.strategy,
    adaptive: a,
    roundOffsets: c
  })))), t.modifiersData.arrow != null && (t.styles.arrow = Object.assign({}, t.styles.arrow, Jr(Object.assign({}, d, {
    offsets: t.modifiersData.arrow,
    position: "absolute",
    adaptive: !1,
    roundOffsets: c
  })))), t.attributes.popper = Object.assign({}, t.attributes.popper, {
    "data-popper-placement": t.placement
  });
}
const ba = {
  name: "computeStyles",
  enabled: !0,
  phase: "beforeWrite",
  fn: ma,
  data: {}
};
var Bt = {
  passive: !0
};
function wa(e) {
  var t = e.state, r = e.instance, i = e.options, n = i.scroll, o = n === void 0 ? !0 : n, a = i.resize, s = a === void 0 ? !0 : a, c = ae(t.elements.popper), u = [].concat(t.scrollParents.reference, t.scrollParents.popper);
  return o && u.forEach(function(d) {
    d.addEventListener("scroll", r.update, Bt);
  }), s && c.addEventListener("resize", r.update, Bt), function() {
    o && u.forEach(function(d) {
      d.removeEventListener("scroll", r.update, Bt);
    }), s && c.removeEventListener("resize", r.update, Bt);
  };
}
const ya = {
  name: "eventListeners",
  enabled: !0,
  phase: "write",
  fn: function() {
  },
  effect: wa,
  data: {}
};
var xa = {
  left: "right",
  right: "left",
  bottom: "top",
  top: "bottom"
};
function Ht(e) {
  return e.replace(/left|right|bottom|top/g, function(t) {
    return xa[t];
  });
}
var Oa = {
  start: "end",
  end: "start"
};
function ei(e) {
  return e.replace(/start|end/g, function(t) {
    return Oa[t];
  });
}
function Cr(e) {
  var t = ae(e), r = t.pageXOffset, i = t.pageYOffset;
  return {
    scrollLeft: r,
    scrollTop: i
  };
}
function _r(e) {
  return st(Ue(e)).left + Cr(e).scrollLeft;
}
function Da(e, t) {
  var r = ae(e), i = Ue(e), n = r.visualViewport, o = i.clientWidth, a = i.clientHeight, s = 0, c = 0;
  if (n) {
    o = n.width, a = n.height;
    var u = yi();
    (u || !u && t === "fixed") && (s = n.offsetLeft, c = n.offsetTop);
  }
  return {
    width: o,
    height: a,
    x: s + _r(e),
    y: c
  };
}
function Ca(e) {
  var t, r = Ue(e), i = Cr(e), n = (t = e.ownerDocument) == null ? void 0 : t.body, o = He(r.scrollWidth, r.clientWidth, n ? n.scrollWidth : 0, n ? n.clientWidth : 0), a = He(r.scrollHeight, r.clientHeight, n ? n.scrollHeight : 0, n ? n.clientHeight : 0), s = -i.scrollLeft + _r(e), c = -i.scrollTop;
  return ce(n || r).direction === "rtl" && (s += He(r.clientWidth, n ? n.clientWidth : 0) - o), {
    width: o,
    height: a,
    x: s,
    y: c
  };
}
function Tr(e) {
  var t = ce(e), r = t.overflow, i = t.overflowX, n = t.overflowY;
  return /auto|scroll|overlay|hidden/.test(r + n + i);
}
function Ci(e) {
  return ["html", "body", "#document"].indexOf(ge(e)) >= 0 ? e.ownerDocument.body : oe(e) && Tr(e) ? e : Ci(Zt(e));
}
function Dt(e, t) {
  var r;
  t === void 0 && (t = []);
  var i = Ci(e), n = i === ((r = e.ownerDocument) == null ? void 0 : r.body), o = ae(i), a = n ? [o].concat(o.visualViewport || [], Tr(i) ? i : []) : i, s = t.concat(a);
  return n ? s : (
    // $FlowFixMe[incompatible-call]: isBody tells us target will be an HTMLElement here
    s.concat(Dt(Zt(a)))
  );
}
function gr(e) {
  return Object.assign({}, e, {
    left: e.x,
    top: e.y,
    right: e.x + e.width,
    bottom: e.y + e.height
  });
}
function _a(e, t) {
  var r = st(e, !1, t === "fixed");
  return r.top = r.top + e.clientTop, r.left = r.left + e.clientLeft, r.bottom = r.top + e.clientHeight, r.right = r.left + e.clientWidth, r.width = e.clientWidth, r.height = e.clientHeight, r.x = r.left, r.y = r.top, r;
}
function ti(e, t, r) {
  return t === bi ? gr(Da(e, r)) : ze(t) ? _a(t, r) : gr(Ca(Ue(e)));
}
function Ta(e) {
  var t = Dt(Zt(e)), r = ["absolute", "fixed"].indexOf(ce(e).position) >= 0, i = r && oe(e) ? Jt(e) : e;
  return ze(i) ? t.filter(function(n) {
    return ze(n) && ca(n, i) && ge(n) !== "body";
  }) : [];
}
function Pa(e, t, r, i) {
  var n = t === "clippingParents" ? Ta(e) : [].concat(t), o = [].concat(n, [r]), a = o[0], s = o.reduce(function(c, u) {
    var d = ti(e, u, i);
    return c.top = He(d.top, c.top), c.right = zt(d.right, c.right), c.bottom = zt(d.bottom, c.bottom), c.left = He(d.left, c.left), c;
  }, ti(e, a, i));
  return s.width = s.right - s.left, s.height = s.bottom - s.top, s.x = s.left, s.y = s.top, s;
}
function _i(e) {
  var t = e.reference, r = e.element, i = e.placement, n = i ? fe(i) : null, o = i ? lt(i) : null, a = t.x + t.width / 2 - r.width / 2, s = t.y + t.height / 2 - r.height / 2, c;
  switch (n) {
    case ne:
      c = {
        x: a,
        y: t.y - r.height
      };
      break;
    case ve:
      c = {
        x: a,
        y: t.y + t.height
      };
      break;
    case De:
      c = {
        x: t.x + t.width,
        y: s
      };
      break;
    case se:
      c = {
        x: t.x - r.width,
        y: s
      };
      break;
    default:
      c = {
        x: t.x,
        y: t.y
      };
  }
  var u = n ? Oi(n) : null;
  if (u != null) {
    var d = u === "y" ? "height" : "width";
    switch (o) {
      case ot:
        c[u] = c[u] - (t[d] / 2 - r[d] / 2);
        break;
      case Ct:
        c[u] = c[u] + (t[d] / 2 - r[d] / 2);
        break;
    }
  }
  return c;
}
function Pr(e, t) {
  t === void 0 && (t = {});
  var r = t, i = r.placement, n = i === void 0 ? e.placement : i, o = r.strategy, a = o === void 0 ? e.strategy : o, s = r.boundary, c = s === void 0 ? Xo : s, u = r.rootBoundary, d = u === void 0 ? bi : u, v = r.elementContext, D = v === void 0 ? Ot : v, h = r.altBoundary, $ = h === void 0 ? !1 : h, O = r.padding, g = O === void 0 ? 0 : O, y = ha(typeof g != "number" ? g : fa(g, Kt)), _ = D === Ot ? Go : Ot, m = e.rects.popper, w = e.elements[$ ? _ : D], x = Pa(ze(w) ? w : w.contextElement || Ue(e.elements.popper), c, d, a), C = st(e.elements.reference), L = _i({
    reference: C,
    element: m,
    strategy: "absolute",
    placement: n
  }), q = gr(Object.assign({}, m, L)), F = D === Ot ? q : C, Y = {
    top: x.top - F.top + y.top,
    bottom: F.bottom - x.bottom + y.bottom,
    left: x.left - F.left + y.left,
    right: F.right - x.right + y.right
  }, S = e.modifiersData.offset;
  if (D === Ot && S) {
    var R = S[n];
    Object.keys(Y).forEach(function(A) {
      var ue = [De, ve].indexOf(A) >= 0 ? 1 : -1, re = [ne, ve].indexOf(A) >= 0 ? "y" : "x";
      Y[A] += R[re] * ue;
    });
  }
  return Y;
}
function ka(e, t) {
  t === void 0 && (t = {});
  var r = t, i = r.placement, n = r.boundary, o = r.rootBoundary, a = r.padding, s = r.flipVariations, c = r.allowedAutoPlacements, u = c === void 0 ? wi : c, d = lt(i), v = d ? s ? Kr : Kr.filter(function($) {
    return lt($) === d;
  }) : Kt, D = v.filter(function($) {
    return u.indexOf($) >= 0;
  });
  D.length === 0 && (D = v, process.env.NODE_ENV !== "production" && console.error(["Popper: The `allowedAutoPlacements` option did not allow any", "placements. Ensure the `placement` option matches the variation", "of the allowed placements.", 'For example, "auto" cannot be used to allow "bottom-start".', 'Use "auto-start" instead.'].join(" ")));
  var h = D.reduce(function($, O) {
    return $[O] = Pr(e, {
      placement: O,
      boundary: n,
      rootBoundary: o,
      padding: a
    })[fe(O)], $;
  }, {});
  return Object.keys(h).sort(function($, O) {
    return h[$] - h[O];
  });
}
function Sa(e) {
  if (fe(e) === Gt)
    return [];
  var t = Ht(e);
  return [ei(e), t, ei(t)];
}
function Ea(e) {
  var t = e.state, r = e.options, i = e.name;
  if (!t.modifiersData[i]._skip) {
    for (var n = r.mainAxis, o = n === void 0 ? !0 : n, a = r.altAxis, s = a === void 0 ? !0 : a, c = r.fallbackPlacements, u = r.padding, d = r.boundary, v = r.rootBoundary, D = r.altBoundary, h = r.flipVariations, $ = h === void 0 ? !0 : h, O = r.allowedAutoPlacements, g = t.options.placement, y = fe(g), _ = y === g, m = c || (_ || !$ ? [Ht(g)] : Sa(g)), w = [g].concat(m).reduce(function(et, ke) {
      return et.concat(fe(ke) === Gt ? ka(t, {
        placement: ke,
        boundary: d,
        rootBoundary: v,
        padding: u,
        flipVariations: $,
        allowedAutoPlacements: O
      }) : ke);
    }, []), x = t.rects.reference, C = t.rects.popper, L = /* @__PURE__ */ new Map(), q = !0, F = w[0], Y = 0; Y < w.length; Y++) {
      var S = w[Y], R = fe(S), A = lt(S) === ot, ue = [ne, ve].indexOf(R) >= 0, re = ue ? "width" : "height", z = Pr(t, {
        placement: S,
        boundary: d,
        rootBoundary: v,
        altBoundary: D,
        padding: u
      }), N = ue ? A ? De : se : A ? ve : ne;
      x[re] > C[re] && (N = Ht(N));
      var K = Ht(N), ie = [];
      if (o && ie.push(z[R] <= 0), s && ie.push(z[N] <= 0, z[K] <= 0), ie.every(function(et) {
        return et;
      })) {
        F = S, q = !1;
        break;
      }
      L.set(S, ie);
    }
    if (q)
      for (var Lt = $ ? 3 : 1, ar = function(ke) {
        var wt = w.find(function(Ut) {
          var qe = L.get(Ut);
          if (qe)
            return qe.slice(0, ke).every(function(sr) {
              return sr;
            });
        });
        if (wt)
          return F = wt, "break";
      }, bt = Lt; bt > 0; bt--) {
        var Nt = ar(bt);
        if (Nt === "break")
          break;
      }
    t.placement !== F && (t.modifiersData[i]._skip = !0, t.placement = F, t.reset = !0);
  }
}
const $a = {
  name: "flip",
  enabled: !0,
  phase: "main",
  fn: Ea,
  requiresIfExists: ["offset"],
  data: {
    _skip: !1
  }
};
function Ma(e, t, r) {
  var i = fe(e), n = [se, ne].indexOf(i) >= 0 ? -1 : 1, o = typeof r == "function" ? r(Object.assign({}, t, {
    placement: e
  })) : r, a = o[0], s = o[1];
  return a = a || 0, s = (s || 0) * n, [se, De].indexOf(i) >= 0 ? {
    x: s,
    y: a
  } : {
    x: a,
    y: s
  };
}
function Ia(e) {
  var t = e.state, r = e.options, i = e.name, n = r.offset, o = n === void 0 ? [0, 0] : n, a = wi.reduce(function(d, v) {
    return d[v] = Ma(v, t.rects, o), d;
  }, {}), s = a[t.placement], c = s.x, u = s.y;
  t.modifiersData.popperOffsets != null && (t.modifiersData.popperOffsets.x += c, t.modifiersData.popperOffsets.y += u), t.modifiersData[i] = a;
}
const La = {
  name: "offset",
  enabled: !0,
  phase: "main",
  requires: ["popperOffsets"],
  fn: Ia
};
function Na(e) {
  var t = e.state, r = e.name;
  t.modifiersData[r] = _i({
    reference: t.rects.reference,
    element: t.rects.popper,
    strategy: "absolute",
    placement: t.placement
  });
}
const Ua = {
  name: "popperOffsets",
  enabled: !0,
  phase: "read",
  fn: Na,
  data: {}
};
function Ya(e) {
  return e === "x" ? "y" : "x";
}
function qa(e) {
  var t = e.state, r = e.options, i = e.name, n = r.mainAxis, o = n === void 0 ? !0 : n, a = r.altAxis, s = a === void 0 ? !1 : a, c = r.boundary, u = r.rootBoundary, d = r.altBoundary, v = r.padding, D = r.tether, h = D === void 0 ? !0 : D, $ = r.tetherOffset, O = $ === void 0 ? 0 : $, g = Pr(t, {
    boundary: c,
    rootBoundary: u,
    padding: v,
    altBoundary: d
  }), y = fe(t.placement), _ = lt(t.placement), m = !_, w = Oi(y), x = Ya(w), C = t.modifiersData.popperOffsets, L = t.rects.reference, q = t.rects.popper, F = typeof O == "function" ? O(Object.assign({}, t.rects, {
    placement: t.placement
  })) : O, Y = typeof F == "number" ? {
    mainAxis: F,
    altAxis: F
  } : Object.assign({
    mainAxis: 0,
    altAxis: 0
  }, F), S = t.modifiersData.offset ? t.modifiersData.offset[t.placement] : null, R = {
    x: 0,
    y: 0
  };
  if (C) {
    if (o) {
      var A, ue = w === "y" ? ne : se, re = w === "y" ? ve : De, z = w === "y" ? "height" : "width", N = C[w], K = N + g[ue], ie = N - g[re], Lt = h ? -q[z] / 2 : 0, ar = _ === ot ? L[z] : q[z], bt = _ === ot ? -q[z] : -L[z], Nt = t.elements.arrow, et = h && Nt ? xi(Nt) : {
        width: 0,
        height: 0
      }, ke = t.modifiersData["arrow#persistent"] ? t.modifiersData["arrow#persistent"].padding : Di(), wt = ke[ue], Ut = ke[re], qe = At(0, L[z], et[z]), sr = m ? L[z] / 2 - Lt - qe - wt - Y.mainAxis : ar - qe - wt - Y.mainAxis, Ei = m ? -L[z] / 2 + Lt + qe + Ut + Y.mainAxis : bt + qe + Ut + Y.mainAxis, lr = t.elements.arrow && Jt(t.elements.arrow), $i = lr ? w === "y" ? lr.clientTop || 0 : lr.clientLeft || 0 : 0, Mr = (A = S == null ? void 0 : S[w]) != null ? A : 0, Mi = N + sr - Mr - $i, Ii = N + Ei - Mr, Ir = At(h ? zt(K, Mi) : K, N, h ? He(ie, Ii) : ie);
      C[w] = Ir, R[w] = Ir - N;
    }
    if (s) {
      var Lr, Li = w === "x" ? ne : se, Ni = w === "x" ? ve : De, Fe = C[x], Yt = x === "y" ? "height" : "width", Nr = Fe + g[Li], Ur = Fe - g[Ni], cr = [ne, se].indexOf(y) !== -1, Yr = (Lr = S == null ? void 0 : S[x]) != null ? Lr : 0, qr = cr ? Nr : Fe - L[Yt] - q[Yt] - Yr + Y.altAxis, Fr = cr ? Fe + L[Yt] + q[Yt] - Yr - Y.altAxis : Ur, Wr = h && cr ? pa(qr, Fe, Fr) : At(h ? qr : Nr, Fe, h ? Fr : Ur);
      C[x] = Wr, R[x] = Wr - Fe;
    }
    t.modifiersData[i] = R;
  }
}
const Ti = {
  name: "preventOverflow",
  enabled: !0,
  phase: "main",
  fn: qa,
  requiresIfExists: ["offset"]
};
function Fa(e) {
  return {
    scrollLeft: e.scrollLeft,
    scrollTop: e.scrollTop
  };
}
function Wa(e) {
  return e === ae(e) || !oe(e) ? Cr(e) : Fa(e);
}
function Ba(e) {
  var t = e.getBoundingClientRect(), r = at(t.width) / e.offsetWidth || 1, i = at(t.height) / e.offsetHeight || 1;
  return r !== 1 || i !== 1;
}
function Aa(e, t, r) {
  r === void 0 && (r = !1);
  var i = oe(t), n = oe(t) && Ba(t), o = Ue(t), a = st(e, n, r), s = {
    scrollLeft: 0,
    scrollTop: 0
  }, c = {
    x: 0,
    y: 0
  };
  return (i || !i && !r) && ((ge(t) !== "body" || // https://github.com/popperjs/popper-core/issues/1078
  Tr(o)) && (s = Wa(t)), oe(t) ? (c = st(t, !0), c.x += t.clientLeft, c.y += t.clientTop) : o && (c.x = _r(o))), {
    x: a.left + s.scrollLeft - c.x,
    y: a.top + s.scrollTop - c.y,
    width: a.width,
    height: a.height
  };
}
function Ha(e) {
  var t = /* @__PURE__ */ new Map(), r = /* @__PURE__ */ new Set(), i = [];
  e.forEach(function(o) {
    t.set(o.name, o);
  });
  function n(o) {
    r.add(o.name);
    var a = [].concat(o.requires || [], o.requiresIfExists || []);
    a.forEach(function(s) {
      if (!r.has(s)) {
        var c = t.get(s);
        c && n(c);
      }
    }), i.push(o);
  }
  return e.forEach(function(o) {
    r.has(o.name) || n(o);
  }), i;
}
function ja(e) {
  var t = Ha(e);
  return fr.reduce(function(r, i) {
    return r.concat(t.filter(function(n) {
      return n.phase === i;
    }));
  }, []);
}
function Ra(e) {
  var t;
  return function() {
    return t || (t = new Promise(function(r) {
      Promise.resolve().then(function() {
        t = void 0, r(e());
      });
    })), t;
  };
}
function Ee(e) {
  for (var t = arguments.length, r = new Array(t > 1 ? t - 1 : 0), i = 1; i < t; i++)
    r[i - 1] = arguments[i];
  return [].concat(r).reduce(function(n, o) {
    return n.replace(/%s/, o);
  }, e);
}
var We = 'Popper: modifier "%s" provided an invalid %s property, expected %s but got %s', za = 'Popper: modifier "%s" requires "%s", but "%s" modifier is not available', ri = ["name", "enabled", "phase", "fn", "effect", "requires", "options"];
function Va(e) {
  e.forEach(function(t) {
    [].concat(Object.keys(t), ri).filter(function(r, i, n) {
      return n.indexOf(r) === i;
    }).forEach(function(r) {
      switch (r) {
        case "name":
          typeof t.name != "string" && console.error(Ee(We, String(t.name), '"name"', '"string"', '"' + String(t.name) + '"'));
          break;
        case "enabled":
          typeof t.enabled != "boolean" && console.error(Ee(We, t.name, '"enabled"', '"boolean"', '"' + String(t.enabled) + '"'));
          break;
        case "phase":
          fr.indexOf(t.phase) < 0 && console.error(Ee(We, t.name, '"phase"', "either " + fr.join(", "), '"' + String(t.phase) + '"'));
          break;
        case "fn":
          typeof t.fn != "function" && console.error(Ee(We, t.name, '"fn"', '"function"', '"' + String(t.fn) + '"'));
          break;
        case "effect":
          t.effect != null && typeof t.effect != "function" && console.error(Ee(We, t.name, '"effect"', '"function"', '"' + String(t.fn) + '"'));
          break;
        case "requires":
          t.requires != null && !Array.isArray(t.requires) && console.error(Ee(We, t.name, '"requires"', '"array"', '"' + String(t.requires) + '"'));
          break;
        case "requiresIfExists":
          Array.isArray(t.requiresIfExists) || console.error(Ee(We, t.name, '"requiresIfExists"', '"array"', '"' + String(t.requiresIfExists) + '"'));
          break;
        case "options":
        case "data":
          break;
        default:
          console.error('PopperJS: an invalid property has been provided to the "' + t.name + '" modifier, valid properties are ' + ri.map(function(i) {
            return '"' + i + '"';
          }).join(", ") + '; but "' + r + '" was provided.');
      }
      t.requires && t.requires.forEach(function(i) {
        e.find(function(n) {
          return n.name === i;
        }) == null && console.error(Ee(za, String(t.name), i, i));
      });
    });
  });
}
function Qa(e, t) {
  var r = /* @__PURE__ */ new Set();
  return e.filter(function(i) {
    var n = t(i);
    if (!r.has(n))
      return r.add(n), !0;
  });
}
function Xa(e) {
  var t = e.reduce(function(r, i) {
    var n = r[i.name];
    return r[i.name] = n ? Object.assign({}, n, i, {
      options: Object.assign({}, n.options, i.options),
      data: Object.assign({}, n.data, i.data)
    }) : i, r;
  }, {});
  return Object.keys(t).map(function(r) {
    return t[r];
  });
}
var ii = "Popper: Invalid reference or popper argument provided. They must be either a DOM element or virtual element.", Ga = "Popper: An infinite loop in the modifiers cycle has been detected! The cycle has been interrupted to prevent a browser crash.", ni = {
  placement: "bottom",
  modifiers: [],
  strategy: "absolute"
};
function oi() {
  for (var e = arguments.length, t = new Array(e), r = 0; r < e; r++)
    t[r] = arguments[r];
  return !t.some(function(i) {
    return !(i && typeof i.getBoundingClientRect == "function");
  });
}
function Ka(e) {
  e === void 0 && (e = {});
  var t = e, r = t.defaultModifiers, i = r === void 0 ? [] : r, n = t.defaultOptions, o = n === void 0 ? ni : n;
  return function(s, c, u) {
    u === void 0 && (u = o);
    var d = {
      placement: "bottom",
      orderedModifiers: [],
      options: Object.assign({}, ni, o),
      modifiersData: {},
      elements: {
        reference: s,
        popper: c
      },
      attributes: {},
      styles: {}
    }, v = [], D = !1, h = {
      state: d,
      setOptions: function(y) {
        var _ = typeof y == "function" ? y(d.options) : y;
        O(), d.options = Object.assign({}, o, d.options, _), d.scrollParents = {
          reference: ze(s) ? Dt(s) : s.contextElement ? Dt(s.contextElement) : [],
          popper: Dt(c)
        };
        var m = ja(Xa([].concat(i, d.options.modifiers)));
        if (d.orderedModifiers = m.filter(function(S) {
          return S.enabled;
        }), process.env.NODE_ENV !== "production") {
          var w = Qa([].concat(m, d.options.modifiers), function(S) {
            var R = S.name;
            return R;
          });
          if (Va(w), fe(d.options.placement) === Gt) {
            var x = d.orderedModifiers.find(function(S) {
              var R = S.name;
              return R === "flip";
            });
            x || console.error(['Popper: "auto" placements require the "flip" modifier be', "present and enabled to work."].join(" "));
          }
          var C = ce(c), L = C.marginTop, q = C.marginRight, F = C.marginBottom, Y = C.marginLeft;
          [L, q, F, Y].some(function(S) {
            return parseFloat(S);
          }) && console.warn(['Popper: CSS "margin" styles cannot be used to apply padding', "between the popper and its reference element or boundary.", "To replicate margin, use the `offset` modifier, as well as", "the `padding` option in the `preventOverflow` and `flip`", "modifiers."].join(" "));
        }
        return $(), h.update();
      },
      // Sync update – it will always be executed, even if not necessary. This
      // is useful for low frequency updates where sync behavior simplifies the
      // logic.
      // For high frequency updates (e.g. `resize` and `scroll` events), always
      // prefer the async Popper#update method
      forceUpdate: function() {
        if (!D) {
          var y = d.elements, _ = y.reference, m = y.popper;
          if (!oi(_, m)) {
            process.env.NODE_ENV !== "production" && console.error(ii);
            return;
          }
          d.rects = {
            reference: Aa(_, Jt(m), d.options.strategy === "fixed"),
            popper: xi(m)
          }, d.reset = !1, d.placement = d.options.placement, d.orderedModifiers.forEach(function(S) {
            return d.modifiersData[S.name] = Object.assign({}, S.data);
          });
          for (var w = 0, x = 0; x < d.orderedModifiers.length; x++) {
            if (process.env.NODE_ENV !== "production" && (w += 1, w > 100)) {
              console.error(Ga);
              break;
            }
            if (d.reset === !0) {
              d.reset = !1, x = -1;
              continue;
            }
            var C = d.orderedModifiers[x], L = C.fn, q = C.options, F = q === void 0 ? {} : q, Y = C.name;
            typeof L == "function" && (d = L({
              state: d,
              options: F,
              name: Y,
              instance: h
            }) || d);
          }
        }
      },
      // Async and optimistically optimized update – it will not be executed if
      // not necessary (debounced to run at most once-per-tick)
      update: Ra(function() {
        return new Promise(function(g) {
          h.forceUpdate(), g(d);
        });
      }),
      destroy: function() {
        O(), D = !0;
      }
    };
    if (!oi(s, c))
      return process.env.NODE_ENV !== "production" && console.error(ii), h;
    h.setOptions(u).then(function(g) {
      !D && u.onFirstUpdate && u.onFirstUpdate(g);
    });
    function $() {
      d.orderedModifiers.forEach(function(g) {
        var y = g.name, _ = g.options, m = _ === void 0 ? {} : _, w = g.effect;
        if (typeof w == "function") {
          var x = w({
            state: d,
            name: y,
            instance: h,
            options: m
          }), C = function() {
          };
          v.push(x || C);
        }
      });
    }
    function O() {
      v.forEach(function(g) {
        return g();
      }), v = [];
    }
    return h;
  };
}
var Za = [ya, Ua, ba, la], Ja = /* @__PURE__ */ Ka({
  defaultModifiers: Za
});
const mr = class {
  constructor(e, t) {
    this.target = e, this.placement = "bottom", this.doNotCloseElements = [], this.zIndex = 20, this.modifiers = [Ti, mr.sameWidthModifier], this.checkForOutsideClickEvent = (r) => {
      const i = r.composedPath()[0];
      if (i instanceof Element) {
        let n = !0, o = i;
        do
          if (o) {
            if (this.doNotCloseElements.indexOf(o) != -1) {
              n = !1;
              break;
            }
            if (o.parentElement != null)
              o = o.parentElement;
            else {
              const a = o.getRootNode();
              a instanceof ShadowRoot ? o = a.host : o = null;
            }
          }
        while (o);
        n && this.hide();
      }
    }, this.setContent(t), this.doNotCloseElements.push(this.target), this.doNotCloseElements.push(this.content);
  }
  setContent(e) {
    this.content = e, this.isShown() ? this.content.style.display = "block" : this.content.style.display = "none";
  }
  /**
   * Adds an element that does not close the popover if it is clicked or gets focus.
   * @param element
   */
  addNotCloseElement(e) {
    this.doNotCloseElements.push(e);
  }
  getContent() {
    return this.content;
  }
  setPlacement(e) {
    this.placement = e;
  }
  setModifiers(e) {
    this.modifiers = e;
  }
  focus(e) {
    this.content.firstElementChild.focus(e);
  }
  show() {
    this.content.style.display = "block", this.content.style.zIndex = this.zIndex.toString(), this.popperInstance = Ja(this.target, this.content, {
      placement: this.placement,
      modifiers: this.modifiers,
      strategy: "fixed"
    }), document.addEventListener("click", this.checkForOutsideClickEvent, { capture: !0 }), document.addEventListener("focus", this.checkForOutsideClickEvent, { capture: !0 });
  }
  isShown() {
    return this.popperInstance !== void 0;
  }
  setHideListener(e) {
    this.hideListener = e;
  }
  hide() {
    this.content.style.display = "none", this.popperInstance && (this.popperInstance.destroy(), this.hideListener && this.hideListener(), this.popperInstance = void 0), document.removeEventListener("click", this.checkForOutsideClickEvent, { capture: !0 }), document.removeEventListener("focus", this.checkForOutsideClickEvent, { capture: !0 });
  }
  static get sameWidthModifier() {
    return mr._sameWidthModifier;
  }
};
let Ie = mr;
Ie._sameWidthModifier = {
  name: "sameWidth",
  enabled: !0,
  phase: "beforeWrite",
  requires: ["computeStyles"],
  fn: ({ state: e }) => {
    e.styles.popper.width = `${e.rects.reference.width}px`;
  },
  effect: ({ state: e }) => {
    e.elements.reference instanceof HTMLElement && (e.elements.popper.style.boxSizing = "border-box", e.elements.popper.style.width = `${e.elements.reference.offsetWidth}px`);
  }
};
const es = I`


`;
var ts = Object.defineProperty, rs = Object.getOwnPropertyDescriptor, $t = (e, t, r, i) => {
  for (var n = i > 1 ? void 0 : i ? rs(t, r) : t, o = e.length - 1, a; o >= 0; o--)
    (a = e[o]) && (n = (i ? a(t, r, n) : a(n)) || n);
  return i && n && ts(t, r, n), n;
};
let Ve = class extends U {
  constructor() {
    super(...arguments), this.offsetX = 5, this.offsetY = 0, this.placement = "bottom-start";
  }
  render() {
    return p`
           <slot @slotchange=${this.slotChanged}></slot>
        `;
  }
  show(e) {
    this.toggle(e, !0);
  }
  hide() {
    var e;
    (e = this.druidePopover) == null || e.hide();
  }
  slotChanged() {
    this.mainSlot.assignedElements()[0].style.display = "none", this.druidePopover && this.mainSlot.assignedElements()[0] && this.druidePopover.setContent(this.mainSlot.assignedElements()[0]);
  }
  getModifiers() {
    return [
      Ti,
      $a,
      La,
      {
        name: "offset",
        options: {
          offset: [this.offsetX, this.offsetY]
        }
      }
    ];
  }
  focus(e) {
    this.druidePopover && this.druidePopover.focus(e);
  }
  isShown() {
    return this.druidePopover ? this.druidePopover.isShown() : !1;
  }
  toggle(e, t = void 0) {
    let r;
    if (e instanceof Event ? e.target instanceof HTMLElement && (r = e.target) : e instanceof HTMLElement && (r = e), r === void 0 && (console.info("DruideDropdown show at first Element because target is undefined."), r = document.body.firstElementChild), !this.druidePopover) {
      let i = this.mainSlot.assignedElements()[0];
      this.druidePopover = new Ie(r, i), this.druidePopover.setModifiers(this.getModifiers());
    }
    this.druidePopover.setPlacement(this.placement), this.druidePopover.target = r, t === void 0 && (t = this.isShown()), t ? this.druidePopover.hide() : this.druidePopover.show();
  }
};
Ve.styles = es;
$t([
  l({ type: Number })
], Ve.prototype, "offsetX", 2);
$t([
  l({ type: Number })
], Ve.prototype, "offsetY", 2);
$t([
  l({ type: String })
], Ve.prototype, "placement", 2);
$t([
  E("slot")
], Ve.prototype, "mainSlot", 2);
Ve = $t([
  P("druide-dropdown")
], Ve);
const is = I`:host {
    padding: 0.25rem;
    padding-top: 0.5rem;
    padding-bottom: 0.5rem;
    display:inline-block;
}
druide-list-menu{
    background-color:white;
    box-shadow: rgb(0 0 0 / 20%) 0px 5px 5px -3px, rgb(0 0 0 / 14%) 0px 8px 10px 1px, rgb(0 0 0 / 12%) 0px 3px 14px 2px;
    z-index: 10 !important;
}
`;
var ns = Object.defineProperty, os = Object.getOwnPropertyDescriptor, gt = (e, t, r, i) => {
  for (var n = i > 1 ? void 0 : i ? os(t, r) : t, o = e.length - 1, a; o >= 0; o--)
    (a = e[o]) && (n = (i ? a(t, r, n) : a(n)) || n);
  return i && n && ns(t, r, n), n;
};
let Le = class extends U {
  constructor() {
    super(...arguments), this.title = "", this.placement = "bottom-end";
  }
  render() {
    return p`
           
            <slot name="trigger"  @click=${this.onClick} ><druide-button .title=${this.title} .icon=${this.icon}></druide-button></slot>
            <druide-dropdown  placement=${this.placement}>
                <druide-list-menu @click=${this.hide}>
                <slot></slot>
                </druide-list-menu>
            </druide-dropdown>
        `;
  }
  hide(e) {
    e.target && (e.target.disabled || e.target.hasAttribute && e.target.hasAttribute("disabled")) || this.dropdown.hide();
  }
  toggle(e = void 0) {
    this.dropdown.toggle(this, e), this.dropdown.isShown() && window.setTimeout(() => {
      this.menu.focus();
    }, 0);
  }
  onClick(e) {
    e.stopPropagation(), this.toggle();
  }
  show() {
    this.toggle(!0);
  }
};
Le.styles = _e(is);
gt([
  l()
], Le.prototype, "title", 2);
gt([
  l()
], Le.prototype, "icon", 2);
gt([
  E("druide-dropdown")
], Le.prototype, "dropdown", 2);
gt([
  l()
], Le.prototype, "placement", 2);
gt([
  E("druide-list-menu")
], Le.prototype, "menu", 2);
Le = gt([
  P("druide-dropdown-menu")
], Le);
const as = `:host{position:relative}::slotted(*){max-height:inherit}.header{display:flex;align-items:center}druide-icon-button{flex-grow:0;padding:20px;transform:rotate(0);transition-property:transform;transition-duration:.3s}druide-icon-button.active{transform:rotate(180deg);transition-property:transform;transition-duration:.3s}druide-icon-button#small{padding:0;position:absolute;bottom:5px;right:5px;--icon-btn-background-color: var(--primary-color);--icon-color: white;--primary-text-color: white;--primary-color-hover: var(--primary-color)}@media only screen and (max-width : 600px){druide-icon-button#large{opacity:0}}@media only screen and (min-width : 601px){druide-icon-button#small{display:none}}slot[name=accordian]{max-height:0;transition:max-height .25s ease-in-out;overflow:hidden}
`;
var ss = Object.defineProperty, ls = Object.getOwnPropertyDescriptor, kr = (e, t, r, i) => {
  for (var n = i > 1 ? void 0 : i ? ls(t, r) : t, o = e.length - 1, a; o >= 0; o--)
    (a = e[o]) && (n = (i ? a(t, r, n) : a(n)) || n);
  return i && n && ss(t, r, n), n;
};
const ai = Te`<svg xmlns="http://www.w3.org/2000/svg" height="48" viewBox="0 -960 960 960" width="48"><path d="M480-345 240-585l43-43 197 198 197-197 43 43-240 239Z"/></svg>`;
let _t = class extends U {
  render() {
    return p`
            <div class="header" @click=${this.toggleSmallScreen}>
                <slot></slot>
                <druide-icon-button id="large" .icon=${ai} @click=${() => this.toggle()}></druide-icon-button>
            </div>
            <slot name="accordian"></slot>
            <druide-icon-button id="small" .icon=${ai} @click=${() => this.toggle()}></druide-icon-button>
        `;
  }
  toggleSmallScreen() {
    screen.width <= 600 && this.toggle();
  }
  toggle() {
    this.triggers.forEach((e) => e.classList.toggle("active")), this.accordian.style.maxHeight != "" && this.accordian.style.maxHeight != "0px" ? this.accordian.style.maxHeight = "0px" : this.accordian.style.maxHeight = this.accordian.assignedNodes()[0].scrollHeight + "px";
  }
};
_t.styles = [_e(as)];
kr([
  si("druide-icon-button")
], _t.prototype, "triggers", 2);
kr([
  E("slot[name=accordian]")
], _t.prototype, "accordian", 2);
_t = kr([
  P("druide-expandable")
], _t);
const Pi = I`
:host {
    display: inline-block;
    padding: 0.25rem;
    padding-top: 0.5rem;
    padding-bottom: 0.5rem;
    font-size: var(--input-font-size);
}
:host([disabled]) {
    opacity:0.7;
    pointer-events: none;
    
}
:host([disabled]) > .input-container,
:host([read-only]) > .input-container,
.input-container.read-only,
.input-container.disabled  {
    background-color: var(--input-disabled-color); 
}

:host([multiline]) > .input-container {
    flex-wrap: wrap;
}

.input-container {
    position: relative;
    margin-top: 0.6em;
    border: 1px solid var(--input-border-color);
    border-radius: var(--druide-input-radius, 4px);
    display:flex;
    flex-direction:row;
    flex-wrap: no-wrap;
    align-items:center;
    padding: 8px;
    cursor:default;
}

label {
    padding: 0 0.25em;
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;

    display: flex;
    align-items: center;

    color: var(--input-label-color, rgba(0, 0, 0, 0.8));
    border-radius: var(--druide-input-radius, 4px);
    
    transition: all 0.3s;
}

label.active {
    top: -0.8em;
    left: 0.5em;
    bottom: unset;
    font-size: 0.85em;
    
    background: var(--input-background-color, #ffffff);
}

.required > label::after {
    content: "*";
}

::slotted([slot=prefix]) {
    padding-left: 0.5em;
}

select,
input {
    height: var(--input-height);
    font-size: 1em;
    min-width:50px;
    color: var(--input-text-color, rgba(0, 0, 0, 0.9));
    border:none;
    border-radius: var(--druide-input-radius, 4px);
    padding: 5px 0 0 0;
    flex-grow:1;
 
    box-sizing: border-box;
    background-color: #fff;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}
select:focus,
input:focus,
.input-container:focus-within,
.input-container.error:focus-within {
    border-color: var(--primary-color);
    outline: none;
}

select:disabled,
input:disabled,
select:read-only,
input:read-only{
    opacity: 1;
    background-color: transparent
}
.input-container.disabled {
    opacity: 1;
    /* */
}

select:focus ~ label,
input:focus ~ label {
    color: var(--primary-color);
}

.input-container.error  {
    border-color: var(--error-border-color);
    -webkit-appearance: none; /* This ensures that ios safari will show the box-shadow */
}

.error > label {
    color: var(--error-border-color);
}

.suggest > input,
.suggest > select {
    border-radius: 0.5rem 0.5rem 0 0;
}
`;
function Me(e, t = document) {
  const r = t.activeElement;
  if (r) {
    if (r === e)
      return !0;
  } else
    return !1;
  return r.shadowRoot ? Me(e, r.shadowRoot) : r === e;
}
const cs = `.input-container>.icon{display:block;height:var(--input-height);padding:0;border:0;cursor:pointer;box-sizing:border-box}.input-container>.icon+#base-input-field{padding-right:1.75rem}.input-container>.icon.center{display:flex;align-items:center}.input-error-popover{display:none;color:var(--error-text-color);background-color:var(--error-background-color);box-shadow:0 2px 2px #00000024,0 3px 1px -2px #0000001f,0 1px 5px #0003;overflow:hidden;font-size:.8em;border-radius:.25rem;padding:.25rem .75rem;word-wrap:break-word}
`, us = I`
.container {
    background-color: var(--background-color);
    height: 100%;
    box-shadow: 0 2px 2px 0 rgba(0, 0, 0, 0.14), 0 3px 1px -2px rgba(0, 0, 0, 0.12), 0 1px 5px 0 rgba(0, 0, 0, 0.2);
    overflow: hidden;
    border: 1px solid var(--input-border-color);
    border-top: 0px;
    border-radius: 0 0 0.5rem 0.5rem;
    position: relative;
}
.container .list {
    display: flex;
    flex-direction: column;
    overflow-y: auto;
    max-height: 200px;
}
.container .list > * {
    padding: 0.25rem;
    cursor: pointer;
    border-bottom: 1px solid var(--input-disabled-color);
    line-height: var(--suggestion-element-line-height);
}
.container .list > .focused {
    background-color: var(--background-color-hover);
}

.container .list > *:last-child {
    border-bottom: 0;
}

.container:focus {
    border-color: var(--primary-color);
    outline: none;
}

.container .list > div > .oneline {
    overflow:hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

`;
var ds = Object.defineProperty, ps = Object.getOwnPropertyDescriptor, Ze = (e, t, r, i) => {
  for (var n = i > 1 ? void 0 : i ? ps(t, r) : t, o = e.length - 1, a; o >= 0; o--)
    (a = e[o]) && (n = (i ? a(t, r, n) : a(n)) || n);
  return i && n && ds(t, r, n), n;
};
class ki {
  constructor(t, r) {
    this.id = t, this.title = r, this.focused = !1;
  }
}
let me = class extends U {
  constructor() {
    super(...arguments), this.suggestOptions = [], this.oneLineSuggestion = !0, this.shouldScroll = !0;
  }
  render() {
    return p`
        <div class="container "
            tabindex=1
            @keydown=${this.handleKeyDown} 
            @blur=${this.handleBlur} >
            <div class="list" @click=${this.handleClick} >
                ${this.suggestOptions.map((e) => this.renderOption(e))}
            </div>
        </div>`;
  }
  updated() {
    var e;
    this.shouldScroll && ((e = this.focusedElement) == null || e.scrollIntoView({ behavior: "smooth", block: "nearest" }), this.shouldScroll = !1);
  }
  renderOption(e) {
    return p`<div class="${e.focused ? "focused" : ""}">
                <div data-id="${e.id}" @mouseover="${this.handleMouseOver}" class="${this.oneLineSuggestion ? "oneline" : ""} ">
                    ${e.title}
                </div>
            </div>`;
  }
  handleMouseOver(e) {
    e.target instanceof HTMLElement && this.focusId(e.target.dataset.id ?? "");
  }
  handleBlur() {
    this.suggestOptions.forEach((e) => e.focused = !1);
  }
  getSelectedIndex() {
    return this.suggestOptions.findIndex((e) => e.focused);
  }
  focusId(e) {
    const t = this.getSelectedIndex();
    this.suggestOptions[t] && (this.suggestOptions[t].focused = !1);
    const r = this.suggestOptions.find((i) => i.id === e);
    r && (r.focused = !0), this.requestUpdate();
  }
  focusNext() {
    const e = this.getSelectedIndex();
    let t = e + 1;
    t >= this.suggestOptions.length && (t = this.suggestOptions.length - 1), this.suggestOptions[e] && (this.suggestOptions[e].focused = !1), this.suggestOptions[t].focused = !0, this.shouldScroll = !0, this.requestUpdate();
  }
  focusPrevious() {
    const e = this.getSelectedIndex();
    let t = e - 1;
    t < 0 && (t = 0), this.suggestOptions[e] && (this.suggestOptions[e].focused = !1), this.suggestOptions[t].focused = !0, this.shouldScroll = !0, this.requestUpdate();
  }
  handleKeyDown(e) {
    let t = !1;
    switch (e.key) {
      case "Down":
      case "ArrowDown":
        this.focusNext(), t = !0;
        break;
      case "Up":
      case "ArrowUp":
        this.focusPrevious(), t = !0;
        break;
    }
    return t && (e.preventDefault(), e.stopPropagation()), t;
  }
  handleKeyUp(e) {
    return e.key === "Enter" ? (this.fireSelectEvent(), e.preventDefault(), e.stopPropagation(), !0) : !1;
  }
  fireSelectEvent() {
    const e = this.suggestOptions.find((t) => t.focused);
    e && this.dispatchEvent(new CustomEvent("change", { detail: e }));
  }
  handleClick(e) {
    if (e.target instanceof HTMLElement) {
      const t = this.getSelectedIndex();
      this.suggestOptions[t] && (this.suggestOptions[t].focused = !1);
      const r = e.target.dataset.id, i = this.suggestOptions.find((n) => n.id === r);
      i && (i.focused = !0), this.requestUpdate(), this.fireSelectEvent();
    }
  }
};
me.styles = us;
Ze([
  l({ type: Array })
], me.prototype, "suggestOptions", 2);
Ze([
  l()
], me.prototype, "highlightString", 2);
Ze([
  l({ type: Boolean })
], me.prototype, "oneLineSuggestion", 2);
Ze([
  E(".list")
], me.prototype, "list", 2);
Ze([
  vt(),
  E(".container")
], me.prototype, "container", 2);
Ze([
  E(".focused")
], me.prototype, "focusedElement", 2);
me = Ze([
  P("druide-suggest-list")
], me);
var hs = Object.defineProperty, fs = Object.getOwnPropertyDescriptor, Q = (e, t, r, i) => {
  for (var n = i > 1 ? void 0 : i ? fs(t, r) : t, o = e.length - 1, a; o >= 0; o--)
    (a = e[o]) && (n = (i ? a(t, r, n) : a(n)) || n);
  return i && n && hs(t, r, n), n;
};
class k extends U {
  constructor() {
    super(...arguments), this.maxLength = 256, this.placeholder = "", this.label = "", this.autocomplete = "", this.actionIcon = "", this.required = !1, this.autofocus = !1, this.valueText = "", this.disabled = !1, this.readonly = !1, this.suggestVisible = !1;
  }
  get error() {
    return this._error;
  }
  set error(t) {
    this._error !== t && (this._error = t, this.toggleError());
  }
  get suggestOptions() {
    return this._suggestOptions;
  }
  set suggestOptions(t) {
    this._suggestOptions = t, this.toggleSuggestions();
  }
  render() {
    return p`
            <div class="input-container ${this.getClassList()}">
                
                <slot name="prefix" >${this.getPrefix()}</slot>
                <input 
                    id="base-input-field" 
                    .value=${this.valueText} 
                    .maxLength=${this.maxLength}
                    .autocomplete=${this.autocomplete}
                    .placeholder=${this.placeholder}
                    .disabled=${this.disabled}
                    .readOnly=${this.readonly}
                    type="${this.type}"
                    @input=${this.onInput}
                    @blur=${this.onBlurInternal}
                    @keydown=${this.onKeyDownInternal}
                    @keyup=${this.onKeyUpInternal}
                    @paste=${this.onPaste}
                    @focus=${this.onFocusInternal}
                    />
                ${this.getActionIcon()}
                <label class="label ${this.isLabelActiveInternal() ? "active" : ""}" for="base-input-field">${this.label} </label>
            </div>
            <div id="error" class="input-error-popover">${this.error}</div>
        `;
  }
  getClassList() {
    let t = "";
    return t += this.error ? "error " : "", t += this.required ? "required " : "", t += this.suggestVisible ? "suggest " : "", t += this.disabled ? "disabled " : "", t += this.readonly ? "read-only " : "", t;
  }
  getPrefix() {
    return p``;
  }
  firstUpdated() {
    this.autofocus && this.input.focus();
  }
  getActionIcon() {
    return this.actionIcon ? p`<druide-icon class="icon" icon="${this.actionIcon}" @click=${this.onActionIconClicked}></druide-icon>` : p``;
  }
  onActionIconClicked(t) {
    this.dispatchEvent(new CustomEvent("action-click", t));
  }
  select() {
    this.input.select();
  }
  toggleSuggestions() {
    var t, r;
    if (this.suggestPopover && this.suggestPopover.isShown()) {
      !this.suggestOptions || this.suggestOptions.length === 0 ? (this.suggestPopover.hide(), this.suggestPopover = void 0, (t = this.suggestList) == null || t.remove(), this.suggestList = void 0) : this.suggestList && (this.suggestList.suggestOptions = this.suggestOptions);
      return;
    }
    this.suggestOptions && this.suggestOptions.length > 0 && Me(this) && ((r = this.suggestList) == null || r.remove(), this.suggestList = new me(), this.container.appendChild(this.suggestList), this.suggestList.suggestOptions = this.suggestOptions, this.suggestList.addEventListener("change", (i) => this.onSuggestionSelect(i)), this.suggestPopover = new Ie(this.container, this.suggestList), this.suggestPopover.addNotCloseElement(this), this.suggestPopover.setHideListener(() => this.suggestVisible = !1), this.suggestVisible = !0, this.suggestPopover.show());
  }
  /**
   * Shows the error popover or hides it depending on the error state
   */
  toggleError() {
    if (this.errorPopover && this.errorPopover.isShown()) {
      this.error || (this.errorPopover.hide(), this.errorPopover = void 0);
      return;
    }
    this.error && Me(this) && (this.errorPopover = new Ie(this.container, this.errorDiv), this.errorPopover.addNotCloseElement(this), this.suggestList && this.errorPopover.setPlacement("top"), this.errorPopover.show());
  }
  onSuggestionSelect(t) {
    this.dispatchEvent(new CustomEvent("suggest-select", { detail: t.detail }));
  }
  /**
   * Hook method to distribute onInput to subclasses.
   * @param e Event
   */
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  onInput(t) {
  }
  /**
   * Hook method to distribute onInputBlur to subclasses.
   * @param e Event
   */
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  onInputBlur(t) {
  }
  /**
   * Hook method to distribute onFocus to subclasses.
   * @param e Event
   */
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  onFocus(t) {
  }
  onKeyDownInternal(t) {
    return this.suggestList && this.suggestList.handleKeyDown(t) ? !0 : this.onKeyDown(t);
  }
  /**
   * Hook method to distribute onKeyDown to subclasses.
   * @param e Event
   */
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  onKeyDown(t) {
    return !0;
  }
  onKeyUpInternal(t) {
    return this.suggestList && this.suggestList.handleKeyUp(t) ? !0 : this.onKeyUp(t);
  }
  onKeyUp(t) {
    return t.key === "Enter" && (this.onSubmitTriggered(), this.dispatchEvent(new CustomEvent("submit", { bubbles: !0, composed: !0 }))), !0;
  }
  /**
   * Hook method to distribute onPaste to subclasses.
   * @param e Event
   */
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  onPaste(t) {
    return !0;
  }
  onFocusInternal(t) {
    this.toggleSuggestions(), this.toggleError(), this.setLabelActive(), this.onFocus(t);
  }
  setLabelActive() {
    this.labelField.classList.add("active");
  }
  isLabelActiveInternal() {
    return !!(this.placeholder || this.valueText || Me(this) || this.isLabelActive());
  }
  /**
   * Hook method to distribute isLabelActive to subclasses.
   */
  isLabelActive() {
    return !1;
  }
  onBlurInternal(t) {
    this.onInputBlur(t), this.isLabelActiveInternal() || this.labelField.classList.remove("active");
  }
  hideSuggestion() {
    var t;
    this.suggestPopover && ((t = this.suggestPopover) == null || t.hide());
  }
  setCustomValidity(t) {
    this.error = t;
  }
  reportValidity() {
    const t = this.input.checkValidity();
    return t || (this.error = this.getErrorMessageForType(this.type)), t;
  }
  getErrorMessageForType(t) {
    switch (t) {
      case "date":
        return "Bitte geben Sie ein gültiges Datum an";
      case "email":
        return "Bitte geben Sie eine gültige Email-Adresse mit @ ein";
      case "number":
        return "Bitte geben Sie eine gültige Zahl ein";
      case "tel":
        return "Bitte geben Sie eine gültige Telefonnummer an";
      case "time":
        return "Bitte geben Sie eine gültige Zeit ein";
      case "password":
      case "text":
        return "Inkorrekte Eingabe";
    }
  }
}
k.styles = [Pi, _e(cs), I``];
Q([
  l({ type: Number })
], k.prototype, "maxLength", 2);
Q([
  l({ type: String })
], k.prototype, "placeholder", 2);
Q([
  l({ type: String })
], k.prototype, "label", 2);
Q([
  l({ type: String })
], k.prototype, "autocomplete", 2);
Q([
  l({ attribute: "action-icon", type: String })
], k.prototype, "actionIcon", 2);
Q([
  l({ type: Boolean })
], k.prototype, "required", 2);
Q([
  l({ type: Boolean })
], k.prototype, "autofocus", 2);
Q([
  V()
], k.prototype, "_error", 2);
Q([
  l({ type: String })
], k.prototype, "error", 1);
Q([
  V()
], k.prototype, "valueText", 2);
Q([
  l({ type: Boolean })
], k.prototype, "disabled", 2);
Q([
  l({ type: Boolean })
], k.prototype, "readonly", 2);
Q([
  V()
], k.prototype, "suggestVisible", 2);
Q([
  l({ type: Array })
], k.prototype, "_suggestOptions", 2);
Q([
  vt(),
  E("#base-input-field")
], k.prototype, "input", 2);
Q([
  E("#error")
], k.prototype, "errorDiv", 2);
Q([
  E(".input-container")
], k.prototype, "container", 2);
Q([
  E("label")
], k.prototype, "labelField", 2);
var vs = Object.defineProperty, gs = Object.getOwnPropertyDescriptor, Je = (e, t, r, i) => {
  for (var n = i > 1 ? void 0 : i ? gs(t, r) : t, o = e.length - 1, a; o >= 0; o--)
    (a = e[o]) && (n = (i ? a(t, r, n) : a(n)) || n);
  return i && n && vs(t, r, n), n;
};
let Ce = class extends k {
  constructor() {
    super(...arguments), this.type = "text", this._selectionOptions = [], this.selectionMapFunction = (e) => e.toString(), this.generateAutocompleteOptions = Promise.resolve, this.minAutocompleteSize = 2, this._value = "";
  }
  get selectionOptions() {
    return this._selectionOptions;
  }
  set selectionOptions(e) {
    this._selectionOptions = e, this.selectionMapFunction && (this.suggestOptions = e.map((t, r) => new ki(r.toString(), this.selectionMapFunction(t))));
  }
  get selectedOption() {
    return this._selectedOption;
  }
  set selectedOption(e) {
    this._selectedOption = e, this.value = e ? this.selectionMapFunction(e) : "", e !== void 0 ? (this.disabled = !0, this.suggestOptions = void 0) : this.disabled = !1, this.requestUpdate();
  }
  get value() {
    return this._value;
  }
  set value(e) {
    this._value !== e && (this._value = e, this.valueText = this.value, this.input && (this.input.value = this.value), this.value.length > this.minAutocompleteSize && this.generateAutocompleteOptions(this.value).then((t) => {
      this.selectionOptions = t;
    }), this.error = void 0);
  }
  onSubmitTriggered() {
    this.value = this.input.value;
  }
  getActionIcon() {
    return p`
            <div class="icon center" style="display: ${this.selectedOption ? "flex" : "none"}" @click=${(e) => this.onDeleteClicked(e)}>
                <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 0 24 24" width="24px" fill="#000000">
                    <path d="M0 0h24v24H0V0z" fill="none"/>
                    <path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12 19 6.41z"/>
                </svg>
            </div>
        `;
  }
  onDeleteClicked(e) {
    this.selectedOption = void 0, this.dispatchEvent(new Event("change")), this.focus();
  }
  onSuggestionSelect(e) {
    const t = this.selectionOptions[e.detail.id];
    this.onSelection(t);
  }
  onSelection(e) {
    e !== this.selectedOption && (this.selectedOption = e, this.hideSuggestion(), this.dispatchEvent(new Event("change")), this.input.blur());
  }
  onInput() {
    var t;
    this.clearInputTimer(), this.selectedOption && (this.input.value = this.value);
    const e = (t = this.suggestOptions) != null && t.length ? 100 : 400;
    this.inputTimer = window.setTimeout(() => {
      this.value = this.input.value;
    }, e);
  }
  clearInputTimer() {
    this.inputTimer && (window.clearTimeout(this.inputTimer), this.inputTimer = void 0);
  }
  onInputBlur(e) {
    this.clearInputTimer(), this.value = this.input.value, this.selectedOption === void 0 && (this.value = "");
  }
  onFocus(e) {
    this.value === "" && (this.selectionOptions = []);
  }
};
Ce.styles = k.styles;
Je([
  l({ type: Array })
], Ce.prototype, "_selectionOptions", 2);
Je([
  l()
], Ce.prototype, "_selectedOption", 2);
Je([
  l()
], Ce.prototype, "selectionMapFunction", 2);
Je([
  l()
], Ce.prototype, "generateAutocompleteOptions", 2);
Je([
  l({ type: Number })
], Ce.prototype, "minAutocompleteSize", 2);
Je([
  V()
], Ce.prototype, "_value", 2);
Ce = Je([
  P("druide-autocomplete-field")
], Ce);
const ms = I`

.chip{
    display:flex;
    flex-direction:row;
}
.chip >* {
    background-color:var( --chip-background);
    padding-left: var(--druide-input-radius, 4px);
    padding-right: var(--druide-input-radius, 4px);
    padding-bottom:1px;
    margin-top:2px;
    margin-bottom: 2px;
}
.chip > .content{
    border-top-left-radius: var(--druide-input-radius, 4px);
    border-bottom-left-radius: var(--druide-input-radius, 4px);
    margin-left:0.3em;
    font-size: 0.85em;
    white-space:nowrap;
    text-overflow: ellipsis;
}
.chip > .close{
    border-top-right-radius: var(--druide-input-radius, 4px);
    border-bottom-right-radius: var(--druide-input-radius, 4px);
    margin-left:2px;
    margin-right: 2px;
    cursor:pointer;
    transition: 150ms cubic-bezier(0.4, 0, 0.2, 1);
}
.chip > .close:hover{
    filter: brightness(0.85);
    box-shadow: 0px 2px 4px -1px rgba(0, 0, 0, 0.2), 0px 4px 5px 0px rgba(0, 0, 0, 0.14), 0px 1px 10px 0px rgba(0, 0, 0, 0.12);

}
.chip > .close > svg{
    fill: var(--text-color);
}
.rotate{
    animation:spin 4s linear infinite;
}
@keyframes spin { 
100% { 
    -webkit-transform: rotate(-360deg); 
    transform:rotate(-360deg); 
} 
}
`;
var bs = Object.defineProperty, ws = Object.getOwnPropertyDescriptor, we = (e, t, r, i) => {
  for (var n = i > 1 ? void 0 : i ? ws(t, r) : t, o = e.length - 1, a; o >= 0; o--)
    (a = e[o]) && (n = (i ? a(t, r, n) : a(n)) || n);
  return i && n && bs(t, r, n), n;
};
let J = class extends k {
  constructor() {
    super(...arguments), this.type = "text", this._selectionOptions = [], this.selectedOptions = [], this.allowDoubleOptions = !1, this.optionToSuggest = (e) => e + "", this.optionToChip = (e) => e + "", this.optionsSearch = Promise.resolve, this.minAutocompleteSize = 2, this._value = "", this.loading = !1;
  }
  get selectionOptions() {
    return this._selectionOptions;
  }
  set selectionOptions(e) {
    this.allowDoubleOptions || (e = e.filter((t) => !this.isSelected(t))), this._selectionOptions = e, this.suggestOptions = e.map((t, r) => new ki(r.toString(), this.optionToSuggest(t)));
  }
  get value() {
    return this._value;
  }
  set value(e) {
    this._value !== e && (this._value = e, this.valueText = this.value, this.input && (this.input.value = this.value), this.value.length >= this.minAutocompleteSize && (this.loading = !0, this.optionsSearch(this.value).then((t) => {
      this.selectionOptions = t, this.loading = !1;
    })));
  }
  onSubmitTriggered() {
    this.value = this.input.value;
  }
  getActionIcon() {
    if (this.loading) {
      const e = new Z();
      return e.svg = J.loadingSVG, e.className = "rotate", p`${e}`;
    }
    return p``;
  }
  getPrefix() {
    return p`${this.selectedOptions.map((e) => this.getLabel(e))}`;
  }
  getLabel(e) {
    return p`<div class="chip"><div class="content">${this.optionToChip(e)}</div><div class="close" @click=${() => this.removeSelection(e)}>${J.closeSVG}</div></div>`;
  }
  removeSelection(e) {
    this.selectedOptions = this.selectedOptions.filter((t) => !this.objectEquals(e, t)), this.dispatchEvent(new Event("change"));
  }
  addSelection(e) {
    this.selectedOptions.push(e), this.dispatchEvent(new Event("change")), this.value = "", this.suggestOptions = void 0, this.hideSuggestion(), this.input.focus();
  }
  isSelected(e) {
    return this.selectedOptions.findIndex((t) => this.objectEquals(e, t)) !== -1;
  }
  objectEquals(e, t) {
    const r = Object.keys, i = typeof e;
    return e && t && i === "object" && i === typeof t ? r(e).length === r(t).length && r(e).every((o) => this.objectEquals(e[o], t[o])) : e === t;
  }
  onSuggestionSelect(e) {
    const t = this.selectionOptions[e.detail.id];
    this.addSelection(t);
  }
  onInput() {
    var t;
    this.clearInputTimer();
    const e = (t = this.suggestOptions) != null && t.length ? 100 : 300;
    this.inputTimer = window.setTimeout(() => {
      this.value = this.input.value;
    }, e);
  }
  clearInputTimer() {
    this.inputTimer && (window.clearTimeout(this.inputTimer), this.inputTimer = void 0);
  }
  onInputBlur(e) {
    this.clearInputTimer();
  }
  onFocus(e) {
    this.input.value = "", this.selectionOptions = [];
  }
  isLabelActive() {
    return this.selectedOptions.length > 0;
  }
};
J.styles = [...k.styles, ms];
J.loadingSVG = Te`<svg xmlns="http://www.w3.org/2000/svg" height="48px" viewBox="0 0 24 24" width="48px" ><path d="M0 0h24v24H0z" fill="none"/><path d="M12 4V1L8 5l4 4V6c3.31 0 6 2.69 6 6 0 1.01-.25 1.97-.7 2.8l1.46 1.46C19.54 15.03 20 13.57 20 12c0-4.42-3.58-8-8-8zm0 14c-3.31 0-6-2.69-6-6 0-1.01.25-1.97.7-2.8L5.24 7.74C4.46 8.97 4 10.43 4 12c0 4.42 3.58 8 8 8v3l4-4-4-4v3z"/></svg>`;
J.closeSVG = Te`<svg height="100%"  width="0.7em" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 460.775 460.775" xml:space="preserve"><g stroke-width="0"></g><g stroke-linecap="round" stroke-linejoin="round"></g><g > <path d="M285.08,230.397L456.218,59.27c6.076-6.077,6.076-15.911,0-21.986L423.511,4.565c-2.913-2.911-6.866-4.55-10.992-4.55 c-4.127,0-8.08,1.639-10.993,4.55l-171.138,171.14L59.25,4.565c-2.913-2.911-6.866-4.55-10.993-4.55 c-4.126,0-8.08,1.639-10.992,4.55L4.558,37.284c-6.077,6.075-6.077,15.909,0,21.986l171.138,171.128L4.575,401.505 c-6.074,6.077-6.074,15.911,0,21.986l32.709,32.719c2.911,2.911,6.865,4.55,10.992,4.55c4.127,0,8.08-1.639,10.994-4.55 l171.117-171.12l171.118,171.12c2.913,2.911,6.866,4.55,10.993,4.55c4.128,0,8.081-1.639,10.992-4.55l32.709-32.719 c6.074-6.075,6.074-15.909,0-21.986L285.08,230.397z"></path> </g></svg>`;
we([
  l({ type: Array })
], J.prototype, "_selectionOptions", 2);
we([
  l({ type: Array })
], J.prototype, "selectedOptions", 2);
we([
  l()
], J.prototype, "allowDoubleOptions", 2);
we([
  l()
], J.prototype, "optionToSuggest", 2);
we([
  l()
], J.prototype, "optionToChip", 2);
we([
  l()
], J.prototype, "optionsSearch", 2);
we([
  l({ type: Number })
], J.prototype, "minAutocompleteSize", 2);
we([
  V()
], J.prototype, "_value", 2);
we([
  V()
], J.prototype, "loading", 2);
J = we([
  P("druide-chip-field")
], J);
var ys = Object.defineProperty, xs = Object.getOwnPropertyDescriptor, Ye = (e, t, r, i) => {
  for (var n = i > 1 ? void 0 : i ? xs(t, r) : t, o = e.length - 1, a; o >= 0; o--)
    (a = e[o]) && (n = (i ? a(t, r, n) : a(n)) || n);
  return i && n && ys(t, r, n), n;
};
let be = class extends k {
  constructor() {
    super(), this.type = "tel", this.value = "", this.dayDatePickerColoringMap = /* @__PURE__ */ new Map(), this.monthDatePickerColoringMap = /* @__PURE__ */ new Map(), this.yearDatePickerColoringMap = /* @__PURE__ */ new Map(), this.colorMapCaption = /* @__PURE__ */ new Map(), super.placeholder = "TT.MM.JJJJ";
  }
  update(e) {
    e.has("value") && (this.valueText = this.value ? this.formatDateGerman(new Date(this.value)) : this.valueText), super.update(e);
  }
  render() {
    return p`
            ${super.render()}
            <slot></slot>
            <druide-date-picker style="display:none" 
                @change=${this.datePickerChange} 
                .dayColoringMap=${this.dayDatePickerColoringMap} 
                .monthColoringMap=${this.monthDatePickerColoringMap} 
                .yearColoringMap=${this.yearDatePickerColoringMap}
                .colorMapCaption=${this.colorMapCaption}>
            </druide-date-picker>
            `;
  }
  getActionIcon() {
    return p`<div style="width: 30px; height: 30px">
                <svg xmlns="http://www.w3.org/2000/svg" class="icon" @click=${this.showDatePicker}  viewBox="0 0 24 24">
                    <path d="M0 0h24v24H0z" fill="none"/>
                    <path d="M20 3h-1V1h-2v2H7V1H5v2H4c-1.1 0-2 .9-2 2v16c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 18H4V8h16v13z"/>
                </svg>
            </div>
            `;
  }
  datePickerChange() {
    this.value !== this.datePicker.value && (this.value = this.datePicker.value, this.fireChangedEvent()), this.hideDatePicker();
  }
  showDatePicker() {
    if (this.druidePopover && this.druidePopover.isShown()) {
      this.hideDatePicker();
      return;
    }
    this.druidePopover = new Ie(this.input, this.datePicker), this.druidePopover.setModifiers([]), this.druidePopover.addNotCloseElement(this), this.datePicker.value = this.value, this.druidePopover.show(), this.input.focus();
  }
  hideDatePicker() {
    this.druidePopover && (this.druidePopover.hide(), this.druidePopover = void 0);
  }
  onInput() {
    /^(\d|\.)*$/gm.test(this.input.value) ? this.valueText = this.input.value : this.input.value = this.valueText;
  }
  onDatePickerChange() {
    const e = this.dateInput.valueAsDate;
    e && (this.error = void 0, this.value = this.formatDateIso(e), this.valueText = this.formatDateGerman(e), this.dispatchEvent(new Event("change")), this.requestUpdate());
  }
  onSubmitTriggered() {
    this.inputChangedEvent();
  }
  onInputBlur() {
    this.inputChangedEvent();
  }
  inputChangedEvent() {
    const e = this.input.value;
    if (e === "")
      this.value = "", this.error = void 0;
    else {
      const t = this.parseDate(e);
      t !== void 0 ? (this.error = void 0, this.value = this.formatDateIso(t), this.valueText = this.formatDateGerman(t)) : (this.value = "", this.error = "Ungültiges Datum");
    }
    this.fireChangedEvent();
  }
  fireChangedEvent() {
    this.dispatchEvent(new Event("change")), this.requestUpdate();
  }
  formatDateIso(e) {
    if (e == null)
      return "";
    const t = e.getDate() < 10 ? "0" + e.getDate() : e.getDate(), r = e.getMonth() + 1, i = r < 10 ? "0" + r : r;
    return e.getFullYear() + "-" + i + "-" + t;
  }
  formatDateGerman(e) {
    if (e == null)
      return "";
    const t = e.getDate() < 10 ? "0" + e.getDate() : e.getDate(), r = e.getMonth() + 1, i = r < 10 ? "0" + r : r;
    return t + "." + i + "." + e.getFullYear();
  }
  parseDate(e) {
    if (e.indexOf(".") === -1) {
      const a = this.addSeparatorToDate(e);
      if (a)
        e = a;
      else
        return;
    }
    const t = e.split(".");
    if (t.length !== 3)
      return;
    t[2].length == 2 && (t[2] = this.transferYearToFullYear(parseInt(t[2], 10)).toString());
    const [r, i, n] = t.map((a) => parseInt(a, 10)), o = new Date(n, i - 1, r);
    if (o.getMonth() === i - 1 && o.getFullYear() === n)
      return o;
  }
  addSeparatorToDate(e) {
    return e.length === 6 ? e.substring(0, 2) + "." + e.substring(2, 4) + "." + e.substring(4, 6) : e.length === 8 ? e.substring(0, 2) + "." + e.substring(2, 4) + "." + e.substring(4, 8) : void 0;
  }
  transferYearToFullYear(e) {
    const t = +(/* @__PURE__ */ new Date()).getFullYear().toString().slice(-2);
    return e > t && e - t < 40 ? (/* @__PURE__ */ new Date()).getFullYear() + (e - t) : (/* @__PURE__ */ new Date()).getFullYear() - ((t - e) % 100 + 100) % 100;
  }
};
be.styles = [...k.styles];
Ye([
  l({ type: String })
], be.prototype, "value", 2);
Ye([
  l({ attribute: !1 })
], be.prototype, "dayDatePickerColoringMap", 2);
Ye([
  l({ attribute: !1 })
], be.prototype, "monthDatePickerColoringMap", 2);
Ye([
  l({ attribute: !1 })
], be.prototype, "yearDatePickerColoringMap", 2);
Ye([
  l({ attribute: !1 })
], be.prototype, "colorMapCaption", 2);
Ye([
  E("input#date")
], be.prototype, "dateInput", 2);
Ye([
  E("druide-date-picker")
], be.prototype, "datePicker", 2);
be = Ye([
  P("druide-date-field")
], be);
const Os = I`
/* Chrome, Safari, Edge, Opera */
.hide-spinner input::-webkit-outer-spin-button,
.hide-spinner input::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
}

/* Firefox */
.hide-spinner input[type="number"] {
    -moz-appearance: textfield;
}
`;
var Ds = Object.defineProperty, Cs = Object.getOwnPropertyDescriptor, er = (e, t, r, i) => {
  for (var n = i > 1 ? void 0 : i ? Cs(t, r) : t, o = e.length - 1, a; o >= 0; o--)
    (a = e[o]) && (n = (i ? a(t, r, n) : a(n)) || n);
  return i && n && Ds(t, r, n), n;
};
let ct = class extends k {
  constructor() {
    super(...arguments), this.hideSpinner = !1, this.type = "number";
  }
  get value() {
    return this._value;
  }
  set value(e) {
    this._value = e, this._value !== void 0 && !isNaN(this._value) ? this.valueText = this._value.toString() : this.valueText = "", this.input && this.input.valueAsNumber != e && (this.input.value = this.valueText);
  }
  getClassList() {
    let e = super.getClassList();
    return e += this.hideSpinner ? "hide-spinner " : "", e;
  }
  onInput() {
    var t;
    this.inputTimer && (window.clearTimeout(this.inputTimer), this.inputTimer = void 0);
    const e = (t = this.suggestOptions) != null && t.length ? 100 : 400;
    this.inputTimer = window.setTimeout(() => this.fireChangeEvent(), e);
  }
  onSubmitTriggered() {
    this.onInputBlur();
  }
  onInputBlur() {
    this.inputTimer && (window.clearTimeout(this.inputTimer), this.inputTimer = void 0), this.fireChangeEvent();
  }
  fireChangeEvent() {
    this.value !== this.input.valueAsNumber && (this.value = this.input.valueAsNumber, this.dispatchEvent(new Event("change")));
  }
};
ct.styles = [...k.styles, Os];
er([
  l({ attribute: "hide-spinner", type: Boolean })
], ct.prototype, "hideSpinner", 2);
er([
  l({ type: Number })
], ct.prototype, "value", 1);
er([
  l()
], ct.prototype, "type", 2);
ct = er([
  P("druide-number-field")
], ct);
var _s = Object.defineProperty, Ts = Object.getOwnPropertyDescriptor, Sr = (e, t, r, i) => {
  for (var n = i > 1 ? void 0 : i ? Ts(t, r) : t, o = e.length - 1, a; o >= 0; o--)
    (a = e[o]) && (n = (i ? a(t, r, n) : a(n)) || n);
  return i && n && _s(t, r, n), n;
};
let Tt = class extends k {
  constructor() {
    super(...arguments), this._value = "", this.type = "text", this.modifiedSinceLastBlur = !1;
  }
  get value() {
    return this._value;
  }
  set value(e) {
    this._value = e, this.valueText = this.value, this.input && this.input.value != e && (this.input.value = this.value);
  }
  onInput() {
    var t;
    this.inputTimer && (window.clearTimeout(this.inputTimer), this.inputTimer = void 0);
    const e = (t = this.suggestOptions) != null && t.length ? 100 : 400;
    this.inputTimer = window.setTimeout(() => {
      this.modifiedSinceLastBlur = this.value !== this.input.value, this.fireChangeEvent();
    }, e);
  }
  onSubmitTriggered() {
    this.onInputBlur();
  }
  onInputBlur() {
    this.inputTimer && (window.clearTimeout(this.inputTimer), this.inputTimer = void 0), (this.modifiedSinceLastBlur || this.value !== this.input.value) && (this.error = void 0, this.reportValidity(), this.modifiedSinceLastBlur = !1), this.fireChangeEvent();
  }
  fireChangeEvent() {
    this.value !== this.input.value && (this.value = this.input.value, this.dispatchEvent(new Event("change")));
  }
};
Tt.styles = k.styles;
Sr([
  l()
], Tt.prototype, "value", 1);
Sr([
  l()
], Tt.prototype, "type", 2);
Tt = Sr([
  P("druide-text-field")
], Tt);
var Ps = Object.defineProperty, ks = Object.getOwnPropertyDescriptor, Si = (e, t, r, i) => {
  for (var n = i > 1 ? void 0 : i ? ks(t, r) : t, o = e.length - 1, a; o >= 0; o--)
    (a = e[o]) && (n = (i ? a(t, r, n) : a(n)) || n);
  return i && n && Ps(t, r, n), n;
};
let Vt = class extends k {
  constructor() {
    super(), this.type = "time", this.value = "", super.placeholder = "HH:mm";
  }
  update(e) {
    e.has("value") && (this.valueText = this.value ?? this.valueText), super.update(e);
  }
  onInput() {
    /^(\d|\:)*$/gm.test(this.input.value) ? this.valueText = this.input.value : this.input.value = this.valueText;
  }
  onSubmitTriggered() {
    this.inputChangedEvent();
  }
  onInputBlur() {
    this.inputChangedEvent();
  }
  inputChangedEvent() {
    const e = this.input.value;
    e === "" ? (this.value = "", this.error = void 0) : e !== void 0 ? (this.error = void 0, this.value = e, this.valueText = e) : (this.value = "", this.error = "Ungültige Zeitangabe"), this.fireChangedEvent();
  }
  formatTime(e) {
    return he(e, "HH:mm");
  }
  fireChangedEvent() {
    this.dispatchEvent(new Event("change")), this.requestUpdate();
  }
};
Vt.styles = [...k.styles];
Si([
  l({ type: String })
], Vt.prototype, "value", 2);
Vt = Si([
  P("druide-time-field")
], Vt);
var Ss = Object.defineProperty, Es = Object.getOwnPropertyDescriptor, mt = (e, t, r, i) => {
  for (var n = i > 1 ? void 0 : i ? Es(t, r) : t, o = e.length - 1, a; o >= 0; o--)
    (a = e[o]) && (n = (i ? a(t, r, n) : a(n)) || n);
  return i && n && Ss(t, r, n), n;
};
let Ne = class extends U {
  constructor() {
    super(...arguments), this._value = "", this._readonly = !1, this.autofocus = !1, this.placeholder = "", this.languageUrl = "theme/tinymce/langs/de.js";
  }
  set value(e) {
    this._value != e && (this._value = e, this.editor && this.editor.setContent(e));
  }
  get value() {
    return this._value;
  }
  get readonly() {
    return this.editor ? this.editor.mode.get() === "readonly" : this._readonly;
  }
  set readonly(e) {
    this._readonly = e, this.editor && (e && this.editor.mode.get() !== "readonly" ? this.editor.mode.set("readonly") : !e && this.editor.mode.get() == "readonly" && this.editor.mode.set("design"));
  }
  createRenderRoot() {
    return this;
  }
  async firstUpdated(e) {
    const t = await window.tinymce.init({
      target: this.editorContainer,
      plugins: "preview importcss searchreplace autolink visualblocks visualchars fullscreen image link media table charmap nonbreaking anchor insertdatetime advlist lists charmap quickbars emoticons accordion",
      toolbar: "undo redo | bold italic underline strikethrough | blocks | alignleft aligncenter alignright alignjustify | outdent indent | fontfamily fontsize | numlist bullist accordion | forecolor backcolor removeformat | charmap emoticons | fullscreen  preview | insertfile image media template link anchor codesample ",
      menubar: "edit insert view format table tools",
      removed_menuitems: "styles",
      placeholder: this.placeholder,
      readonly: this.readonly,
      promotion: !1,
      image_advtab: !0,
      language_url: this.languageUrl,
      language: "de",
      file_picker_callback: this.pickFile.bind(this),
      file_picker_types: "image",
      setup: (r) => {
        r.on("blur", this.onChange.bind(this));
      }
    });
    t && (this.editor = t.find((r) => r.id == this.editorContainer.id), this.editor.setContent(this.value));
  }
  pickFile(e, t, r) {
    const i = document.createElement("input");
    i.setAttribute("type", "file"), i.setAttribute("accept", "image/*"), i.onchange = function() {
      if (i.files) {
        const n = i.files[0], o = new FileReader();
        o.onload = function() {
          const a = "blobid" + (/* @__PURE__ */ new Date()).getTime(), s = window.tinymce.activeEditor.editorUpload.blobCache;
          if (o.result && typeof o.result == "string") {
            const c = o.result.split(",")[1], u = s.create(a, n, c);
            s.add(u), e(u.blobUri(), { title: n.name });
          }
        }, o.readAsDataURL(n);
      }
      i.remove();
    }, i.click();
  }
  render() {
    return p`
            <div id=${this.id != "" ? this.id : "editor"} style="height: 100%;"></div>
            <input id="my-filepicker" type="file" name="my-filefilepicker" style="display: none;" onchange="" />
        `;
  }
  onChange() {
    const e = window.tinymce.activeEditor.getContent();
    this._value != e && (this._value = e, this.dispatchEvent(new Event("change")));
  }
};
Ne.styles = [I`
        :host {
            display: block;
            height: 100%;
        }
    `];
mt([
  E("div")
], Ne.prototype, "editorContainer", 2);
mt([
  V()
], Ne.prototype, "_value", 2);
mt([
  l({ type: Boolean })
], Ne.prototype, "autofocus", 2);
mt([
  l()
], Ne.prototype, "placeholder", 2);
mt([
  l()
], Ne.prototype, "languageUrl", 2);
Ne = mt([
  P("druide-html-editor")
], Ne);
const $s = I`
:host {
    display: block;
    box-sizing: border-box;
    height: 100%;
}
iframe {
    width: 100%;
    height: 100%;
    border: 0;
    overflow: auto;
}
`;
var Ms = Object.defineProperty, Is = Object.getOwnPropertyDescriptor, Mt = (e, t, r, i) => {
  for (var n = i > 1 ? void 0 : i ? Is(t, r) : t, o = e.length - 1, a; o >= 0; o--)
    (a = e[o]) && (n = (i ? a(t, r, n) : a(n)) || n);
  return i && n && Ms(t, r, n), n;
};
let Qe = class extends U {
  constructor() {
    super(...arguments), this.html = "", this.autoHeight = !1, this.linkToBlank = !0;
  }
  render() {
    return p`
            <iframe sandbox="allow-popups allow-popups-to-escape-sandbox allow-same-origin" 
            @load=${this.iframeLoaded} 
            .src=${this.getHtmlAsContentUrl()} >
            </iframe>
        `;
  }
  updated(e) {
    super.updated(e), window.setTimeout(() => this.iframeResize(), 50);
  }
  iframeLoaded() {
    this.iframeResize(), this.dispatchEvent(new Event("load", { composed: !0 }));
  }
  iframeResize() {
    var t, r;
    const e = (r = (t = this.iframe) == null ? void 0 : t.contentWindow) == null ? void 0 : r.document.body;
    e && this.autoHeight && e.scrollHeight > 10 && (e.style.margin = "0", this.style.height = e.scrollHeight + "px");
  }
  getHtmlAsContentUrl() {
    let e;
    this.linkToBlank ? e = this.html.replace(/( href=['"])/, ' target="_blank"$1') : e = this.html;
    const t = new Blob([e], { type: "text/html;charset=utf-8" });
    return URL.createObjectURL(t);
  }
};
Qe.styles = $s;
Mt([
  l({ type: String })
], Qe.prototype, "html", 2);
Mt([
  l({ type: Boolean, attribute: "auto-height" })
], Qe.prototype, "autoHeight", 2);
Mt([
  E("iframe")
], Qe.prototype, "iframe", 2);
Mt([
  l({ type: Boolean, attribute: "link-to-blank" })
], Qe.prototype, "linkToBlank", 2);
Qe = Mt([
  P("druide-html-view")
], Qe);
const Ls = I`
:host {
    display: block;
    box-sizing: border-box;
    height: 100%;
}
iframe {
    width: 100%;
    height: 100%;
    border: 0;
    overflow: auto;
}
`;
var Ns = Object.defineProperty, Us = Object.getOwnPropertyDescriptor, Er = (e, t, r, i) => {
  for (var n = i > 1 ? void 0 : i ? Us(t, r) : t, o = e.length - 1, a; o >= 0; o--)
    (a = e[o]) && (n = (i ? a(t, r, n) : a(n)) || n);
  return i && n && Ns(t, r, n), n;
};
let Pt = class extends U {
  constructor() {
    super(...arguments), this.url = "", this.sandbox = "allow-forms allow-popups-to-escape-sandbox allow-same-origin allow-scripts";
  }
  render() {
    return p`<iframe .sandbox=${this.sandbox} .src=${this.url} ></iframe>`;
  }
};
Pt.styles = Ls;
Er([
  l({ type: String })
], Pt.prototype, "url", 2);
Er([
  l({ type: String })
], Pt.prototype, "sandbox", 2);
Pt = Er([
  P("druide-iframe")
], Pt);
var Ys = Object.defineProperty, qs = Object.getOwnPropertyDescriptor, tr = (e, t, r, i) => {
  for (var n = i > 1 ? void 0 : i ? qs(t, r) : t, o = e.length - 1, a; o >= 0; o--)
    (a = e[o]) && (n = (i ? a(t, r, n) : a(n)) || n);
  return i && n && Ys(t, r, n), n;
};
let ut = class extends U {
  constructor() {
    super(...arguments), this.minWidth = "350px", this.maxWidth = "1fr";
  }
  render() {
    if (this.columns) {
      let e = "";
      for (let t = 0; t < this.columns; t++)
        e += `minmax(${this.minWidth}, ${this.maxWidth}) `;
      this.style.setProperty("--druide-column-definition", e);
    } else
      this.style.setProperty("--druide-column-definition", `repeat(auto-fill, minmax(${this.minWidth}, ${this.maxWidth}))`);
    return p`<slot></slot>`;
  }
};
ut.styles = I`
        :host{
            display: grid;
            grid-template-columns: var(--druide-column-definition);
            grid-gap: 1rem;
            padding-top:0.5rem;
            padding-bottom:0.5rem;
        }
    `;
tr([
  l({ type: Number })
], ut.prototype, "columns", 2);
tr([
  l({ attribute: "min-width" })
], ut.prototype, "minWidth", 2);
tr([
  l({ attribute: "max-width" })
], ut.prototype, "maxWidth", 2);
ut = tr([
  P("druide-layout")
], ut);
const Fs = I`
:host {
    display: grid;
    align-items: center;
    padding: 0.25rem;
    gap: 0.25rem;
    grid-template-columns: min-content auto min-content;
    grid-template-areas:
        "icon title action"
        "icon detail action";
}

:host(.selected) .icon > druide-icon {
    display: none;
}
:host(.selected) .icon > .check-icon {
    display: block;
}

.icon {
    grid-area: icon;
    padding: 0 0.5rem;
    width: 1rem;
}
.icon > .check-icon {
    display: none;
}
.icon > .check-icon svg {
    position: relative;
    fill: var(--icon-color, var(--text-color));
    width: 100%;
    height: 100%;
}

.title {
    grid-area: title;
    font-weight: bold;
}
.detail {
    grid-area: detail;
    font-size: 0.8rem;
}
.action {
    grid-area: action;
}
`;
var Ws = Object.defineProperty, Bs = Object.getOwnPropertyDescriptor, $r = (e, t, r, i) => {
  for (var n = i > 1 ? void 0 : i ? Bs(t, r) : t, o = e.length - 1, a; o >= 0; o--)
    (a = e[o]) && (n = (i ? a(t, r, n) : a(n)) || n);
  return i && n && Ws(t, r, n), n;
};
let kt = class extends U {
  constructor() {
    super(...arguments), this.title = "";
  }
  render() {
    return p`
            <div class="icon"> ${Z.createIfDefined(this.icon)} <div class="check-icon">${this.getCheckIcon()}</div></div>
            <div class="title">${this.title}</div>
            <div class="detail"><slot></slot></div>
            <div class="action"><slot name="action"></slot></div>
        `;
  }
  getCheckIcon() {
    return p`<svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 0 24 24" width="24px" style=" fill: var(--icon-color, var(--text-color));"><path d="M0 0h24v24H0z" fill="none"/><path d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z"/></svg>`;
  }
};
kt.styles = Fs;
$r([
  l()
], kt.prototype, "icon", 2);
$r([
  l()
], kt.prototype, "title", 2);
kt = $r([
  P("druide-list-item")
], kt);
const As = I`
:host {
    margin: 0.25rem; 
    margin-bottom:1rem;
    display:block;
}
.input-error-popover {
    display:none;
    color: var(--error-text-color);
    background-color: var(--error-background-color);
    box-shadow: 0 2px 2px 0 rgba(0, 0, 0, 0.14), 0 3px 1px -2px rgba(0, 0, 0, 0.12), 0 1px 5px 0 rgba(0, 0, 0, 0.2);
    overflow: hidden;
    font-size: 0.8em;
    border-radius: 0.25rem;
    padding: 0.25rem 0.75rem;
    word-wrap: break-word;
}

.container {
    height: 100%;
    /* border: 1px solid #aaaaaa; */
    border-radius: 4px;
    padding: 0;
    position: relative;
    background-color:var(--background-color);
}

.container .list {
    display: flex;
    flex-direction: column;
    overflow-y: auto;
    height: 100%;
}

.container.error {
    box-shadow: 0 0 1pt 2pt var(--error-border-color);
    -webkit-appearance: none; // This ensures that ios safari will show the box-shadow
}

.container:focus {
    border-color: #8e258d;
    outline: none;
}

.label {
    font-size: 0.8em;
    padding: 0 0.25rem;
    position: absolute;
    top: -0.8em;
    left: 0.5rem;
    background: var(--background-color);
    border-radius: var(--druide-input-radius, 4px);
}
.required > .label::after {
    content: "*";
}

::slotted(:not([disabled])) {
    cursor: pointer;
}

::slotted(.focused) {
    background-color: var(--background-color-hover);
}

::slotted(.selected) {
    background-color: var(--selected-background-color);
    color: var(--selected-text-color);
    border-color: var(--selected-text-color);
}

::slotted(.selected.focused),
::slotted(.selected:hover) {
    opacity: 0.8;
}
::slotted([disabled]) {
    opacity: 0.7;
}

::slotted(*) {
    border-top: 1px solid var(--input-disabled-color);
}
::slotted(*:first-child) {
    border-top: 0;
}
::slotted(druide-menu-separator + *) {
    border-top: 0;
}
::slotted(druide-menu-separator),
::slotted(druide-menu-separator:hover) {
    cursor: default;
    background-color:unset;
}
`;
var Hs = Object.defineProperty, js = Object.getOwnPropertyDescriptor, ye = (e, t, r, i) => {
  for (var n = i > 1 ? void 0 : i ? js(t, r) : t, o = e.length - 1, a; o >= 0; o--)
    (a = e[o]) && (n = (i ? a(t, r, n) : a(n)) || n);
  return i && n && Hs(t, r, n), n;
};
class G extends U {
  constructor() {
    super(...arguments), this.required = !1, this._value = [], this.label = "";
  }
  get value() {
    return this._value.join(",");
  }
  set value(t) {
    typeof t == "string" && (t = t.split(/, ?/)), t == null && (t = []), t instanceof Array && (this._value = t);
  }
  get error() {
    return this._error;
  }
  set error(t) {
    this._error !== t && (this._error = t, this.toggleError());
  }
  render() {
    return p`<div
      class="container ${this.error ? "error" : ""} ${this.required ? "required" : ""}"
      tabindex="1"
      @keydown=${this.handleKeyDown}
      @blur=${this.handleBlur}
      @focus=${this.handleFocus}
      @slotchange=${() => this.slotChange()}
    >
      <div class="label">${this.label}</div>
      <div class="list" @click=${this.handleClick}>
        <slot></slot>
      </div>
      <div id="error" class="input-error-popover">${this.error}</div>
    </div>`;
  }
  slotChange() {
    for (const t of this.entries)
      t.dataset.listInitEventsDone || (t.addEventListener("mouseenter", () => {
        this.resetFocused(), this.isSelectable(t) && t.classList.add("focused");
      }), t.addEventListener("mouseleave", () => t.classList.remove("focused")), t.dataset.listInitEventsDone = "done");
  }
  /**
   * Shows the error popover or hides it depending on the error state
   */
  toggleError() {
    if (this.errorPopover && this.errorPopover.isShown()) {
      this.error || (this.errorPopover.hide(), this.errorPopover = void 0);
      return;
    }
    this.error && Me(this) && (this.errorPopover = new Ie(this.list, this.errorDiv), this.errorPopover.addNotCloseElement(this), this.errorPopover.show());
  }
  firstUpdated() {
    this.entries.filter((t) => this._value.indexOf(t.id) != -1).forEach((t) => t.classList.add("selected"));
  }
  handleFocus() {
    this.toggleError();
  }
  resetFocused() {
    this.entries.forEach((t) => t.classList.remove("focused"));
  }
  handleBlur() {
    this.resetFocused();
  }
  getFocusedChild() {
    for (const t of this.entries)
      if (t.classList.contains("focused"))
        return t;
  }
  getSelectedIndex() {
    const t = this.entries.findIndex((r) => r.classList.contains("focused"));
    return t !== -1 ? t : this.entries.findIndex((r) => r.classList.contains("selected"));
  }
  switchFocus(t) {
    const r = this.getSelectedIndex(), i = r + t;
    if (i >= this.entries.length || i < 0)
      return;
    const n = this.entries[i];
    if (!this.isSelectable(n)) {
      this.switchFocus(t + (t > 0 ? 1 : -1));
      return;
    }
    this.entries[r] && this.entries[r].classList.remove("focused"), this.entries[i].classList.add("focused");
  }
  isSelectable(t) {
    return !t.disabled && !t.hasAttribute("disabled");
  }
  focusNext() {
    this.switchFocus(1);
  }
  focusPrevious() {
    this.switchFocus(-1);
  }
  handleKeyDown(t) {
    let r = !1;
    switch (t.key) {
      case "Down":
      case "ArrowDown":
        this.focusNext(), r = !0;
        break;
      case "Up":
      case "ArrowUp":
        this.focusPrevious(), r = !0;
        break;
      case "Enter":
        this.selectFocused(), r = !0;
        break;
    }
    r && (t.preventDefault(), t.stopPropagation());
  }
  selectFocused() {
    this.setSelected(this.getFocusedChild());
  }
  setSelected(t) {
    t && this.isSelectable(t) && (t.classList.toggle("selected"), this._value = this.entries.filter((r) => r.classList.contains("selected")).map((r) => r.id), this.dispatchEvent(new CustomEvent("change", { detail: this._value })));
  }
  handleClick(t) {
    if (t.target instanceof Node)
      for (const r of this.entries)
        r.contains(t.target) && (this.setSelected(r), this.focus());
  }
}
G.styles = As;
ye([
  l({ type: Boolean })
], G.prototype, "required", 2);
ye([
  V()
], G.prototype, "_value", 2);
ye([
  l({ type: String })
], G.prototype, "value", 1);
ye([
  V()
], G.prototype, "_error", 2);
ye([
  l({ type: String })
], G.prototype, "error", 1);
ye([
  l({ type: String })
], G.prototype, "label", 2);
ye([
  E(".list")
], G.prototype, "list", 2);
ye([
  vt(),
  E(".container")
], G.prototype, "container", 2);
ye([
  Ui(void 0, !0, "*")
], G.prototype, "entries", 2);
ye([
  E("#error")
], G.prototype, "errorDiv", 2);
var Rs = Object.defineProperty, zs = Object.getOwnPropertyDescriptor, Vs = (e, t, r, i) => {
  for (var n = i > 1 ? void 0 : i ? zs(t, r) : t, o = e.length - 1, a; o >= 0; o--)
    (a = e[o]) && (n = (i ? a(t, r, n) : a(n)) || n);
  return i && n && Rs(t, r, n), n;
};
let br = class extends G {
  setSelected(e) {
  }
};
br.styles = G.styles;
br = Vs([
  P("druide-list-menu")
], br);
var Qs = Object.defineProperty, Xs = Object.getOwnPropertyDescriptor, Gs = (e, t, r, i) => {
  for (var n = i > 1 ? void 0 : i ? Xs(t, r) : t, o = e.length - 1, a; o >= 0; o--)
    (a = e[o]) && (n = (i ? a(t, r, n) : a(n)) || n);
  return i && n && Qs(t, r, n), n;
};
let wr = class extends G {
};
wr.styles = G.styles;
wr = Gs([
  P("druide-list-multi-select")
], wr);
var Ks = Object.defineProperty, Zs = Object.getOwnPropertyDescriptor, Js = (e, t, r, i) => {
  for (var n = i > 1 ? void 0 : i ? Zs(t, r) : t, o = e.length - 1, a; o >= 0; o--)
    (a = e[o]) && (n = (i ? a(t, r, n) : a(n)) || n);
  return i && n && Ks(t, r, n), n;
};
let yr = class extends G {
  setSelected(e) {
    if (e)
      for (const t of this.entries)
        t !== e && t.classList.remove("selected");
    super.setSelected(e);
  }
};
yr.styles = G.styles;
yr = Js([
  P("druide-list-select")
], yr);
const el = I`
:host {
    display: flex;
    align-items: center;
    padding: 0.25em 1em;
    cursor:default !important;
    font-size: 12px;
    font-weight: 300;
    border-bottom: 1px solid var(--primary-color, #666);
}`;
var tl = Object.defineProperty, rl = Object.getOwnPropertyDescriptor, rr = (e, t, r, i) => {
  for (var n = i > 1 ? void 0 : i ? rl(t, r) : t, o = e.length - 1, a; o >= 0; o--)
    (a = e[o]) && (n = (i ? a(t, r, n) : a(n)) || n);
  return i && n && tl(t, r, n), n;
};
let dt = class extends U {
  constructor() {
    super(...arguments), this.disabled = !0, this.title = "";
  }
  render() {
    return p`
            <div class="title"><slot>${this.title}</slot></div>
        `;
  }
};
dt.styles = el;
rr([
  l()
], dt.prototype, "icon", 2);
rr([
  l({ type: Boolean })
], dt.prototype, "disabled", 2);
rr([
  l()
], dt.prototype, "title", 2);
dt = rr([
  P("druide-menu-header")
], dt);
const il = I`
:host {
    display: grid;
    align-items: center;
    padding: 0.25em 0.5em;
    gap: 0.5em;
    min-height:36px;
    grid-template-columns: min-content auto min-content;
    grid-template-areas: "icon title action";
    font-size: 14px;
}

druide-icon, .icon {
    grid-area: icon;
    padding: 0;
    align-self: center;
}

.icon:empty{
    display:none
}

.title {
    grid-area: title;
    align-self: center;
    font-weight: 500;
}
.action {
    grid-area: action; 
    align-self: center;
}
`;
var nl = Object.defineProperty, ol = Object.getOwnPropertyDescriptor, ir = (e, t, r, i) => {
  for (var n = i > 1 ? void 0 : i ? ol(t, r) : t, o = e.length - 1, a; o >= 0; o--)
    (a = e[o]) && (n = (i ? a(t, r, n) : a(n)) || n);
  return i && n && nl(t, r, n), n;
};
let pt = class extends U {
  constructor() {
    super(...arguments), this.title = "", this.disabled = !1;
  }
  render() {
    const e = p`<div class="icon"></div>`;
    return p`
            ${Z.createIfDefined(this.icon, e)}
            <div class="title"><slot>${this.title}</slot></div>
            <div class="action"><slot name="action"></slot></div>
        `;
  }
};
pt.styles = il;
ir([
  l()
], pt.prototype, "icon", 2);
ir([
  l()
], pt.prototype, "title", 2);
ir([
  l({ type: Boolean })
], pt.prototype, "disabled", 2);
pt = ir([
  P("druide-menu-item")
], pt);
const al = I`
.modal-overlay {
    display: flex;
    justify-content: center;
    align-items: center;
    position: fixed;
    z-index: 10;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    overflow: auto;
    background-color: rgba(0, 0, 0, 0.4);
    opacity: 1;
    visibility: visible;
    transition: visibility 0.25s linear, opacity 0.25s;
}
.modal-overlay.hidden {
    visibility: hidden;
    opacity: 0;
}

::slotted {
    max-width: 100%;
}
`;
var sl = Object.defineProperty, ll = Object.getOwnPropertyDescriptor, It = (e, t, r, i) => {
  for (var n = i > 1 ? void 0 : i ? ll(t, r) : t, o = e.length - 1, a; o >= 0; o--)
    (a = e[o]) && (n = (i ? a(t, r, n) : a(n)) || n);
  return i && n && sl(t, r, n), n;
};
let Xe = class extends U {
  constructor() {
    super(...arguments), this.visible = !1, this.closeExplicit = !1, this.closeClick = !1;
  }
  render() {
    return p`<div class="modal-overlay ${this.visible ? "" : "hidden"}" @click=${this.onClick} @cancel=${this.onCancel}>
            <slot></slot>
        </div>`;
  }
  onCancel() {
    this.hide();
  }
  onClick(e) {
    if (this.closeClick) {
      this.hide();
      return;
    }
    e.target === this.modalOverlay && !this.closeExplicit && this.hide();
  }
  hide() {
    this.modalOverlay.classList.add("hidden"), this.dispatchEvent(new CustomEvent("hide"));
  }
  show() {
    this.modalOverlay.classList.remove("hidden"), this.dispatchEvent(new CustomEvent("show"));
  }
};
Xe.styles = al;
It([
  l({ type: Boolean })
], Xe.prototype, "visible", 2);
It([
  l({ attribute: "close-explicit", type: Boolean })
], Xe.prototype, "closeExplicit", 2);
It([
  l({ attribute: "close-click", type: Boolean })
], Xe.prototype, "closeClick", 2);
It([
  E(".modal-overlay")
], Xe.prototype, "modalOverlay", 2);
Xe = It([
  P("druide-modal")
], Xe);
const cl = `:host{--text-color: black;--primary-color: purple;color:var(--text-color)}.progress_container{display:flex;overflow-x:auto;overflow-y:hidden}.step-container{display:grid;width:100%;grid-template-columns:auto max-content auto;cursor:pointer}.bar-container{display:flex;align-items:center;min-width:5px}.progress-bar-inner{display:flex;flex-direction:row;width:100%;height:2.5em;align-items:center}.step-container.clickable:hover .circle{height:2.5em;width:2.5em}.step-container.clickable:hover .label{font-size:1.3em}.circle{position:relative;display:flex;align-items:center;justify-content:center;height:2em;width:2em;border-radius:50%;box-sizing:border-box;background-color:#fff;border:4px solid var(--primary-color);transition:all .1s linear}.circle.active{height:2.5em;width:2.5em}.circle>*{height:100%;width:100%;border-radius:50%}.circle>svg{background-color:var(--primary-color);fill:#fff}.circle>.active{background-color:var(--primary-color);height:70%;width:70%;border-radius:50%}.bar{height:4px;flex-grow:1;background-color:var(--primary-color)}.step-container:first-child .bar.start{background-color:#fff}.step-container:last-child .bar.end{background-color:#fff}.label{display:flex;align-items:center;margin-top:10px;height:1.5rem;transition:all .1s linear}.label.active{font-size:1.3em;font-weight:500}
`;
var ul = Object.defineProperty, dl = Object.getOwnPropertyDescriptor, nr = (e, t, r, i) => {
  for (var n = i > 1 ? void 0 : i ? dl(t, r) : t, o = e.length - 1, a; o >= 0; o--)
    (a = e[o]) && (n = (i ? a(t, r, n) : a(n)) || n);
  return i && n && ul(t, r, n), n;
};
let ht = class extends U {
  constructor() {
    super(...arguments), this.steps = [], this.value = 1;
  }
  firstUpdated() {
    this.activeLabel.scrollIntoView();
  }
  render() {
    return p`
            <div class="progress_container">
                ${this.steps.map((e) => this.renderStep(e))}
            </div>
        `;
  }
  renderStep(e) {
    return p`
            <div class="step-container ${e.callback ? "clickable" : ""}">
                <div class="bar-container start">
                    <div class="bar start"></div>
                </div>
                <div class="progress-bar-inner ${e.callback ? "clickable" : ""}" @click=${() => this.onStepClicked(e)}>
                    <div class="bar start"></div>
                    <div class="circle ${e.id == this.value ? "active" : ""}">
                        ${this.renderStepStatus(e)}
                    </div>
                    <div class="bar end"></div>
                </div>
                <div class="bar-container end">
                    <div class="bar end"></div>
                </div>
                <div class="label-spacing start"></div>
                <div class="label ${e.id == this.value ? "active" : ""}">${e.text}</div>
                <div class="label-spacing end"></div>
            </div>
        `;
  }
  renderStepStatus(e) {
    return this.value == e.id ? p`<div class="active"></div>` : this.value > e.id ? p`<svg xmlns="http://www.w3.org/2000/svg" height="48" viewBox="0 -960 960 960" width="48"><path d="M378-246 154-470l43-43 181 181 384-384 43 43-427 427Z"/></svg>` : "";
  }
  onStepClicked(e) {
    e.callback && e.callback(e.id);
  }
  addStepCallback(e, t) {
    const r = this.steps.find((i) => i.id == e);
    r && (r.callback = t, this.requestUpdate());
  }
};
ht.styles = [_e(cl)];
nr([
  l({ attribute: !1 })
], ht.prototype, "steps", 2);
nr([
  l({ type: Number })
], ht.prototype, "value", 2);
nr([
  E(".label.active")
], ht.prototype, "activeLabel", 2);
ht = nr([
  P("druide-progress-bar")
], ht);
const pl = I`

select[multiple] {
    height: fit-content;
}

.input-error-popover {
    display:none;
    color: var(--error-text-color);
    background-color: var(--error-background-color);
    box-shadow: 0 2px 2px 0 rgba(0, 0, 0, 0.14), 0 3px 1px -2px rgba(0, 0, 0, 0.12), 0 1px 5px 0 rgba(0, 0, 0, 0.2);
    overflow: hidden;
    font-size: 0.8em;
    border-radius: 0.25rem;
    padding: 0.25rem 0.75rem;
    word-wrap: break-word;
}
`;
var hl = Object.defineProperty, fl = Object.getOwnPropertyDescriptor, X = (e, t, r, i) => {
  for (var n = i > 1 ? void 0 : i ? fl(t, r) : t, o = e.length - 1, a; o >= 0; o--)
    (a = e[o]) && (n = (i ? a(t, r, n) : a(n)) || n);
  return i && n && hl(t, r, n), n;
};
class $l {
  constructor(t, r) {
    this.id = t, this.title = r;
  }
}
let j = class extends U {
  constructor() {
    super(...arguments), this.label = "", this.required = !1, this._value = "", this.autofocus = !1, this.disabled = !1, this.options = [], this.showEmptyOption = !0, this.emptyOptionTitle = "", this.multiple = !1;
  }
  get error() {
    return this._error;
  }
  set error(e) {
    this._error !== e && (this._error = e, this.toggleError());
  }
  set value(e) {
    e != "" && (this._value = e);
  }
  get value() {
    return this._value;
  }
  render() {
    return p`
            <div class="input-container ${this.error ? "error" : ""} ${this.required ? "required" : ""}">
                <select
                    id="select-field"
                    .disabled=${this.disabled}
                    .multiple=${this.multiple}
                    @change=${this.onInput}
                    @focus=${this.onFocusInternal}
                    @blur=${this.onBlurInternal} >
                    ${this.showEmptyOption ? p`<option value="" disabled .selected=${this.value.length === 0}>${this.emptyOptionTitle}</option>` : ""}
                    ${this.options.map((e) => this.renderOption(e))}
                </select>
                <label class="label ${this.isLabelActive() ? "active" : ""}" for="select-field">${this.label}</label>
                <div id="error" class="input-error-popover">${this.error}</div>
            </div>
        `;
  }
  renderOption(e) {
    return p`<option value="${e.id}" .selected=${this._value.indexOf(e.id) !== -1}>${e.title}</option>`;
  }
  firstUpdated() {
    this.autofocus && this.input.focus();
  }
  /**
   * Shows the error popover or hides it depending on the error state
   */
  toggleError() {
    if (this.errorPopover && this.errorPopover.isShown()) {
      this.error || (this.errorPopover.hide(), this.errorPopover = void 0);
      return;
    }
    this.error && Me(this) && (this.errorPopover = new Ie(this.container, this.errorDiv), this.errorPopover.addNotCloseElement(this), this.errorPopover.show());
  }
  onFocusInternal(e) {
    this.toggleError(), this.setLabelActive(), this.onFocus(e);
  }
  setLabelActive() {
    this.labelField.classList.add("active");
  }
  isLabelActive() {
    return !(this.value == "" && !this.showEmptyOption && !Me(this));
  }
  onBlurInternal(e) {
    this.onInputBlur(e), this.isLabelActive() || this.labelField.classList.remove("active");
  }
  onInput() {
    const e = [];
    this.optionElements.forEach((t) => {
      t.selected && e.push(t.value);
    }), this.value = e.length == 1 ? e[0] : e, this.dispatchEvent(new CustomEvent("change", { detail: { value: this.value } }));
  }
  onFocus(e) {
  }
  onInputBlur(e) {
  }
  setCustomValidity(e) {
    this.error = e;
  }
  reportValidity() {
    return this.error != null;
  }
};
j.styles = [Pi, pl, I``];
X([
  l({ type: String })
], j.prototype, "label", 2);
X([
  l({ type: Boolean })
], j.prototype, "required", 2);
X([
  V()
], j.prototype, "_error", 2);
X([
  l({ type: String })
], j.prototype, "error", 1);
X([
  V()
], j.prototype, "_value", 2);
X([
  l()
], j.prototype, "value", 1);
X([
  l({ type: Boolean })
], j.prototype, "autofocus", 2);
X([
  l({ type: Boolean })
], j.prototype, "disabled", 2);
X([
  l({ type: Array })
], j.prototype, "options", 2);
X([
  l({ type: Boolean })
], j.prototype, "showEmptyOption", 2);
X([
  l()
], j.prototype, "emptyOptionTitle", 2);
X([
  l({ type: Boolean })
], j.prototype, "multiple", 2);
X([
  vt(),
  E("#select-field")
], j.prototype, "input", 2);
X([
  E("#error")
], j.prototype, "errorDiv", 2);
X([
  E(".input-container")
], j.prototype, "container", 2);
X([
  E("label")
], j.prototype, "labelField", 2);
X([
  si("option")
], j.prototype, "optionElements", 2);
j = X([
  P("druide-select-field")
], j);
const vl = I`
:host {
    display: inline-block;
    padding: 0.25rem;
    padding-top: 0.5rem;
    padding-bottom: 0.5rem;
}

.input-container {
    position: relative;
    height: 100%;
}

.label {
    font-size: 0.8em;
    padding: 0 0.25rem;
    position: absolute;
    top: -0.8em;
    left: 0.5rem;
    background: var(--background-color);
    border-radius: var(--druide-input-radius, 4px);
}
.required > .label::after {
    content: "*";
}

.error > #base-input-field {
    box-shadow: 0 0 1pt 2pt var(--error-border-color);
    -webkit-appearance: none; /* This ensures that ios safari will show the box-shadow */
}
#base-input-field {
    font-family: inherit;
    font-size: inherit;
    color: var(--text-color);
    border: 1px solid var(--input-border-color);
    border-radius: var(--druide-input-radius, 4px);
    width: 100%;
    box-sizing: border-box;
    height: 100%;

    padding: 0.25rem 0.75rem;
}
#base-input-field:disabled {
    background-color: var(--input-disabled-color);
}

#base-input-field:focus {
    border-color: var(--primary-color);
    outline: none;
}

#base-input-field:read-only {
    background-color: var(--input-disabled-color);
}

.suggest > #base-input-field {
    border-radius: 0.5rem 0.5rem 0 0;
}

.input-error-popover {
    display:none;
    color: var(--error-text-color);
    background-color: var(--error-background-color);
    box-shadow: 0 2px 2px 0 rgba(0, 0, 0, 0.14), 0 3px 1px -2px rgba(0, 0, 0, 0.12), 0 1px 5px 0 rgba(0, 0, 0, 0.2);
    overflow: hidden;
    font-size: 0.8em;
    border-radius: 0.25rem;
    padding: 0.25rem 0.75rem;
    word-wrap: break-word;
}
`;
var gl = Object.defineProperty, ml = Object.getOwnPropertyDescriptor, te = (e, t, r, i) => {
  for (var n = i > 1 ? void 0 : i ? ml(t, r) : t, o = e.length - 1, a; o >= 0; o--)
    (a = e[o]) && (n = (i ? a(t, r, n) : a(n)) || n);
  return i && n && gl(t, r, n), n;
};
let ee = class extends U {
  constructor() {
    super(...arguments), this.maxLength = 1024, this.placeholder = "", this.label = "", this.autofocus = !1, this.autocomplete = "", this.required = !1, this.value = "", this.disabled = !1, this.readonly = !1;
  }
  get error() {
    return this._error;
  }
  set error(e) {
    this._error !== e && (this._error = e, this.toggleError());
  }
  render() {
    return p`
            <div class="input-container ${this.getClassList()}">
                <span class="label">${this.label} </span>
                <textarea 
                    id="base-input-field" 
                    .maxLength=${this.maxLength}
                    .autocomplete=${this.autocomplete}
                    .placeholder=${this.placeholder}
                    .disabled=${this.disabled}
                    .readOnly=${this.readonly}
                    @input=${this.onInput}
                    @blur=${this.onInputBlur}
                    @keydown=${this.onKeyDownInternal}
                    @keyup=${this.onKeyUpInternal}
                    @paste=${this.onPaste}
                    @focus=${this.onFocusInternal}
                    >${this.value}</textarea>
                    <div id="error" class="input-error-popover">${this.error}</div>
            </div>
        `;
  }
  firstUpdated() {
    this.autofocus && this.input.focus();
  }
  getClassList() {
    let e = "";
    return e += this.error ? "error " : "", e += this.required ? "required " : "", e;
  }
  select() {
    this.input.select();
  }
  /**
   * Shows the error popover or hides it depending on the error state
   */
  toggleError() {
    if (this.errorPopover && this.errorPopover.isShown()) {
      this.error || (this.errorPopover.hide(), this.errorPopover = void 0);
      return;
    }
    this.error && Me(this) && (this.errorPopover = new Ie(this.input, this.errorDiv), this.errorPopover.addNotCloseElement(this), this.errorPopover.show());
  }
  /**
   * Hook method to distribute onInput to subclasses.
   * @param e Event
   */
  onInput() {
    this.inputTimer && (window.clearTimeout(this.inputTimer), this.inputTimer = void 0), this.inputTimer = window.setTimeout(() => this.fireChangeEvent(), 400);
  }
  /**
   * Hook method to distribute onInputBlur to subclasses.
   * @param e Event
   */
  onInputBlur() {
    this.inputTimer && (window.clearTimeout(this.inputTimer), this.inputTimer = void 0), this.fireChangeEvent();
  }
  /**
   * Hook method to distribute onFocus to subclasses.
   * @param e Event
   */
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  onFocus(e) {
  }
  onKeyDownInternal(e) {
    return this.onKeyDown(e);
  }
  /**
   * Hook method to distribute onKeyDown to subclasses.
   * @param e Event
   */
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  onKeyDown(e) {
    return !0;
  }
  /**
   * Hook method to process the state before sending submit event.
   */
  onSubmitTriggered() {
    this.onInputBlur();
  }
  onKeyUpInternal(e) {
    return this.onKeyUp(e);
  }
  onKeyUp(e) {
    return !0;
  }
  /**
   * Hook method to distribute onPaste to subclasses.
   * @param e Event
   */
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  onPaste(e) {
    return !0;
  }
  onFocusInternal(e) {
    this.toggleError(), this.onFocus(e);
  }
  fireChangeEvent() {
    this.value !== this.input.value && (this.value = this.input.value, this.dispatchEvent(new Event("change")));
  }
};
ee.styles = [vl, I``];
te([
  l({ type: Number })
], ee.prototype, "maxLength", 2);
te([
  l({ type: String })
], ee.prototype, "placeholder", 2);
te([
  l({ type: String })
], ee.prototype, "label", 2);
te([
  l({ type: Boolean })
], ee.prototype, "autofocus", 2);
te([
  l({ type: String })
], ee.prototype, "autocomplete", 2);
te([
  l({ type: Boolean })
], ee.prototype, "required", 2);
te([
  V()
], ee.prototype, "_error", 2);
te([
  l()
], ee.prototype, "value", 2);
te([
  l({ type: String })
], ee.prototype, "error", 1);
te([
  l({ type: Boolean })
], ee.prototype, "disabled", 2);
te([
  l({ type: Boolean })
], ee.prototype, "readonly", 2);
te([
  vt(),
  E("#base-input-field")
], ee.prototype, "input", 2);
te([
  E("#error")
], ee.prototype, "errorDiv", 2);
ee = te([
  P("druide-text-area")
], ee);
const bl = `:host{width:fit-content;display:none}.container{display:flex;align-items:center;background-color:#a9a9a9;padding:10px;border-radius:5px}.container.check{background-color:green}.container.info{background-color:#00f}.container.warning{background-color:orange}.container.error{background-color:red}.container druide-icon{--icon-color: white;height:1.5em;width:1.5em}.text{color:#fff;padding:10px}.close-container{border-left:2px solid white}.close-container>druide-icon-button{--icon-btn-background-color: rgba(1, 1, 1, 0);--primary-color-hover: rgb(255, 255, 255, .2);--primary-text-color: white;--icon-color: white}
`;
var wl = Object.defineProperty, yl = Object.getOwnPropertyDescriptor, or = (e, t, r, i) => {
  for (var n = i > 1 ? void 0 : i ? yl(t, r) : t, o = e.length - 1, a; o >= 0; o--)
    (a = e[o]) && (n = (i ? a(t, r, n) : a(n)) || n);
  return i && n && wl(t, r, n), n;
};
const xl = Te`<svg xmlns="http://www.w3.org/2000/svg" height="48" viewBox="0 -960 960 960" width="48"><path d="m249-207-42-42 231-231-231-231 42-42 231 231 231-231 42 42-231 231 231 231-42 42-231-231-231 231Z"/></svg>`, Ol = Te`<svg xmlns="http://www.w3.org/2000/svg" height="48" viewBox="0 -960 960 960" width="48"><path d="m419-283 294-294-66-66-228 228-111-111-65 66 176 177Zm61.138 228Q392-55 314.513-88.084q-77.488-33.083-135.417-91.012T88.084-314.375Q55-391.724 55-479.862 55-569 88.084-646.487q33.083-77.488 90.855-134.969 57.772-57.482 135.195-91.013Q391.557-906 479.779-906q89.221 0 166.827 33.454 77.605 33.453 135.012 90.802 57.407 57.349 90.895 134.877Q906-569.34 906-480q0 88.276-33.531 165.747-33.531 77.471-91.013 135.278-57.481 57.808-134.831 90.891Q569.276-55 480.138-55ZM480-149q138 0 234.5-96.372T811-480q0-138-96.5-234.5t-235-96.5q-137.5 0-234 96.5t-96.5 235q0 137.5 96.372 234T480-149Zm0-331Z"/></svg>`, Dl = Te`<svg xmlns="http://www.w3.org/2000/svg" height="48" viewBox="0 -960 960 960" width="48"><path d="M442-269h82v-251h-82v251Zm38.07-310q20.43 0 34.18-13.513Q528-606.025 528-626q0-21.95-13.795-35.475Q500.41-675 480.018-675q-21.518 0-34.768 13.525T432-626.5q0 20.6 13.82 34.05Q459.64-579 480.07-579Zm.334 524q-88.872 0-166.125-33.084-77.254-33.083-135.183-91.012-57.929-57.929-91.012-135.119Q55-391.406 55-480.362q0-88.957 33.084-166.285 33.083-77.328 90.855-134.809 57.772-57.482 135.036-91.013Q391.238-906 480.279-906q89.04 0 166.486 33.454 77.446 33.453 134.853 90.802 57.407 57.349 90.895 134.877Q906-569.34 906-480.266q0 89.01-33.531 166.247-33.531 77.237-91.013 134.86-57.481 57.623-134.831 90.891Q569.276-55 480.404-55Zm.096-94q137.5 0 234-96.372T811-480.5q0-137.5-96.312-234Q618.375-811 479.5-811q-137.5 0-234 96.312Q149-618.375 149-479.5q0 137.5 96.372 234T480.5-149Zm-.5-331Z"/></svg>`, Cl = Te`<svg xmlns="http://www.w3.org/2000/svg" height="48" viewBox="0 -960 960 960" width="48"><path d="m18-107 462-799 462 799H18Zm145-84h634L480-739 163-191Zm321.175-48q13.4 0 23.613-10.388Q518-259.776 518-273.175q0-13.4-10.388-23.113Q497.224-306 483.825-306q-13.4 0-23.613 9.888Q450-286.224 450-272.825q0 13.4 10.388 23.613Q470.776-239 484.175-239ZM454-348h60v-216h-60v216Zm26-117Z"/></svg>`, _l = Te`<svg xmlns="http://www.w3.org/2000/svg" height="48" viewBox="0 -960 960 960" width="48"><path d="M480-264q19.375 0 32.688-13.312Q526-290.625 526-310q0-19-13.312-33-13.313-14-32.688-14t-32.688 14Q434-329 434-310t13.312 32.5Q460.625-264 480-264Zm-36-140h72v-298h-72v298ZM320-95 95-319.824V-641l224.824-225H641l225 224.824V-320L641.176-95H320Zm38.616-94H601l170-169.616V-601L601.384-771H359L189-601.384V-359l169.616 170ZM480-480Z"/></svg>`;
var Tl = /* @__PURE__ */ ((e) => (e.CHECK = "check", e.INFO = "info", e.WARNING = "warning", e.ERROR = "error", e))(Tl || {});
let ft = class extends U {
  constructor() {
    super(...arguments), this.text = "", this.showSeconds = 3;
  }
  render() {
    return p`
            <div class="container ${this.warningLevel ?? ""}">
                <slot name="icon">
                    ${this.renderWarningIcon()}
                </slot>
                <div class="text">${this.text}</div>
                <slot name="action"></slot>
                <div class="close-container">
                    <druide-icon-button .icon=${xl} @click=${this.hide}></druide-icon-button>
                </div>
            </div>`;
  }
  renderWarningIcon() {
    return this.warningLevel == "check" ? p`<druide-icon .svg=${Ol}></druide-icon>` : this.warningLevel == "info" ? p`<druide-icon .svg=${Dl}></druide-icon>` : this.warningLevel == "warning" ? p`<druide-icon .svg=${Cl}></druide-icon>` : this.warningLevel == "error" ? p`<druide-icon .svg=${_l}></druide-icon>` : void 0;
  }
  show() {
    this.dispatchEvent(new CustomEvent("show")), this.style.display = "block", setTimeout(this.hide.bind(this), this.showSeconds * 1e3);
  }
  hide() {
    this.dispatchEvent(new CustomEvent("hide")), this.style.display = "none";
  }
};
ft.styles = [_e(bl)];
or([
  l()
], ft.prototype, "text", 2);
or([
  l({ type: Number })
], ft.prototype, "showSeconds", 2);
or([
  l()
], ft.prototype, "warningLevel", 2);
ft = or([
  P("druide-toast")
], ft);
export {
  Ce as DruideAutocompleteField,
  xe as DruideButton,
  it as DruideCard,
  Re as DruideCardExpandable,
  Oe as DruideCheckbox,
  J as DruideChipField,
  be as DruideDateField,
  le as DruideDatePicker,
  Ve as DruideDropdown,
  Le as DruideDropdownMenu,
  _t as DruideExpandable,
  Ne as DruideHtmlEditor,
  Qe as DruideHtmlView,
  Pt as DruideIFrame,
  Z as DruideIcon,
  je as DruideIconButton,
  ut as DruideLayout,
  kt as DruideListItem,
  br as DruideListMenu,
  wr as DruideListMultiSelect,
  yr as DruideListSelect,
  dt as DruideMenuHeader,
  pt as DruideMenuItem,
  Xe as DruideModal,
  ct as DruideNumberField,
  ht as DruideProgressBar,
  j as DruideSelectField,
  me as DruideSuggestList,
  ee as DruideTextArea,
  Tt as DruideTextField,
  Vt as DruideTimeField,
  ft as DruideToast,
  $l as SelectOption,
  ki as SuggestOption,
  Tl as WarningLevel
};
